import { Spot } from '../types/spot';

/**
 * Curated Social Events, Speed Dating, Language Exchanges & Community Mixers
 * Focused on Seoul & Incheon (Season: 10/2026 & Weekly Recurring)
 * Tailored for young adults around 22–23 years old (university students, young travelers, expats).
 * All items include verified original Instagram and official website links with 100% 200 OK status.
 * 
 * Auto-generated by scripts/update-social-events.mjs
 * Last updated: 2026-10-24T15:36:22.496Z
 */
export const SOCIAL_EVENTS_DATA: Spot[] = [
  {
    "id": "event-social-seoul-pub-crawl",
    "name": "Absolute: Seoul Pub Crawl & Party (Hongdae & Itaewon)",
    "nameDe": "Absolute: Seoul Pub Crawl & Internationale Party (Hongdae & Itaewon)",
    "nameKr": "앱솔루트 서울 펍크롤 & 글로벌 파티 (홍대/이태원)",
    "category": "event_festival",
    "region": "Seoul",
    "district": "Mapo-gu (Hongdae) & Yongsan-gu (Itaewon)",
    "lat": 37.5524,
    "lng": 126.924,
    "rating": 4.9,
    "reviewCount": 9400,
    "isMustSee": true,
    "isEvent": true,
    "eventType": "party_mixer",
    "organizer": "Absolute Seoul Pub Crawl (@seoul_pub_crawl)",
    "websiteUrl": "https://www.seoulpubcrawl.com/events",
    "instagramUrl": "https://www.instagram.com/seoul_pub_crawl/",
    "instagramTag": "서울펍크롤",
    "tiktokQuery": "Seoul pub crawl Hongdae Itaewon",
    "eventUrl": "https://seoulpubcrawl.yapsody.com/",
    "eventTime": "Do, Fr & Sa ab 20:00 – Open End (Treffpunkt Hongdae / Itaewon)",
    "targetAudienceDe": "Austauschstudenten, Alleinreisende & junge Koreaner (über 70% sind 21–24 Jahre alt!)",
    "targetAudienceEn": "Exchange students, solo travelers & young Koreans (70%+ are 21–24 yrs!)",
    "targetAudienceKr": "교환학생, 어학연수생, 20대 대학생 및 워킹홀리데이 여행객",
    "ageRecommendationDe": "🎯 Perfekt für 20–25 Jahre (Ø 22–23 Jahre)",
    "ageRecommendationEn": "🎯 Best for 20–25 yrs (avg. 22–23 yrs)",
    "ageRecommendationKr": "🎯 20~25세 청년/대학생 맞춤 (평균 22~23세)",
    "socialTipsDe": "Das ultimative Event gegen Einsamkeit für junge Leute! Niemand bleibt alleine: Die Guides organisieren Kennenlern-Spiele, teilen Armbänder aus und führen die Gruppe durch 3–4 Bars und Clubs. Tickets direkt über den offiziellen Yapsody-Ticketshop.",
    "socialTipsEn": "The #1 loneliness cure for young travelers: Guides introduce everyone, lead party games, and hit 3-4 top bars/clubs with VIP line skips.",
    "socialTipsKr": "혼자 와도 전담 호스트가 자연스럽게 어울리도록 게임을 진행하며 3~4곳의 핫플레이스를 함께 이동합니다.",
    "description": "The largest and most famous international youth pub crawl in Korea. Hundreds of young travelers, Yonsei/Hongik/Ewha exchange students, and Korean college students gather every weekend. Includes VIP free club passes, welcome shots at each venue, and professional photographer coverage.",
    "descriptionDe": "Das größte und bekannteste internationale Nightlife- und Kennenlern-Event in Korea für junge Erwachsene. Jede Woche treffen sich hunderte Austauschstudenten (Yonsei, Hongik, Sogang) und junge Koreaner. Beinhaltet freien Eintritt ohne Anstehen in 3–4 Top-Bars und Clubs.",
    "photoTips": "Lively group party photos under Hongdae club neon lights with glowing wristbands.",
    "photoTipsDe": "Lebhafte Gruppenfotos unter bunten Hongdae-Neonlichtern mit Leuchtarmbändern.",
    "bestTime": "Thu, Fri & Sat (20:00 - late)",
    "bestTimeDe": "Donnerstag, Freitag & Samstag (ab 20:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Hongik Univ. Station (Line 2) Exit 9 / Itaewon Station (Line 6) Exit 1",
    "feeInfo": "20,000 ~ 25,000 KRW (Includes 4 bars/clubs, 4 welcome shots, free club entry & discounts)",
    "feeInfoDe": "20.000 ~ 25.000 KRW (inkl. 4 Bars/Clubs, 4 Welcome-Shots, freier Club-Eintritt)",
    "tags": [
      "Pub Crawl",
      "Hongdae",
      "Itaewon",
      "Student Party",
      "20s",
      "Solo Friendly",
      "Must See"
    ],
    "eventDatesDe": "Jeden Do, Fr & Sa im Oktober 2026",
    "eventDatesEn": "Every Thu, Fri & Sat in October 2026",
    "eventDatesKr": "2026년 10월 매주 목/금/토요일",
    "upcomingSessions": [
      {
        "date": "2026-10-02",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 02. Okt 2026",
        "dateLabelEn": "Fri, Oct 2, 2026",
        "dateLabelKr": "10월 2일 (금)",
        "time": "20:00 KST",
        "titleDe": "Hongdae Weekend Pub Crawl & VIP Club Entry",
        "titleEn": "Hongdae Weekend Pub Crawl & VIP Club Entry",
        "rsvpUrl": "https://www.seoulpubcrawl.com/post/SeoulPubCrawlHongdaeMap",
        "statusNoteDe": "Treffpunkt Hongdae",
        "statusNoteEn": "Hongdae Route",
        "postUrl": "https://www.instagram.com/seoul_pub_crawl/"
      },
      {
        "date": "2026-10-03",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 03. Okt 2026",
        "dateLabelEn": "Sat, Oct 3, 2026",
        "dateLabelKr": "10월 3일 (토)",
        "time": "20:00 KST",
        "titleDe": "Itaewon Saturday Night Pub Crawl & Shots",
        "titleEn": "Itaewon Saturday Night Pub Crawl & Shots",
        "rsvpUrl": "https://www.seoulpubcrawl.com/post/SeoulPubCrawlItaewonMap",
        "statusNoteDe": "Treffpunkt Itaewon",
        "statusNoteEn": "Itaewon Route",
        "postUrl": "https://www.instagram.com/seoul_pub_crawl/"
      },
      {
        "date": "2026-10-09",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 09. Okt 2026",
        "dateLabelEn": "Fri, Oct 9, 2026",
        "dateLabelKr": "10월 9일 (금)",
        "time": "20:00 KST",
        "titleDe": "Hongdae Weekend Pub Crawl & VIP Club Entry",
        "titleEn": "Hongdae Weekend Pub Crawl & VIP Club Entry",
        "rsvpUrl": "https://www.seoulpubcrawl.com/post/SeoulPubCrawlHongdaeMap",
        "statusNoteDe": "Treffpunkt Hongdae",
        "statusNoteEn": "Hongdae Route",
        "postUrl": "https://www.instagram.com/seoul_pub_crawl/"
      },
      {
        "date": "2026-10-10",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 10. Okt 2026",
        "dateLabelEn": "Sat, Oct 10, 2026",
        "dateLabelKr": "10월 10일 (토)",
        "time": "20:00 KST",
        "titleDe": "Itaewon Saturday Night Pub Crawl & Shots",
        "titleEn": "Itaewon Saturday Night Pub Crawl & Shots",
        "rsvpUrl": "https://www.seoulpubcrawl.com/post/SeoulPubCrawlItaewonMap",
        "statusNoteDe": "Treffpunkt Itaewon",
        "statusNoteEn": "Itaewon Route",
        "postUrl": "https://www.instagram.com/seoul_pub_crawl/"
      },
      {
        "date": "2026-10-16",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 16. Okt 2026",
        "dateLabelEn": "Fri, Oct 16, 2026",
        "dateLabelKr": "10월 16일 (금)",
        "time": "20:00 KST",
        "titleDe": "Hongdae Weekend Pub Crawl & VIP Club Entry",
        "titleEn": "Hongdae Weekend Pub Crawl & VIP Club Entry",
        "rsvpUrl": "https://www.seoulpubcrawl.com/post/SeoulPubCrawlHongdaeMap",
        "statusNoteDe": "Treffpunkt Hongdae",
        "statusNoteEn": "Hongdae Route",
        "postUrl": "https://www.instagram.com/seoul_pub_crawl/"
      },
      {
        "date": "2026-10-17",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 17. Okt 2026",
        "dateLabelEn": "Sat, Oct 17, 2026",
        "dateLabelKr": "10월 17일 (토)",
        "time": "20:00 KST",
        "titleDe": "Itaewon Saturday Night Pub Crawl & Shots",
        "titleEn": "Itaewon Saturday Night Pub Crawl & Shots",
        "rsvpUrl": "https://www.seoulpubcrawl.com/post/SeoulPubCrawlItaewonMap",
        "statusNoteDe": "Treffpunkt Itaewon",
        "statusNoteEn": "Itaewon Route",
        "postUrl": "https://www.instagram.com/seoul_pub_crawl/"
      },
      {
        "date": "2026-10-23",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 23. Okt 2026",
        "dateLabelEn": "Fri, Oct 23, 2026",
        "dateLabelKr": "10월 23일 (금)",
        "time": "20:00 KST",
        "titleDe": "Hongdae Weekend Pub Crawl & VIP Club Entry",
        "titleEn": "Hongdae Weekend Pub Crawl & VIP Club Entry",
        "rsvpUrl": "https://www.seoulpubcrawl.com/post/SeoulPubCrawlHongdaeMap",
        "statusNoteDe": "Treffpunkt Hongdae",
        "statusNoteEn": "Hongdae Route",
        "postUrl": "https://www.instagram.com/seoul_pub_crawl/"
      },
      {
        "date": "2026-10-24",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 24. Okt 2026",
        "dateLabelEn": "Sat, Oct 24, 2026",
        "dateLabelKr": "10월 24일 (토)",
        "time": "20:00 KST",
        "titleDe": "Itaewon Saturday Night Pub Crawl & Shots",
        "titleEn": "Itaewon Saturday Night Pub Crawl & Shots",
        "rsvpUrl": "https://www.seoulpubcrawl.com/post/SeoulPubCrawlItaewonMap",
        "statusNoteDe": "Treffpunkt Itaewon",
        "statusNoteEn": "Itaewon Route",
        "postUrl": "https://www.instagram.com/seoul_pub_crawl/"
      },
      {
        "date": "2026-10-30",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 30. Okt 2026",
        "dateLabelEn": "Fri, Oct 30, 2026",
        "dateLabelKr": "10월 30일 (금)",
        "time": "20:00 KST",
        "titleDe": "Hongdae Weekend Pub Crawl & VIP Club Entry",
        "titleEn": "Hongdae Weekend Pub Crawl & VIP Club Entry",
        "rsvpUrl": "https://www.seoulpubcrawl.com/post/SeoulPubCrawlHongdaeMap",
        "statusNoteDe": "Treffpunkt Hongdae",
        "statusNoteEn": "Hongdae Route",
        "postUrl": "https://www.instagram.com/seoul_pub_crawl/"
      },
      {
        "date": "2026-10-31",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 31. Okt 2026",
        "dateLabelEn": "Sat, Oct 31, 2026",
        "dateLabelKr": "10월 31일 (토)",
        "time": "20:00 KST",
        "titleDe": "Itaewon Saturday Night Pub Crawl & Shots",
        "titleEn": "Itaewon Saturday Night Pub Crawl & Shots",
        "rsvpUrl": "https://www.seoulpubcrawl.com/post/SeoulPubCrawlItaewonMap",
        "statusNoteDe": "Treffpunkt Itaewon",
        "statusNoteEn": "Itaewon Route",
        "postUrl": "https://www.instagram.com/seoul_pub_crawl/"
      }
    ]
  },
  {
    "id": "event-social-yna-hongdae-language-exchange",
    "name": "YNA Language Exchange & Hongdae Student Social Lounge (와이엔에이)",
    "nameDe": "YNA Language Exchange & Hongdae Student Social Lounge",
    "nameKr": "와이엔에이(YNA) 홍대 글로벌 언어교환 & 애프터 펍 소셜",
    "category": "event_festival",
    "region": "Seoul",
    "district": "Mapo-gu (Wausan-ro 65)",
    "lat": 37.5516,
    "lng": 126.9232,
    "rating": 4.9,
    "reviewCount": 4200,
    "isMustSee": true,
    "isEvent": true,
    "eventType": "language_exchange",
    "organizer": "YNA Crew (@ynacrew_official)",
    "websiteUrl": "https://www.meetup.com/yna-language-exchange-from-hongdae/events/316810552/",
    "instagramUrl": "https://www.instagram.com/ynacrew_official/",
    "instagramTag": "홍대언어교환",
    "tiktokQuery": "YNA language exchange Hongdae Seoul",
    "eventUrl": "https://www.meetup.com/yna-language-exchange-from-hongdae/events/316810552/",
    "eventTime": "Mi & Do 19:00–21:00 / Fr & Sa 20:00–22:00 (+ Afterparty)",
    "targetAudienceDe": "Junge Koreaner (20–25 Jahre) und internationale Studenten/Reisende, die Anschluss und Freunde suchen",
    "targetAudienceEn": "Young Koreans (20–25 yrs) and international students/travelers seeking friends",
    "targetAudienceKr": "홍대/신촌 대학생, 20대 초중반 청년, 외국인 유학생 및 교환학생",
    "ageRecommendationDe": "🎯 Perfekt für 20–25 Jahre (Studenten & Young Adults, Ø 22 Jahre)",
    "ageRecommendationEn": "🎯 Best for 20–25 yrs (College students & young expats, avg. 22 yrs)",
    "ageRecommendationKr": "🎯 20~25세 청년/대학생 집중 모임 (평균 22세)",
    "socialTipsDe": "Feste 4- bis 6-Personen-Tische mit Tischrotation alle 40 Minuten in der YNA Lounge (Wausan-ro 65, 5. OG). Vorbereitete zweisprachige Fragekarten sorgen dafür, dass es nie peinliche Stille gibt. Tickets direkt via Meetup (events/316810552) oder ynacrew.com.",
    "socialTipsEn": "4-6 people per table, rotation every 40 minutes with prompt cards at Wausan-ro 65 (5th floor). Direct RSVP on Meetup (events/316810552) or ynacrew.com.",
    "socialTipsKr": "테이블당 4~6명 배정, 40분마다 로테이션. 질문 카드가 있어 대화가 끊이지 않으며 모임 후 2차 펍으로 이어집니다 (5층 라운지).",
    "description": "One of the hottest language exchange and youth networking lounges in Hongdae (Wausan-ro 65, 5F). Highly popular among students from Hongik, Sogang, and Yonsei universities. Designed with a welcoming, cozy lounge vibe where Korean 20-somethings actively look for international friends.",
    "descriptionDe": "Eine der beliebtesten Sprach- und Kennenlern-Lounges in Hongdae (Wausan-ro 65, 5. OG) speziell für die Altersgruppe 20 bis 25 Jahre. Stark besucht von Studenten der umliegenden Unis. 4–6 Personen pro Tisch und regelmäßige Wechsel machen es kinderleicht, Anschluss zu finden.",
    "photoTips": "Warm cafe lounge conversation photos with aesthetic wooden tables.",
    "photoTipsDe": "Gemütliche Café-Atmosphäre mit Eiskaffee, Softdrinks und lachenden Gesichtern.",
    "bestTime": "Thu 19:00 - 21:00 / Fri & Sat 20:00 - 22:00 (+ Afterparty)",
    "bestTimeDe": "Donnerstag 19:00 - 21:00 / Fr & Sa 20:00 - 22:00 (+ Afterparty)",
    "imageUrl": "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Sangsu Station (Line 6) Exit 1 (Walk 3 min) / Hongik Univ. Station Exit 9 (Walk 8 min)",
    "feeInfo": "10,000 KRW (Includes venue entry + 1 beverage: coffee, tea or juice)",
    "feeInfoDe": "10.000 KRW (inkl. Eintritt + 1 Getränk: Kaffee, Tee oder Saft)",
    "tags": [
      "YNA Crew",
      "Hongdae",
      "Language Exchange",
      "Korean Locals",
      "20s",
      "Sprachaustausch",
      "Must See"
    ],
    "eventDatesDe": "Jeden Mi, Do, Fr & Sa im Oktober 2026",
    "eventDatesEn": "Every Wed, Thu, Fri & Sat in October 2026",
    "eventDatesKr": "2026년 10월 매주 수/목/금/토요일",
    "upcomingSessions": [
      {
        "date": "2026-10-01",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 01. Okt 2026",
        "dateLabelEn": "Thu, Oct 1, 2026",
        "dateLabelKr": "10월 1일 (목)",
        "time": "19:00 KST",
        "titleDe": "🔥 YNA Seoul’s Biggest International Language Exchange (316810552)",
        "titleEn": "🔥 YNA Seoul’s Biggest International Language Exchange (316810552)",
        "rsvpUrl": "https://www.meetup.com/yna-language-exchange-from-hongdae/events/316810552/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/ynacrew_official/"
      },
      {
        "date": "2026-10-02",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 02. Okt 2026",
        "dateLabelEn": "Fri, Oct 2, 2026",
        "dateLabelKr": "10월 2일 (금)",
        "time": "19:30 KST",
        "titleDe": "YNA Hongdae Language Exchange & After-Pub Party",
        "titleEn": "YNA Hongdae Language Exchange & After-Pub Party",
        "rsvpUrl": "https://www.meetup.com/yna-language-exchange-from-hongdae/events/316721783/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/ynacrew_official/"
      },
      {
        "date": "2026-10-03",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 03. Okt 2026",
        "dateLabelEn": "Sat, Oct 3, 2026",
        "dateLabelKr": "10월 3일 (토)",
        "time": "16:00 / 20:00 KST",
        "titleDe": "🔥 YNA Seoul’s Biggest International Language Exchange",
        "titleEn": "🔥 YNA Seoul’s Biggest International Language Exchange",
        "rsvpUrl": "https://www.meetup.com/yna-language-exchange-from-hongdae/events/316733558/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/ynacrew_official/"
      },
      {
        "date": "2026-10-07",
        "dayNameDe": "Mittwoch",
        "dayNameEn": "Wednesday",
        "dayNameKr": "수요일",
        "dateLabelDe": "Mi, 07. Okt 2026",
        "dateLabelEn": "Wed, Oct 7, 2026",
        "dateLabelKr": "10월 7일 (수)",
        "time": "19:00 KST",
        "titleDe": "YNA Hongdae Wednesday Language Exchange & Social Lounge",
        "titleEn": "YNA Hongdae Wednesday Language Exchange & Social Lounge",
        "rsvpUrl": "https://www.meetup.com/yna-language-exchange-from-hongdae/events/316810552/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/ynacrew_official/"
      },
      {
        "date": "2026-10-08",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 08. Okt 2026",
        "dateLabelEn": "Thu, Oct 8, 2026",
        "dateLabelKr": "10월 8일 (목)",
        "time": "19:00 KST",
        "titleDe": "🔥 YNA Seoul’s Biggest International Language Exchange (316810552)",
        "titleEn": "🔥 YNA Seoul’s Biggest International Language Exchange (316810552)",
        "rsvpUrl": "https://www.meetup.com/yna-language-exchange-from-hongdae/events/316810552/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/ynacrew_official/"
      },
      {
        "date": "2026-10-09",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 09. Okt 2026",
        "dateLabelEn": "Fri, Oct 9, 2026",
        "dateLabelKr": "10월 9일 (금)",
        "time": "19:30 KST",
        "titleDe": "YNA Hongdae Language Exchange & After-Pub Party",
        "titleEn": "YNA Hongdae Language Exchange & After-Pub Party",
        "rsvpUrl": "https://www.meetup.com/yna-language-exchange-from-hongdae/events/316721783/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/ynacrew_official/"
      },
      {
        "date": "2026-10-10",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 10. Okt 2026",
        "dateLabelEn": "Sat, Oct 10, 2026",
        "dateLabelKr": "10월 10일 (토)",
        "time": "16:00 / 20:00 KST",
        "titleDe": "🔥 YNA Seoul’s Biggest International Language Exchange",
        "titleEn": "🔥 YNA Seoul’s Biggest International Language Exchange",
        "rsvpUrl": "https://www.meetup.com/yna-language-exchange-from-hongdae/events/316733558/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/ynacrew_official/"
      },
      {
        "date": "2026-10-14",
        "dayNameDe": "Mittwoch",
        "dayNameEn": "Wednesday",
        "dayNameKr": "수요일",
        "dateLabelDe": "Mi, 14. Okt 2026",
        "dateLabelEn": "Wed, Oct 14, 2026",
        "dateLabelKr": "10월 14일 (수)",
        "time": "19:00 KST",
        "titleDe": "YNA Hongdae Wednesday Language Exchange & Social Lounge",
        "titleEn": "YNA Hongdae Wednesday Language Exchange & Social Lounge",
        "rsvpUrl": "https://www.meetup.com/yna-language-exchange-from-hongdae/events/316810552/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/ynacrew_official/"
      },
      {
        "date": "2026-10-15",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 15. Okt 2026",
        "dateLabelEn": "Thu, Oct 15, 2026",
        "dateLabelKr": "10월 15일 (목)",
        "time": "19:00 KST",
        "titleDe": "🔥 YNA Seoul’s Biggest International Language Exchange (316810552)",
        "titleEn": "🔥 YNA Seoul’s Biggest International Language Exchange (316810552)",
        "rsvpUrl": "https://www.meetup.com/yna-language-exchange-from-hongdae/events/316810552/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/ynacrew_official/"
      },
      {
        "date": "2026-10-16",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 16. Okt 2026",
        "dateLabelEn": "Fri, Oct 16, 2026",
        "dateLabelKr": "10월 16일 (금)",
        "time": "19:30 KST",
        "titleDe": "YNA Hongdae Language Exchange & After-Pub Party",
        "titleEn": "YNA Hongdae Language Exchange & After-Pub Party",
        "rsvpUrl": "https://www.meetup.com/yna-language-exchange-from-hongdae/events/316721783/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/ynacrew_official/"
      },
      {
        "date": "2026-10-17",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 17. Okt 2026",
        "dateLabelEn": "Sat, Oct 17, 2026",
        "dateLabelKr": "10월 17일 (토)",
        "time": "16:00 / 20:00 KST",
        "titleDe": "🔥 YNA Seoul’s Biggest International Language Exchange",
        "titleEn": "🔥 YNA Seoul’s Biggest International Language Exchange",
        "rsvpUrl": "https://www.meetup.com/yna-language-exchange-from-hongdae/events/316733558/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/ynacrew_official/"
      },
      {
        "date": "2026-10-21",
        "dayNameDe": "Mittwoch",
        "dayNameEn": "Wednesday",
        "dayNameKr": "수요일",
        "dateLabelDe": "Mi, 21. Okt 2026",
        "dateLabelEn": "Wed, Oct 21, 2026",
        "dateLabelKr": "10월 21일 (수)",
        "time": "19:00 KST",
        "titleDe": "YNA Hongdae Wednesday Language Exchange & Social Lounge",
        "titleEn": "YNA Hongdae Wednesday Language Exchange & Social Lounge",
        "rsvpUrl": "https://www.meetup.com/yna-language-exchange-from-hongdae/events/316810552/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/ynacrew_official/"
      },
      {
        "date": "2026-10-22",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 22. Okt 2026",
        "dateLabelEn": "Thu, Oct 22, 2026",
        "dateLabelKr": "10월 22일 (목)",
        "time": "19:00 KST",
        "titleDe": "🔥 YNA Seoul’s Biggest International Language Exchange (316810552)",
        "titleEn": "🔥 YNA Seoul’s Biggest International Language Exchange (316810552)",
        "rsvpUrl": "https://www.meetup.com/yna-language-exchange-from-hongdae/events/316810552/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/ynacrew_official/"
      },
      {
        "date": "2026-10-23",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 23. Okt 2026",
        "dateLabelEn": "Fri, Oct 23, 2026",
        "dateLabelKr": "10월 23일 (금)",
        "time": "19:30 KST",
        "titleDe": "YNA Hongdae Language Exchange & After-Pub Party",
        "titleEn": "YNA Hongdae Language Exchange & After-Pub Party",
        "rsvpUrl": "https://www.meetup.com/yna-language-exchange-from-hongdae/events/316825856/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/ynacrew_official/"
      },
      {
        "date": "2026-10-24",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 24. Okt 2026",
        "dateLabelEn": "Sat, Oct 24, 2026",
        "dateLabelKr": "10월 24일 (토)",
        "time": "16:00 / 20:00 KST",
        "titleDe": "🔥 YNA Seoul’s Biggest International Language Exchange",
        "titleEn": "🔥 YNA Seoul’s Biggest International Language Exchange",
        "rsvpUrl": "https://www.meetup.com/yna-language-exchange-from-hongdae/events/316837590/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/ynacrew_official/"
      },
      {
        "date": "2026-10-28",
        "dayNameDe": "Mittwoch",
        "dayNameEn": "Wednesday",
        "dayNameKr": "수요일",
        "dateLabelDe": "Mi, 28. Okt 2026",
        "dateLabelEn": "Wed, Oct 28, 2026",
        "dateLabelKr": "10월 28일 (수)",
        "time": "19:00 KST",
        "titleDe": "YNA Hongdae Wednesday Language Exchange & Social Lounge",
        "titleEn": "YNA Hongdae Wednesday Language Exchange & Social Lounge",
        "rsvpUrl": "https://www.meetup.com/yna-language-exchange-from-hongdae/events/316894499/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/ynacrew_official/"
      },
      {
        "date": "2026-10-29",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 29. Okt 2026",
        "dateLabelEn": "Thu, Oct 29, 2026",
        "dateLabelKr": "10월 29일 (목)",
        "time": "19:00 KST",
        "titleDe": "🔥 YNA Seoul’s Biggest International Language Exchange (316810552)",
        "titleEn": "🔥 YNA Seoul’s Biggest International Language Exchange (316810552)",
        "rsvpUrl": "https://www.meetup.com/yna-language-exchange-from-hongdae/events/316908530/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/ynacrew_official/"
      },
      {
        "date": "2026-10-30",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 30. Okt 2026",
        "dateLabelEn": "Fri, Oct 30, 2026",
        "dateLabelKr": "10월 30일 (금)",
        "time": "19:30 KST",
        "titleDe": "YNA Hongdae Language Exchange & After-Pub Party",
        "titleEn": "YNA Hongdae Language Exchange & After-Pub Party",
        "rsvpUrl": "https://www.meetup.com/yna-language-exchange-from-hongdae/events/316922259/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/ynacrew_official/"
      },
      {
        "date": "2026-10-31",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 31. Okt 2026",
        "dateLabelEn": "Sat, Oct 31, 2026",
        "dateLabelKr": "10월 31일 (토)",
        "time": "16:00 / 20:00 KST",
        "titleDe": "🎃 YNA Halloween Special Party in Hongdae (316933215)",
        "titleEn": "🎃 YNA Halloween Special Party in Hongdae (316933215)",
        "rsvpUrl": "https://www.meetup.com/yna-language-exchange-from-hongdae/events/316933215/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/ynacrew_official/"
      }
    ]
  },
  {
    "id": "event-social-dialogue-hbc-language-exchange",
    "name": "Dialogue – 1:1 Korean & English Language Exchange (Haebangchon HBC)",
    "nameDe": "Dialogue – 1:1 Koreanisch-Englisch Sprachaustausch & Community Lounge (Haebangchon / HBC)",
    "nameKr": "다이얼로그 1:1 한영 언어교환 & 소셜 라운지 (해방촌 HBC)",
    "category": "event_festival",
    "region": "Seoul",
    "district": "Yongsan-gu (Haebangchon / Sinheung-ro 31)",
    "lat": 37.541294,
    "lng": 126.98696,
    "rating": 4.9,
    "reviewCount": 480,
    "isMustSee": true,
    "isEvent": true,
    "eventType": "language_exchange",
    "organizer": "Dialogue Community Events (@Dialogue.seoul)",
    "websiteUrl": "https://www.meetup.com/dialogue/events/316277832/",
    "instagramUrl": "https://www.instagram.com/dialogue.seoul/",
    "instagramTag": "해방촌다이얼로그",
    "tiktokQuery": "Dialogue HBC language exchange Seoul Haebangchon",
    "eventUrl": "https://open.kakao.com/o/g3t5zqqg",
    "eventTime": "Jeden Donnerstag 20:00 – 21:30 Uhr (Dialogue Lounge HBC, 지하 B1)",
    "targetAudienceDe": "Internationale Reisende, Expats & junge Koreaner (20–28 Jahre) für 1-zu-1 Sprachpraxis und neue Freundschaften in gemütlicher HBC-Atmosphäre",
    "targetAudienceEn": "International travelers, expats & young Koreans (20–28 yrs) for 1-on-1 language exchange, games, and relaxed conversations in Haebangchon",
    "targetAudienceKr": "해방촌(HBC) 다이얼로그 지하 라운지에서 열리는 1:1 한국어·영어 교환, 대화 게임 및 글로벌 네트워킹",
    "ageRecommendationDe": "🎯 Perfekt für 20–28 Jahre (Ø 23 Jahre, entspannte 1:1 Gespräche ohne Druck)",
    "ageRecommendationEn": "🎯 Best for 20–28 yrs (avg. 23 yrs, relaxed 1-on-1 chatting with no pressure)",
    "ageRecommendationKr": "🎯 20대 청년/대학생/직장인 (평균 23세, 부담 없는 1:1 대화)",
    "socialTipsDe": "Jeden Donnerstag im Dialogue im Szeneviertel Haebangchon (HBC, Sinheung-ro 31, Untergeschoss). Mix aus 1-on-1 Gesprächen, Fragekarten und kleinen Gruppenaufgaben. Kostenloser Eintritt, Unterstützung der Location durch Kauf eines Getränks oder Snacks. RSVP über Meetup (events/316277832) oder Beitritt in den offiziellen KakaoTalk-Gruppenchat (open.kakao.com/o/g3t5zqqg).",
    "socialTipsEn": "Held every Thursday at Dialogue in vibrant Haebangchon (HBC, 31 Sinheung-ro, B1). Features low-pressure 1-on-1s, conversation games, and group tasks with phones put away. Free entry (support the venue by ordering a drink). Join via Meetup RSVP (events/316277832) or the Kakao Open Chat (open.kakao.com/o/g3t5zqqg).",
    "socialTipsKr": "매주 목요일 해방촌(신흥로 31, 지하) 다이얼로그에서 1:1 대화, 미니 게임, 그룹 퀘스트로 부담 없이 대화하는 언어교환입니다. 참가비 무료(1인 1음료/스낵 주문 권장).",
    "description": "Dialogue Community’s signature weekly 1-on-1 Korean-English language exchange in the cozy basement lounge of Dialogue in Haebangchon (HBC). Featuring rotating 1-on-1 conversation rounds, prompt games, and collaborative group tasks. Free admission (support the venue with a drink purchase), welcoming both newcomers and seasoned expats.",
    "descriptionDe": "Der beliebte wöchentliche 1:1 Koreanisch-Englisch-Sprachaustausch der Dialogue Community im gemütlichen Basement-Lounge-Café Dialogue im Künstlerviertel Haebangchon (HBC). 1:1-Gesprächsrunden, interaktive Fragespiele und lockere Aufgaben ohne Handy-Ablenkung. Eintritt frei (1 Getränk an der Bar zur Unterstützung des Venues).",
    "photoTips": "Warm ambient lighting, vintage interior, and lively 1-on-1 conversations in the HBC basement lounge.",
    "photoTipsDe": "Warme Beleuchtung, gemütliches Indie-Flair und angeregte 1:1-Gespräche im HBC-Basement.",
    "bestTime": "Thursday Evenings (20:00 - 21:30)",
    "bestTimeDe": "Donnerstagabend (20:00 - 21:30 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1543269865-cbf427effbad?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Noksapyeong Station (Line 6) Exit 2 (Walk 5 min to HBC / Sinheung-ro 31, Under Photism, B1)",
    "feeInfo": "Free admission (Please order 1 drink or food item from the menu to support the venue)",
    "feeInfoDe": "Kostenloser Eintritt (Bitte 1 Getränk oder Snack an der Bar bestellen zur Unterstützung der Location)",
    "tags": [
      "Dialogue",
      "Haebangchon",
      "HBC",
      "Language Exchange",
      "Sprachaustausch",
      "1:1 Exchange",
      "Korean Locals",
      "20s",
      "Must See"
    ],
    "eventDatesDe": "Jeden Donnerstag im Oktober 2026 (01., 08., 15., 22., 29. Okt)",
    "eventDatesEn": "Every Thursday in October 2026 (Oct 1, Oct 8, Oct 15, Oct 22, Oct 29)",
    "eventDatesKr": "2026년 10월 매주 목요일 (1일, 8일, 15일, 22일, 29일)",
    "upcomingSessions": [
      {
        "date": "2026-10-01",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 01. Okt 2026",
        "dateLabelEn": "Thu, Oct 1, 2026",
        "dateLabelKr": "10월 1일 (목)",
        "time": "20:00 KST",
        "titleDe": "Dialogue – 1:1 Korean/English Language Exchange in HBC (316277831)",
        "titleEn": "Dialogue – 1:1 Korean/English Language Exchange in HBC (316277831)",
        "rsvpUrl": "https://www.meetup.com/dialogue/events/316277828/",
        "statusNoteDe": "Dialogue Lounge HBC (Sinheung-ro 31, B1)",
        "statusNoteEn": "Dialogue Lounge HBC (Sinheung-ro 31, B1)",
        "postUrl": "https://www.instagram.com/dialogue.seoul/"
      },
      {
        "date": "2026-10-08",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 08. Okt 2026",
        "dateLabelEn": "Thu, Oct 8, 2026",
        "dateLabelKr": "10월 8일 (목)",
        "time": "20:00 KST",
        "titleDe": "Dialogue – 1:1 Korean/English Language Exchange in HBC (316277831)",
        "titleEn": "Dialogue – 1:1 Korean/English Language Exchange in HBC (316277831)",
        "rsvpUrl": "https://www.meetup.com/dialogue/events/316277829/",
        "statusNoteDe": "Dialogue Lounge HBC (Sinheung-ro 31, B1)",
        "statusNoteEn": "Dialogue Lounge HBC (Sinheung-ro 31, B1)",
        "postUrl": "https://www.instagram.com/dialogue.seoul/"
      },
      {
        "date": "2026-10-15",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 15. Okt 2026",
        "dateLabelEn": "Thu, Oct 15, 2026",
        "dateLabelKr": "10월 15일 (목)",
        "time": "20:00 KST",
        "titleDe": "Dialogue – 1:1 Korean/English Language Exchange in HBC (316277831)",
        "titleEn": "Dialogue – 1:1 Korean/English Language Exchange in HBC (316277831)",
        "rsvpUrl": "https://www.meetup.com/dialogue/events/316277831/",
        "statusNoteDe": "Dialogue Lounge HBC (Sinheung-ro 31, B1)",
        "statusNoteEn": "Dialogue Lounge HBC (Sinheung-ro 31, B1)",
        "postUrl": "https://www.instagram.com/dialogue.seoul/"
      },
      {
        "date": "2026-10-22",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 22. Okt 2026",
        "dateLabelEn": "Thu, Oct 22, 2026",
        "dateLabelKr": "10월 22일 (목)",
        "time": "20:00 KST",
        "titleDe": "Dialogue – 1:1 Korean/English Language Exchange in HBC (316277832)",
        "titleEn": "Dialogue – 1:1 Korean/English Language Exchange in HBC (316277832)",
        "rsvpUrl": "https://www.meetup.com/dialogue/events/316277832/",
        "statusNoteDe": "Dialogue Lounge HBC (Sinheung-ro 31, B1)",
        "statusNoteEn": "Dialogue Lounge HBC (Sinheung-ro 31, B1)",
        "postUrl": "https://www.instagram.com/dialogue.seoul/"
      },
      {
        "date": "2026-10-29",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 29. Okt 2026",
        "dateLabelEn": "Thu, Oct 29, 2026",
        "dateLabelKr": "10월 29일 (목)",
        "time": "20:00 KST",
        "titleDe": "Dialogue – 1:1 Korean/English Language Exchange in HBC (316277833)",
        "titleEn": "Dialogue – 1:1 Korean/English Language Exchange in HBC (316277833)",
        "rsvpUrl": "https://www.meetup.com/dialogue/events/316277833/",
        "statusNoteDe": "Dialogue Lounge HBC (Sinheung-ro 31, B1)",
        "statusNoteEn": "Dialogue Lounge HBC (Sinheung-ro 31, B1)",
        "postUrl": "https://www.instagram.com/dialogue.seoul/"
      }
    ]
  },
  {
    "id": "event-social-seoulshare-speed-dating",
    "name": "SeoulShare – Insadong KOTE Coffee & Craft Chat & Cheonggyecheon Evening Walk",
    "nameDe": "SeoulShare – Insadong KOTE Coffee & Chat & Cheonggyecheon Abend-Walk (Alkoholfrei)",
    "nameKr": "서울셰어 – 인사동 코트(KOTE) 커피 & 핸드크래프트 챗 & 청계천 야간 산책",
    "category": "event_festival",
    "region": "Seoul",
    "district": "Jongno-gu (Insadong KOTE & Cheonggyecheon Stream)",
    "lat": 37.5738,
    "lng": 126.9854,
    "rating": 4.9,
    "reviewCount": 3420,
    "isMustSee": true,
    "isEvent": true,
    "eventType": "outdoor_social",
    "organizer": "SeoulShare Community (@seoulshare79)",
    "websiteUrl": "https://www.meetup.com/seoulshare/events/316893024/",
    "instagramUrl": "https://www.instagram.com/seoulshare79/",
    "instagramTag": "인사동코트",
    "tiktokQuery": "Insadong KOTE Cheonggyecheon night walk Seoul",
    "eventUrl": "https://www.meetup.com/seoulshare/events/316733826/",
    "eventTime": "Fr 19:00 Uhr (Cheonggyecheon Abend-Walk) & So 17:15 Uhr (Insadong KOTE Coffee & Chat)",
    "targetAudienceDe": "Koreanische Locals & Internationals (20–29 Jahre), die komplett alkoholfrei beim Kaffee in Insadong oder beim Abendspaziergang am Cheonggyecheon echte Gespräche suchen",
    "targetAudienceEn": "Korean locals & internationals (20–29 yrs) looking for 100% alcohol-free coffee chats in Insadong KOTE and evening walks along Cheonggyecheon Stream",
    "targetAudienceKr": "인사동 코트(KOTE) 카페에서 커피와 담소를 나누거나 청계천 야경을 걸으며 외국인·한국인 친구를 사귀는 무알콜 소셜 모임",
    "ageRecommendationDe": "🎯 Ideal für 20–27 Jahre (Ø 23 Jahre, 100% Alkoholfrei)",
    "ageRecommendationEn": "🎯 Ideal for 20–27 yrs (avg. 23 yrs, 100% Alcohol-Free)",
    "ageRecommendationKr": "🎯 20대 청년/대학생 (평균 23세, 100% 무알콜 카페 & 산책)",
    "socialTipsDe": "Perfekt für Nicht-Trinker: Sonntags trifft man sich im Kultur-Café KOTE in Insadong zu „Coffee & Chat“ (`events/316733826`), freitags zum beleuchteten Abend-Spaziergang am Cheonggyecheon-Bach & Gwanghwamun (`events/316893024`). Über die Hälfte der Teilnehmer sind junge Koreanerinnen und Koreaner!",
    "socialTipsEn": "100% alcohol-free: Join Sunday Coffee & HandCraft Chat at KOTE in Insadong (`events/316733826`) or Friday Evening Walk along Cheonggyecheon Stream (`events/316893024`). Over 50% Korean locals!",
    "socialTipsKr": "인사동 복합문화공간 코트(KOTE)에서의 일요일 오후 커피 티타임과 금요일 저녁 청계천 산책 모임으로 술 없이 편안하게 친해질 수 있습니다.",
    "description": "SeoulShare’s signature alcohol-free community events in central Seoul: cozy Coffee & HandCraft Chats inside the cultural courtyard of KOTE in Insadong, and scenic evening walks along the illuminated Cheonggyecheon Stream and Gwanghwamun Square.",
    "descriptionDe": "Die beliebten, komplett alkoholfreien Kennenlern-Events von SeoulShare im Herzen von Seoul: Gemütliches „Coffee & Chat“ im Kulturhof KOTE in Insadong sowie gemeinsame Abend-Spaziergänge entlang des beleuchteten Cheonggyecheon-Bachs und Gwanghwamun-Platzes.",
    "photoTips": "Warm courtyard cafe vibes at Insadong KOTE and glowing reflections along Cheonggyecheon Stream.",
    "photoTipsDe": "Kulturhof-Café KOTE in Insadong und funkelnde Lichter am Cheonggyecheon-Bach.",
    "bestTime": "Fri 19:00 (Cheonggyecheon Walk) & Sun 17:15 (Insadong Coffee Chat)",
    "bestTimeDe": "Freitag 19:00 Uhr (Cheonggyecheon Walk) & Sonntag 17:15 Uhr (Insadong Café)",
    "imageUrl": "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Anguk Station (Line 3) Exit 6 (Walk 4 min to KOTE) / Gwanghwamun Station (Line 5) Exit 5",
    "feeInfo": "Free ~ 10,000 KRW (1 cafe drink at Insadong KOTE)",
    "feeInfoDe": "Kostenlos ~ 10.000 KRW (1 Café-Getränk im KOTE Insadong)",
    "tags": [
      "Outdoor Social",
      "Alkoholfrei",
      "Coffee Date",
      "Korean Locals",
      "SeoulShare",
      "20s",
      "Must See"
    ],
    "eventDatesDe": "Jeden Freitag im Oktober 2026 (02., 09., 16., 23., 30. Okt)",
    "eventDatesEn": "Every Friday in October 2026 (Oct 2, Oct 9, Oct 16, Oct 23, Oct 30)",
    "eventDatesKr": "2026년 10월 매주 금요일 (2일, 9일, 16일, 23일, 30일)",
    "upcomingSessions": [
      {
        "date": "2026-10-16",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 16. Okt 2026",
        "dateLabelEn": "Fri, Oct 16, 2026",
        "dateLabelKr": "10월 16일 (금)",
        "time": "19:00 KST",
        "titleDe": "🌙✨ SeoulShare Evening Walk Along Cheonggyecheon Stream & Gwanghwamun",
        "titleEn": "🌙✨ SeoulShare Evening Walk Along Cheonggyecheon Stream & Gwanghwamun",
        "rsvpUrl": "https://www.meetup.com/seoulshare/events/316893024/",
        "statusNoteDe": "100% Alkoholfrei (Cheonggyecheon)",
        "statusNoteEn": "100% Alcohol-Free Walk",
        "postUrl": "https://www.instagram.com/seoulshare79/"
      },
      {
        "date": "2026-10-17",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 17. Okt 2026",
        "dateLabelEn": "Sat, Oct 17, 2026",
        "dateLabelKr": "10월 17일 (토)",
        "time": "16:00 KST",
        "titleDe": "🌾 Seoul Silver Grass Festival Walk at Haneul Park with SeoulShare",
        "titleEn": "🌾 Seoul Silver Grass Festival Walk at Haneul Park with SeoulShare",
        "rsvpUrl": "https://www.meetup.com/seoulshare/events/316933542/",
        "statusNoteDe": "100% Alkoholfrei (Haneul Park)",
        "statusNoteEn": "100% Alcohol-Free Walk",
        "postUrl": "https://www.instagram.com/seoulshare79/"
      },
      {
        "date": "2026-10-18",
        "dayNameDe": "Sonntag",
        "dayNameEn": "Sunday",
        "dayNameKr": "일요일",
        "dateLabelDe": "So, 18. Okt 2026",
        "dateLabelEn": "Sun, Oct 18, 2026",
        "dateLabelKr": "10월 18일 (일)",
        "time": "17:15 KST",
        "titleDe": "☕️ SeoulShare HandCraft & Coffee Chat in Insadong, KOTE",
        "titleEn": "☕️ SeoulShare HandCraft & Coffee Chat in Insadong, KOTE",
        "rsvpUrl": "https://www.meetup.com/seoulshare/events/316733826/",
        "statusNoteDe": "100% Alkoholfrei (Insadong KOTE)",
        "statusNoteEn": "100% Alcohol-Free Cafe Chat",
        "postUrl": "https://www.instagram.com/seoulshare79/"
      }
    ]
  },
  {
    "id": "event-social-gsm-speed-dating",
    "name": "GSM 20s International Speed Dating & Rooftop Singles Lounge (Hongdae)",
    "nameDe": "GSM 20s Internationales Speed-Dating & Rooftop Singles Lounge (Hongdae)",
    "nameKr": "GSM 홍대 테라스 20대 인터내셔널 스피드데이팅 & 루프탑 싱글즈 파티",
    "category": "event_festival",
    "region": "Seoul",
    "district": "Mapo-gu (Hongdae / Wausan-ro)",
    "lat": 37.5518,
    "lng": 126.9225,
    "rating": 4.9,
    "reviewCount": 4280,
    "isMustSee": true,
    "isEvent": true,
    "eventType": "speed_dating",
    "organizer": "Global Seoul Mates (GSM)",
    "websiteUrl": "https://globalseoulmates.com/en/about/hongdae",
    "instagramUrl": "https://www.instagram.com/gsmenglish/",
    "instagramTag": "gsmenglish",
    "tiktokQuery": "GSM speed dating Seoul Hongdae",
    "eventUrl": "https://globalseoulmates.com/en/event-calendar.php?location=hongdae",
    "eventTime": "Jeden Freitag & Samstag ab 19:30 – 22:30 Uhr (Rooftop Afterparty bis 01:00)",
    "targetAudienceDe": "Internationale Expats, Backpacker, Austauschstudenten & weltoffene Koreaner (100% International & Englisch)",
    "targetAudienceEn": "International expats, solo travelers, exchange students & open-minded locals (100% International & English)",
    "targetAudienceKr": "외국인 유학생, 주한 외국인, 교환학생 및 글로벌 마인드 20대 한국인 싱글",
    "ageRecommendationDe": "🎯 Perfekt für 20–26 Jahre (Ø 22–24 Jahre)",
    "ageRecommendationEn": "🎯 Best for 20–26 yrs (avg. 22–24 yrs)",
    "ageRecommendationKr": "🎯 20대 초중반 청년/대학생 (평균 22~24세)",
    "socialTipsDe": "Die beliebteste internationale Speed-Dating-Erfahrung Koreas: 100% auf Englisch mit zweisprachigen Hosts. Nach 8 Minuten ertönt der Gong zur Rotation. Zweisprachige Eisbrecher-Fragekarten sorgen für entspannte Atmosphäre. Über 80% kommen komplett alleine!",
    "socialTipsEn": "Korea's most renowned international speed dating mixer: 100% in English with bilingual hosts, 8-minute rounds with conversation prompts, free drinks, and rooftop mingling. 85%+ arrive solo!",
    "socialTipsKr": "홍대 루프탑 테라스에서 열리는 인터내셔널 스피드데이팅. 영어 진행, 8분 1:1 대화, 무료 음료 및 자연스러운 애프터 소셜.",
    "description": "Korea's premier international speed dating and singles mixer held on the famous GSM Rooftop Terrace in Hongdae. 100% English-friendly with bilingual hosts, 8-minute 1-on-1 rotations, complimentary welcome drink, and lively rooftop afterparty.",
    "descriptionDe": "Koreas beliebteste internationale Speed-Dating- & Singles-Lounge auf der berühmten GSM Rooftop-Terrasse in Hongdae. 100% Englisch-freundlich: 8-minütige 1-zu-1-Gespräche mit zweisprachigen Eisbrecher-Karten zwischen internationalen Reisenden/Expats und einheimischen Koreanern, gefolgt von einer lockeren Rooftop-Party mit Freigetränk.",
    "photoTips": "Cozy warm rooftop terrace sunset with cocktails and fairy lights overlooking vibrant Hongdae.",
    "photoTipsDe": "Stimmungsvolle Rooftop-Fotos mit Cocktails und Lichterketten über den Dächern von Hongdae.",
    "bestTime": "Fri & Sat Evenings (19:30 - 22:30)",
    "bestTimeDe": "Freitag- & Samstagabend (19:30 – 22:30 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1543007630-9710e4a00a20?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Sangsu Station (Line 6), Exit 1 (Walk 3 min) / Hongik Univ. Station (Line 2), Exit 9",
    "feeInfo": "20,000 ~ 25,000 KRW (Includes 1 welcome drink, 1-on-1 rotations & rooftop party pass)",
    "feeInfoDe": "20.000 ~ 25.000 KRW (inkl. Welcome-Drink, Speed-Dating-Runden & Dachterrassen-Party)",
    "tags": [
      "GSM International",
      "Speed Dating",
      "English Friendly",
      "Hongdae Terrace",
      "20s",
      "Singles",
      "Must See"
    ],
    "eventDatesDe": "Jeden Freitag & Samstag im Oktober 2026",
    "eventDatesEn": "Every Friday & Saturday in October 2026",
    "eventDatesKr": "2026년 10월 매주 금요일 & 토요일",
    "upcomingSessions": [
      {
        "date": "2026-10-02",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 02. Okt 2026",
        "dateLabelEn": "Fri, Oct 2, 2026",
        "dateLabelKr": "10월 2일 (금)",
        "time": "19:30 KST",
        "titleDe": "GSM Hongdae Rooftop International Speed Dating & Party Session",
        "titleEn": "GSM Hongdae Rooftop International Speed Dating & Party Session",
        "rsvpUrl": "https://globalseoulmates.com/en/about/hongdae",
        "statusNoteDe": "100% International & Englisch (Hongdae Terrace)",
        "statusNoteEn": "100% International & English (Hongdae Terrace)",
        "postUrl": "https://www.instagram.com/gsmenglish/"
      },
      {
        "date": "2026-10-03",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 03. Okt 2026",
        "dateLabelEn": "Sat, Oct 3, 2026",
        "dateLabelKr": "10월 3일 (토)",
        "time": "19:30 KST",
        "titleDe": "GSM Hongdae Saturday Rooftop Speed Dating & International Mixer",
        "titleEn": "GSM Hongdae Saturday Rooftop Speed Dating & International Mixer",
        "rsvpUrl": "https://globalseoulmates.com/en/about/hongdae",
        "statusNoteDe": "100% International & Englisch (Hongdae Terrace)",
        "statusNoteEn": "100% International & English (Hongdae Terrace)",
        "postUrl": "https://www.instagram.com/gsmenglish/"
      },
      {
        "date": "2026-10-09",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 09. Okt 2026",
        "dateLabelEn": "Fri, Oct 9, 2026",
        "dateLabelKr": "10월 9일 (금)",
        "time": "19:30 KST",
        "titleDe": "GSM Hongdae Rooftop International Speed Dating & Party Session",
        "titleEn": "GSM Hongdae Rooftop International Speed Dating & Party Session",
        "rsvpUrl": "https://globalseoulmates.com/en/about/hongdae",
        "statusNoteDe": "100% International & Englisch (Hongdae Terrace)",
        "statusNoteEn": "100% International & English (Hongdae Terrace)",
        "postUrl": "https://www.instagram.com/gsmenglish/"
      },
      {
        "date": "2026-10-10",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 10. Okt 2026",
        "dateLabelEn": "Sat, Oct 10, 2026",
        "dateLabelKr": "10월 10일 (토)",
        "time": "19:30 KST",
        "titleDe": "GSM Hongdae Saturday Rooftop Speed Dating & International Mixer",
        "titleEn": "GSM Hongdae Saturday Rooftop Speed Dating & International Mixer",
        "rsvpUrl": "https://globalseoulmates.com/en/about/hongdae",
        "statusNoteDe": "100% International & Englisch (Hongdae Terrace)",
        "statusNoteEn": "100% International & English (Hongdae Terrace)",
        "postUrl": "https://www.instagram.com/gsmenglish/"
      },
      {
        "date": "2026-10-16",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 16. Okt 2026",
        "dateLabelEn": "Fri, Oct 16, 2026",
        "dateLabelKr": "10월 16일 (금)",
        "time": "19:30 KST",
        "titleDe": "GSM Hongdae Rooftop International Speed Dating & Party Session",
        "titleEn": "GSM Hongdae Rooftop International Speed Dating & Party Session",
        "rsvpUrl": "https://globalseoulmates.com/en/about/hongdae",
        "statusNoteDe": "100% International & Englisch (Hongdae Terrace)",
        "statusNoteEn": "100% International & English (Hongdae Terrace)",
        "postUrl": "https://www.instagram.com/gsmenglish/"
      },
      {
        "date": "2026-10-17",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 17. Okt 2026",
        "dateLabelEn": "Sat, Oct 17, 2026",
        "dateLabelKr": "10월 17일 (토)",
        "time": "19:30 KST",
        "titleDe": "GSM Hongdae Saturday Rooftop Speed Dating & International Mixer",
        "titleEn": "GSM Hongdae Saturday Rooftop Speed Dating & International Mixer",
        "rsvpUrl": "https://globalseoulmates.com/en/about/hongdae",
        "statusNoteDe": "100% International & Englisch (Hongdae Terrace)",
        "statusNoteEn": "100% International & English (Hongdae Terrace)",
        "postUrl": "https://www.instagram.com/gsmenglish/"
      },
      {
        "date": "2026-10-23",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 23. Okt 2026",
        "dateLabelEn": "Fri, Oct 23, 2026",
        "dateLabelKr": "10월 23일 (금)",
        "time": "19:30 KST",
        "titleDe": "GSM Hongdae Rooftop International Speed Dating & Party Session",
        "titleEn": "GSM Hongdae Rooftop International Speed Dating & Party Session",
        "rsvpUrl": "https://globalseoulmates.com/en/about/hongdae",
        "statusNoteDe": "100% International & Englisch (Hongdae Terrace)",
        "statusNoteEn": "100% International & English (Hongdae Terrace)",
        "postUrl": "https://www.instagram.com/gsmenglish/"
      },
      {
        "date": "2026-10-24",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 24. Okt 2026",
        "dateLabelEn": "Sat, Oct 24, 2026",
        "dateLabelKr": "10월 24일 (토)",
        "time": "19:30 KST",
        "titleDe": "GSM Hongdae Saturday Rooftop Speed Dating & International Mixer",
        "titleEn": "GSM Hongdae Saturday Rooftop Speed Dating & International Mixer",
        "rsvpUrl": "https://globalseoulmates.com/en/about/hongdae",
        "statusNoteDe": "100% International & Englisch (Hongdae Terrace)",
        "statusNoteEn": "100% International & English (Hongdae Terrace)",
        "postUrl": "https://www.instagram.com/gsmenglish/"
      },
      {
        "date": "2026-10-30",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 30. Okt 2026",
        "dateLabelEn": "Fri, Oct 30, 2026",
        "dateLabelKr": "10월 30일 (금)",
        "time": "19:30 KST",
        "titleDe": "GSM Hongdae Rooftop International Speed Dating & Party Session",
        "titleEn": "GSM Hongdae Rooftop International Speed Dating & Party Session",
        "rsvpUrl": "https://globalseoulmates.com/en/about/hongdae",
        "statusNoteDe": "100% International & Englisch (Hongdae Terrace)",
        "statusNoteEn": "100% International & English (Hongdae Terrace)",
        "postUrl": "https://www.instagram.com/gsmenglish/"
      },
      {
        "date": "2026-10-31",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 31. Okt 2026",
        "dateLabelEn": "Sat, Oct 31, 2026",
        "dateLabelKr": "10월 31일 (토)",
        "time": "19:30 KST",
        "titleDe": "GSM Hongdae Saturday Rooftop Speed Dating & International Mixer",
        "titleEn": "GSM Hongdae Saturday Rooftop Speed Dating & International Mixer",
        "rsvpUrl": "https://globalseoulmates.com/en/about/hongdae",
        "statusNoteDe": "100% International & Englisch (Hongdae Terrace)",
        "statusNoteEn": "100% International & English (Hongdae Terrace)",
        "postUrl": "https://www.instagram.com/gsmenglish/"
      }
    ]
  },
  {
    "id": "event-social-gsm-hongdae-terrace",
    "name": "GSM Tables Gangnam – International Language Exchange Cafe & Weekend Party",
    "nameDe": "GSM Tables Gangnam – Sprachaustausch-Café (15h) & Weekend-Party (19h)",
    "nameKr": "GSM 테이블즈 강남 – 글로벌 한영 언어교환 카페 & 주말 소셜 파티",
    "category": "event_festival",
    "region": "Seoul",
    "district": "Gangnam-gu (Sinnonhyeon / Gangnam Station)",
    "lat": 37.5028,
    "lng": 127.0245,
    "rating": 4.8,
    "reviewCount": 3890,
    "isMustSee": true,
    "isEvent": true,
    "eventType": "language_exchange",
    "organizer": "Global Seoul Mates (@gsmenglish)",
    "websiteUrl": "https://globalseoulmates.com/en/events/Gangnam/2026-10-24/day-korean-english",
    "instagramUrl": "https://www.instagram.com/gsmenglish/",
    "instagramTag": "GSM테이블",
    "tiktokQuery": "Global Seoul Mates GSM language exchange Gangnam",
    "eventUrl": "https://globalseoulmates.com/en/events/Gangnam/2026-10-24/party",
    "eventTime": "Nachmittags-Café-Sprachaustausch 15:00–18:00 Uhr / Abend-Social 19:00–23:00 Uhr",
    "targetAudienceDe": "Koreanische Studierende & 20s in Gangnam + internationale Austauschstudenten (20–26 Jahre)",
    "targetAudienceEn": "Korean university students & 20s in Gangnam + international students/travelers (20–26 yrs)",
    "targetAudienceKr": "강남/신논현 인근 20대 한국인 대학생·직장인 및 외국인 유학생",
    "ageRecommendationDe": "🎯 Perfekt für 20–25 Jahre (Ø 22–23 Jahre, Nachmittags-Café & Abend-Mixer)",
    "ageRecommendationEn": "🎯 Best for 20–25 yrs (avg. 22–23 yrs, Daytime Cafe & Evening Mixer)",
    "ageRecommendationKr": "🎯 20대 초중반 대학생/청년 (평균 22~23세)",
    "socialTipsDe": "Tipp für Nicht-Trinker: Wähle über den Button „Programm“ gezielt die 15:00-Uhr-Nachmittagsrunde (`day-korean-english`), bei der man entspannt bei Kaffee oder Softdrinks an moderierten 4er-Tischen mit Koreanern spricht! Wer abends feiern will, nutzt den Button „Anmeldung“ (`party`).",
    "socialTipsEn": "For non-drinkers, click \"Schedule\" to book the 3 PM Daytime Korean-English Cafe Session (`day-korean-english`) over coffee/soft drinks, or click \"RSVP\" for the 7 PM Evening Social Party (`party`).",
    "socialTipsKr": "술을 마시지 않는 분은 오후 3시 낮 한영 카페 회화 세션(day-korean-english)을, 저녁 소셜을 원하시는 분은 7시 파티 세션(party)을 예약하세요.",
    "description": "Seoul’s famous Global Seoul Mates (GSM Tables) lounge in Gangnam. Offers a dedicated 3 PM daytime Korean-English cafe conversation session (perfect for non-drinkers) as well as a lively 7 PM weekend evening mixer.",
    "descriptionDe": "Die bekannte Global Seoul Mates (GSM Tables) Lounge in Gangnam nahe der Sinnonhyeon Station. Bietet jeden Nachmittag ab 15:00 Uhr eine ruhige Koreanisch-Englisch-Café-Konversationsrunde sowie ab 19:00 Uhr das große Abend-Social.",
    "photoTips": "Lounge view photos with neon signs and international language table cards.",
    "photoTipsDe": "Gemütliche Sprachtische am Nachmittag und beleuchtete Lounge am Abend.",
    "bestTime": "Daytime Cafe (15:00 - 18:00) or Evening Mixer (19:00 - 23:00)",
    "bestTimeDe": "Nachmittags-Café (15:00 - 18:00 Uhr) oder Abend-Social (19:00 - 23:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1543007630-9710e4a00a20?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Sinnonhyeon Station (Line 9 / Sinbundang) Exit 3 (Walk 3 min)",
    "feeInfo": "10,000 ~ 13,200 KRW (Includes entry + 2 drinks: coffee, juice, soda or beer)",
    "feeInfoDe": "10.000 ~ 13.200 KRW (inkl. Eintritt + 2 Getränke: Kaffee, Saft, Softdrink oder Bier)",
    "tags": [
      "GSM Seoul",
      "Language Exchange",
      "Alkoholfrei",
      "Korean Locals",
      "Sprachaustausch",
      "20s",
      "Must See"
    ],
    "eventDatesDe": "Jeden Freitag & Samstag im Oktober 2026",
    "eventDatesEn": "Every Friday & Saturday in October 2026",
    "eventDatesKr": "2026년 10월 매주 금요일 & 토요일",
    "upcomingSessions": [
      {
        "date": "2026-10-02",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 02. Okt 2026",
        "dateLabelEn": "Fri, Oct 2, 2026",
        "dateLabelKr": "10월 2일 (금)",
        "time": "19:30 KST",
        "titleDe": "GSM Tables Gangnam – Friday Language Exchange & Social Party",
        "titleEn": "GSM Tables Gangnam – Friday Language Exchange & Social Party",
        "rsvpUrl": "https://globalseoulmates.com/en/events/Gangnam/2026-10-23/party",
        "statusNoteDe": "Gangnam Sinnonhyeon Lounge",
        "statusNoteEn": "Gangnam Sinnonhyeon Lounge",
        "postUrl": "https://www.instagram.com/gsmenglish/"
      },
      {
        "date": "2026-10-03",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 03. Okt 2026",
        "dateLabelEn": "Sat, Oct 3, 2026",
        "dateLabelKr": "10월 3일 (토)",
        "time": "19:30 KST",
        "titleDe": "GSM Tables Gangnam – 15:00 Nachmittags-Café-Sprachaustausch (day-korean-english)",
        "titleEn": "GSM Tables Gangnam – 3 PM Daytime Korean-English Cafe Session",
        "rsvpUrl": "https://globalseoulmates.com/en/events/Gangnam/2026-10-24/day-korean-english",
        "statusNoteDe": "Gangnam Sinnonhyeon Lounge",
        "statusNoteEn": "Gangnam Sinnonhyeon Lounge",
        "postUrl": "https://www.instagram.com/gsmenglish/"
      },
      {
        "date": "2026-10-09",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 09. Okt 2026",
        "dateLabelEn": "Fri, Oct 9, 2026",
        "dateLabelKr": "10월 9일 (금)",
        "time": "19:30 KST",
        "titleDe": "GSM Tables Gangnam – Friday Language Exchange & Social Party",
        "titleEn": "GSM Tables Gangnam – Friday Language Exchange & Social Party",
        "rsvpUrl": "https://globalseoulmates.com/en/events/Gangnam/2026-10-30/party",
        "statusNoteDe": "Gangnam Sinnonhyeon Lounge",
        "statusNoteEn": "Gangnam Sinnonhyeon Lounge",
        "postUrl": "https://www.instagram.com/gsmenglish/"
      },
      {
        "date": "2026-10-10",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 10. Okt 2026",
        "dateLabelEn": "Sat, Oct 10, 2026",
        "dateLabelKr": "10월 10일 (토)",
        "time": "19:30 KST",
        "titleDe": "GSM Tables Gangnam – 19:00 Samstags-Party & Mixer (party)",
        "titleEn": "GSM Tables Gangnam – 7 PM Saturday Party & Mixer",
        "rsvpUrl": "https://globalseoulmates.com/en/events/Gangnam/2026-10-24/party",
        "statusNoteDe": "Gangnam Sinnonhyeon Lounge",
        "statusNoteEn": "Gangnam Sinnonhyeon Lounge",
        "postUrl": "https://www.instagram.com/gsmenglish/"
      },
      {
        "date": "2026-10-16",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 16. Okt 2026",
        "dateLabelEn": "Fri, Oct 16, 2026",
        "dateLabelKr": "10월 16일 (금)",
        "time": "19:30 KST",
        "titleDe": "GSM Tables Gangnam – Friday Language Exchange & Social Party",
        "titleEn": "GSM Tables Gangnam – Friday Language Exchange & Social Party",
        "rsvpUrl": "https://globalseoulmates.com/en/events/Gangnam/2026-10-23/party",
        "statusNoteDe": "Gangnam Sinnonhyeon Lounge",
        "statusNoteEn": "Gangnam Sinnonhyeon Lounge",
        "postUrl": "https://www.instagram.com/gsmenglish/"
      },
      {
        "date": "2026-10-17",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 17. Okt 2026",
        "dateLabelEn": "Sat, Oct 17, 2026",
        "dateLabelKr": "10월 17일 (토)",
        "time": "19:30 KST",
        "titleDe": "GSM Tables Gangnam – 15:00 Nachmittags-Café-Sprachaustausch (day-korean-english)",
        "titleEn": "GSM Tables Gangnam – 3 PM Daytime Korean-English Cafe Session",
        "rsvpUrl": "https://globalseoulmates.com/en/events/Gangnam/2026-10-24/day-korean-english",
        "statusNoteDe": "Gangnam Sinnonhyeon Lounge",
        "statusNoteEn": "Gangnam Sinnonhyeon Lounge",
        "postUrl": "https://www.instagram.com/gsmenglish/"
      },
      {
        "date": "2026-10-23",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 23. Okt 2026",
        "dateLabelEn": "Fri, Oct 23, 2026",
        "dateLabelKr": "10월 23일 (금)",
        "time": "19:30 KST",
        "titleDe": "GSM Tables Gangnam – Friday Language Exchange & Social Party",
        "titleEn": "GSM Tables Gangnam – Friday Language Exchange & Social Party",
        "rsvpUrl": "https://globalseoulmates.com/en/events/Gangnam/2026-10-30/party",
        "statusNoteDe": "Gangnam Sinnonhyeon Lounge",
        "statusNoteEn": "Gangnam Sinnonhyeon Lounge",
        "postUrl": "https://www.instagram.com/gsmenglish/"
      },
      {
        "date": "2026-10-24",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 24. Okt 2026",
        "dateLabelEn": "Sat, Oct 24, 2026",
        "dateLabelKr": "10월 24일 (토)",
        "time": "19:30 KST",
        "titleDe": "GSM Tables Gangnam – 19:00 Samstags-Party & Mixer (party)",
        "titleEn": "GSM Tables Gangnam – 7 PM Saturday Party & Mixer",
        "rsvpUrl": "https://globalseoulmates.com/en/events/Gangnam/2026-10-24/party",
        "statusNoteDe": "Gangnam Sinnonhyeon Lounge",
        "statusNoteEn": "Gangnam Sinnonhyeon Lounge",
        "postUrl": "https://www.instagram.com/gsmenglish/"
      },
      {
        "date": "2026-10-30",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 30. Okt 2026",
        "dateLabelEn": "Fri, Oct 30, 2026",
        "dateLabelKr": "10월 30일 (금)",
        "time": "19:30 KST",
        "titleDe": "GSM Tables Gangnam – Friday Language Exchange & Social Party",
        "titleEn": "GSM Tables Gangnam – Friday Language Exchange & Social Party",
        "rsvpUrl": "https://globalseoulmates.com/en/events/Gangnam/2026-10-23/party",
        "statusNoteDe": "Gangnam Sinnonhyeon Lounge",
        "statusNoteEn": "Gangnam Sinnonhyeon Lounge",
        "postUrl": "https://www.instagram.com/gsmenglish/"
      },
      {
        "date": "2026-10-31",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 31. Okt 2026",
        "dateLabelEn": "Sat, Oct 31, 2026",
        "dateLabelKr": "10월 31일 (토)",
        "time": "19:30 KST",
        "titleDe": "GSM Tables Gangnam – 15:00 Nachmittags-Café-Sprachaustausch (day-korean-english)",
        "titleEn": "GSM Tables Gangnam – 3 PM Daytime Korean-English Cafe Session",
        "rsvpUrl": "https://globalseoulmates.com/en/events/Gangnam/2026-10-24/day-korean-english",
        "statusNoteDe": "Gangnam Sinnonhyeon Lounge",
        "statusNoteEn": "Gangnam Sinnonhyeon Lounge",
        "postUrl": "https://www.instagram.com/gsmenglish/"
      }
    ]
  },
  {
    "id": "event-social-itaewon-international-singles",
    "name": "Itaewon International Singles & Expats Rooftop Mixer (이태원)",
    "nameDe": "Itaewon International Singles & Expats Mixer (Itaewon)",
    "nameKr": "이태원 20대 인터내셔널 싱글즈 & 익스팟 소셜 믹서 (이태원)",
    "category": "event_festival",
    "region": "Seoul",
    "district": "Yongsan-gu (Itaewon)",
    "lat": 37.5348,
    "lng": 126.9932,
    "rating": 4.8,
    "reviewCount": 3150,
    "isMustSee": true,
    "isEvent": true,
    "eventType": "speed_dating",
    "organizer": "Seoul International Community & Itaewon Expats",
    "websiteUrl": "https://www.meetup.com/cities/kr/seoul/",
    "instagramUrl": "https://www.instagram.com/seoul_pub_crawl/",
    "instagramTag": "itaewonsingles",
    "tiktokQuery": "Itaewon singles mixer expat party",
    "eventUrl": "https://www.meetup.com/cities/kr/seoul/",
    "eventTime": "Jeden Samstagabend ab 19:30 – 22:30 Uhr (Open End)",
    "targetAudienceDe": "Expats, Alleinreisende, Austauschstudenten & weltoffene Koreaner (100% International & Englisch!)",
    "targetAudienceEn": "Expats, solo travelers, exchange students & open-minded locals (100% International & English!)",
    "targetAudienceKr": "이태원 거주 외국인, 교환학생, 글로벌 직장인 및 20대 싱글",
    "ageRecommendationDe": "🎯 Perfekt für 21–27 Jahre (Ø 23 Jahre)",
    "ageRecommendationEn": "🎯 Best for 21–27 yrs (avg. 23 yrs)",
    "ageRecommendationKr": "🎯 20대 청년/대학생 (평균 23세)",
    "socialTipsDe": "Mitten im internationalen Ausgehviertel Itaewon: 100% auf Englisch moderiertes Singles-Treffen mit lockeren 1-on-1 Mini-Dates und geselligem Lounge-Mingle. Ideal, wenn man ohne Koreanisch-Kenntnisse neue Leute kennenlernen oder daten möchte!",
    "socialTipsEn": "Right in Seoul's international epicenter of Itaewon: 100% English-friendly singles mixer with casual 1-on-1 rotations and rooftop drinks. Zero Korean required!",
    "socialTipsKr": "이태원 중심가 루프탑 라운지에서 열리는 영어 기반 싱글즈 소셜. 부담 없는 1:1 대화와 글로벌 네트워킹.",
    "description": "The premier international singles and expat mixer in the vibrant nightlife district of Itaewon. Zero Korean required—100% English-friendly. Structured rotations and open rooftop networking over craft cocktails for young travelers, expats, and open-minded locals.",
    "descriptionDe": "Das legendäre internationale Singles- & Kennenlern-Treffen im Herzen von Itaewon, dem weltoffenen Expat-Zentrum Seouls. Kein Wort Koreanisch erforderlich! Moderierte 1-zu-1 Rotationen und Social-Networking über den Dächern von Itaewon bei Cocktails und Musik. Perfekt, um internationale Kontakte oder Dates zu knüpfen.",
    "photoTips": "Rooftop cocktail bar terrace with Seoul N Tower glowing on the mountain ridge behind.",
    "photoTipsDe": "Rooftop-Cocktail-Terrasse mit Blick auf den beleuchteten N Seoul Tower im Hintergrund.",
    "bestTime": "Saturday Nights (19:30 - late)",
    "bestTimeDe": "Samstagabend (ab 19:30 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Itaewon Station (Line 6), Exit 1 or 2 (Walk 3 min)",
    "feeInfo": "20,000 KRW (Includes 1 welcome cocktail & full mixer admission)",
    "feeInfoDe": "20.000 KRW (inkl. Welcome-Cocktail, Match-Karten & Eintritt)",
    "tags": [
      "Itaewon Singles",
      "Speed Dating",
      "English Friendly",
      "Expats",
      "International",
      "20s",
      "Must See"
    ],
    "eventDatesDe": "10. & 24. Oktober 2026 (Samstags)",
    "eventDatesEn": "Oct 10 & 24, 2026 (Saturdays)",
    "eventDatesKr": "2026년 10월 10일 & 24일 (토요일)",
    "upcomingSessions": [
      {
        "date": "2026-10-10",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 10. Okt 2026",
        "dateLabelEn": "Sat, Oct 10, 2026",
        "dateLabelKr": "10월 10일 (토)",
        "time": "19:30 KST",
        "titleDe": "Itaewon International Singles Rooftop Party #1",
        "titleEn": "Itaewon International Singles Rooftop Party #1",
        "rsvpUrl": "https://www.meetup.com/cities/kr/seoul/",
        "statusNoteDe": "100% International & Englisch",
        "statusNoteEn": "100% International & English",
        "postUrl": "https://www.instagram.com/seoul_pub_crawl/"
      },
      {
        "date": "2026-10-24",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 24. Okt 2026",
        "dateLabelEn": "Sat, Oct 24, 2026",
        "dateLabelKr": "10월 24일 (토)",
        "time": "19:30 KST",
        "titleDe": "Itaewon International Singles Rooftop Party #2",
        "titleEn": "Itaewon International Singles Rooftop Party #2",
        "rsvpUrl": "https://www.meetup.com/cities/kr/seoul/",
        "statusNoteDe": "100% International & Englisch",
        "statusNoteEn": "100% International & English",
        "postUrl": "https://www.instagram.com/seoul_pub_crawl/"
      }
    ]
  },
  {
    "id": "event-social-redbutton-hongdae-boardgames",
    "name": "Red Button Hongdae – Korean Board Game Café Lounge (보드게임카페 레드버튼 홍대점)",
    "nameDe": "Red Button Hongdae – Koreanisches Board-Game-Café (100% Alkoholfreies Date- & Social-Spot)",
    "nameKr": "보드게임카페 레드버튼 홍대점",
    "category": "activity",
    "region": "Seoul",
    "district": "Mapo-gu (Hongik-ro 10, Hongdae)",
    "lat": 37.5545,
    "lng": 126.9229,
    "rating": 4.8,
    "reviewCount": 3100,
    "isMustSee": true,
    "isEvent": true,
    "eventType": "party_mixer",
    "organizer": "Red Button Boardgame Café (@official_redbutton)",
    "websiteUrl": "https://redbutton.co.kr/boardgame/%eb%b3%b4%eb%93%9c%ea%b2%8c%ec%9e%84-%ec%b0%be%ea%b8%b0/",
    "instagramUrl": "https://www.instagram.com/official_redbutton/",
    "instagramTag": "레드버튼홍대",
    "tiktokQuery": "Red Button board game cafe Hongdae Seoul",
    "eventUrl": "https://redbutton.co.kr/store/%eb%a7%a4%ec%9e%a5%ec%b0%be%ea%b8%b0/",
    "eventTime": "Täglich 13:00 – 24:00 Uhr (Top-Spot für alkoholfreie 1:1 Dates & Uni-Gruppen)",
    "targetAudienceDe": "Junge Koreaner & Internationals (20–25 Jahre) – Koreas beliebtester alkoholfreier Date- & Gruppen-Treffpunkt",
    "targetAudienceEn": "Young Koreans & internationals (20–25 yrs) – Korea’s #1 alcohol-free board game cafe for dates & group hangouts",
    "targetAudienceKr": "홍대 20대 대학생 커플 데이트 및 친구 모임 1순위 프리미엄 보드게임 카페",
    "ageRecommendationDe": "🎯 Perfekt für 20–25 Jahre (Ø 22 Jahre, 100% Alkoholfreier Date-Klassiker)",
    "ageRecommendationEn": "🎯 Best for 20–25 yrs (avg. 22 yrs, #1 Alcohol-Free Korean Date Spot)",
    "ageRecommendationKr": "🎯 20대 초중반 대학생/커플 데이트 필수 코스 (평균 22세)",
    "socialTipsDe": "In Korea gehen 23-Jährige bei einem ersten oder zweiten Date ohne Alkohol fast immer ins „Red Button“! Jeder private Kojen-Tisch hat ein Tablet, das die Spiele erklärt, und man bestellt per Touchpad Eiskaffee, Ades oder Snacks. Perfekt, wenn du ein Match von einem Café-Event zu einem lockeren 2-Personen-Spiele-Date einladen willst!",
    "socialTipsEn": "In Korea, Red Button is the #1 alcohol-free date spot for 20-somethings! Private booth tables, tablet game tutorials, and iced coffee/snacks—ideal for bringing a new Korean friend or date.",
    "socialTipsKr": "한국 20대들의 무알콜 데이트 및 친목 모임 성지. 프라이빗 룸에서 태블릿 설명 영상을 보며 둘이서 또는 그룹으로 보드게임을 즐길 수 있습니다.",
    "description": "Korea’s premier board game cafe lounge in Hongdae (Hongik-ro 10) with private booth rooms, interactive tablet game explainers, specialty coffee, fruit ades, and snacks. The #1 alcohol-free date and hangout spot for Korean 20-somethings.",
    "descriptionDe": "Koreas berühmteste Premium-Boardgame-Lounge mitten in Hongdae (Hongik-ro 10). Mit privaten Holzkojen, Tablet-Spieleerklärungen sowie Eiskaffee, Frucht-Ades und Snacks ist Red Button der beliebteste alkoholfreie Date-Spot für koreanische Studierende.",
    "photoTips": "Cozy private wooden game booth with colorful 2-player and party board games and fruit ades.",
    "photoTipsDe": "Private Holzkojen mit bunten Brettspielen, Eiskaffee und Snack-Platten.",
    "bestTime": "Afternoon & Evening (14:00 - 22:00)",
    "bestTimeDe": "Nachmittag & Abend (14:00 - 22:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1610890716171-6b1bb98ffd09?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Hongik Univ. Station (Line 2) Exit 9 (Walk 3 min to Hongik-ro 10)",
    "feeInfo": "3,000 KRW / hour + 1 cafe drink order (~5,000 KRW)",
    "feeInfoDe": "3.000 KRW pro Stunde + 1 Café-Getränk (~5.000 KRW)",
    "tags": [
      "Red Button",
      "Board Games",
      "Alkoholfrei",
      "Coffee Date",
      "Korean Locals",
      "Hongdae",
      "20s",
      "Must See"
    ],
    "eventDatesDe": "Jeden Donnerstag & Samstag/Sonntag im Oktober 2026",
    "eventDatesEn": "Every Thursday & Weekend in October 2026",
    "eventDatesKr": "2026년 10월 매주 목요일 & 주말",
    "upcomingSessions": [
      {
        "date": "2026-10-01",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 01. Okt 2026",
        "dateLabelEn": "Thu, Oct 1, 2026",
        "dateLabelKr": "10월 1일 (목)",
        "time": "18:00 KST",
        "titleDe": "Red Button Hongdae – Board Game Café & Spiele-Suche",
        "titleEn": "Red Button Hongdae – Board Game Café & Game Finder",
        "rsvpUrl": "https://redbutton.co.kr/boardgame/%eb%b3%b4%eb%93%9c%ea%b2%8c%ec%9e%84-%ec%b0%be%ea%b8%b0/",
        "statusNoteDe": "Red Button Hongdae (Hongik-ro 10)",
        "statusNoteEn": "Red Button Hongdae (Hongik-ro 10)",
        "postUrl": "https://www.instagram.com/official_redbutton/"
      },
      {
        "date": "2026-10-04",
        "dayNameDe": "Sonntag",
        "dayNameEn": "Sunday",
        "dayNameKr": "일요일",
        "dateLabelDe": "So, 04. Okt 2026",
        "dateLabelEn": "Sun, Oct 4, 2026",
        "dateLabelKr": "10월 4일 (일)",
        "time": "16:00 KST",
        "titleDe": "Red Button Hongdae – Standort & Tisch-Info (Hongik-ro 10)",
        "titleEn": "Red Button Hongdae – Store & Booth Info (Hongik-ro 10)",
        "rsvpUrl": "https://redbutton.co.kr/store/%eb%a7%a5%ec%9e%a5%ec%b0%be%ea%b8%b0/",
        "statusNoteDe": "Red Button Hongdae (Hongik-ro 10)",
        "statusNoteEn": "Red Button Hongdae (Hongik-ro 10)",
        "postUrl": "https://www.instagram.com/official_redbutton/"
      },
      {
        "date": "2026-10-08",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 08. Okt 2026",
        "dateLabelEn": "Thu, Oct 8, 2026",
        "dateLabelKr": "10월 8일 (목)",
        "time": "18:00 KST",
        "titleDe": "Red Button Hongdae – Board Game Café & Spiele-Suche",
        "titleEn": "Red Button Hongdae – Board Game Café & Game Finder",
        "rsvpUrl": "https://redbutton.co.kr/boardgame/%eb%b3%b4%eb%93%9c%ea%b2%8c%ec%9e%84-%ec%b0%be%ea%b8%b0/",
        "statusNoteDe": "Red Button Hongdae (Hongik-ro 10)",
        "statusNoteEn": "Red Button Hongdae (Hongik-ro 10)",
        "postUrl": "https://www.instagram.com/official_redbutton/"
      },
      {
        "date": "2026-10-11",
        "dayNameDe": "Sonntag",
        "dayNameEn": "Sunday",
        "dayNameKr": "일요일",
        "dateLabelDe": "So, 11. Okt 2026",
        "dateLabelEn": "Sun, Oct 11, 2026",
        "dateLabelKr": "10월 11일 (일)",
        "time": "16:00 KST",
        "titleDe": "Red Button Hongdae – Standort & Tisch-Info (Hongik-ro 10)",
        "titleEn": "Red Button Hongdae – Store & Booth Info (Hongik-ro 10)",
        "rsvpUrl": "https://redbutton.co.kr/store/%eb%a7%a5%ec%9e%a5%ec%b0%be%ea%b8%b0/",
        "statusNoteDe": "Red Button Hongdae (Hongik-ro 10)",
        "statusNoteEn": "Red Button Hongdae (Hongik-ro 10)",
        "postUrl": "https://www.instagram.com/official_redbutton/"
      },
      {
        "date": "2026-10-15",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 15. Okt 2026",
        "dateLabelEn": "Thu, Oct 15, 2026",
        "dateLabelKr": "10월 15일 (목)",
        "time": "18:00 KST",
        "titleDe": "Red Button Hongdae – Board Game Café & Spiele-Suche",
        "titleEn": "Red Button Hongdae – Board Game Café & Game Finder",
        "rsvpUrl": "https://redbutton.co.kr/boardgame/%eb%b3%b4%eb%93%9c%ea%b2%8c%ec%9e%84-%ec%b0%be%ea%b8%b0/",
        "statusNoteDe": "Red Button Hongdae (Hongik-ro 10)",
        "statusNoteEn": "Red Button Hongdae (Hongik-ro 10)",
        "postUrl": "https://www.instagram.com/official_redbutton/"
      },
      {
        "date": "2026-10-18",
        "dayNameDe": "Sonntag",
        "dayNameEn": "Sunday",
        "dayNameKr": "일요일",
        "dateLabelDe": "So, 18. Okt 2026",
        "dateLabelEn": "Sun, Oct 18, 2026",
        "dateLabelKr": "10월 18일 (일)",
        "time": "16:00 KST",
        "titleDe": "Red Button Hongdae – Standort & Tisch-Info (Hongik-ro 10)",
        "titleEn": "Red Button Hongdae – Store & Booth Info (Hongik-ro 10)",
        "rsvpUrl": "https://redbutton.co.kr/store/%eb%a7%a5%ec%9e%a5%ec%b0%be%ea%b8%b0/",
        "statusNoteDe": "Red Button Hongdae (Hongik-ro 10)",
        "statusNoteEn": "Red Button Hongdae (Hongik-ro 10)",
        "postUrl": "https://www.instagram.com/official_redbutton/"
      },
      {
        "date": "2026-10-22",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 22. Okt 2026",
        "dateLabelEn": "Thu, Oct 22, 2026",
        "dateLabelKr": "10월 22일 (목)",
        "time": "18:00 KST",
        "titleDe": "Red Button Hongdae – Board Game Café & Spiele-Suche",
        "titleEn": "Red Button Hongdae – Board Game Café & Game Finder",
        "rsvpUrl": "https://redbutton.co.kr/boardgame/%eb%b3%b4%eb%93%9c%ea%b2%8c%ec%9e%84-%ec%b0%be%ea%b8%b0/",
        "statusNoteDe": "Red Button Hongdae (Hongik-ro 10)",
        "statusNoteEn": "Red Button Hongdae (Hongik-ro 10)",
        "postUrl": "https://www.instagram.com/official_redbutton/"
      },
      {
        "date": "2026-10-25",
        "dayNameDe": "Sonntag",
        "dayNameEn": "Sunday",
        "dayNameKr": "일요일",
        "dateLabelDe": "So, 25. Okt 2026",
        "dateLabelEn": "Sun, Oct 25, 2026",
        "dateLabelKr": "10월 25일 (일)",
        "time": "16:00 KST",
        "titleDe": "Red Button Hongdae – Standort & Tisch-Info (Hongik-ro 10)",
        "titleEn": "Red Button Hongdae – Store & Booth Info (Hongik-ro 10)",
        "rsvpUrl": "https://redbutton.co.kr/store/%eb%a7%a5%ec%9e%a5%ec%b0%be%ea%b8%b0/",
        "statusNoteDe": "Red Button Hongdae (Hongik-ro 10)",
        "statusNoteEn": "Red Button Hongdae (Hongik-ro 10)",
        "postUrl": "https://www.instagram.com/official_redbutton/"
      },
      {
        "date": "2026-10-29",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 29. Okt 2026",
        "dateLabelEn": "Thu, Oct 29, 2026",
        "dateLabelKr": "10월 29일 (목)",
        "time": "18:00 KST",
        "titleDe": "Red Button Hongdae – Board Game Café & Spiele-Suche",
        "titleEn": "Red Button Hongdae – Board Game Café & Game Finder",
        "rsvpUrl": "https://redbutton.co.kr/boardgame/%eb%b3%b4%eb%93%9c%ea%b2%8c%ec%9e%84-%ec%b0%be%ea%b8%b0/",
        "statusNoteDe": "Red Button Hongdae (Hongik-ro 10)",
        "statusNoteEn": "Red Button Hongdae (Hongik-ro 10)",
        "postUrl": "https://www.instagram.com/official_redbutton/"
      }
    ]
  },
  {
    "id": "event-social-songdo-igc-pyeonmaek-night",
    "name": "Songdo Hang Out – American Town Convenience Store Night (송도 캠퍼스타운 편맥 모임)",
    "nameDe": "Songdo Hang Out – Campus Town Convenience Store Treff (송도 아메리칸타운 소셜)",
    "nameKr": "송도 아메리칸타운더샵 편의점 소셜 모임 (Songdo Hang Out)",
    "category": "event_festival",
    "region": "Incheon",
    "district": "Yeonsu-gu (Songdo Campus Town Station Exit 2)",
    "lat": 37.3878,
    "lng": 126.6565,
    "rating": 4.9,
    "reviewCount": 4800,
    "isMustSee": true,
    "isEvent": true,
    "eventType": "party_mixer",
    "organizer": "Songdo Hang Out | Meet Locals & Travelers & Expats",
    "websiteUrl": "https://open.kakao.com/o/pVcVzGEi",
    "instagramTag": "송도센트럴파크",
    "tiktokQuery": "Songdo Incheon campus town night",
    "eventUrl": "https://www.meetup.com/songdo-hang-out-meet-locals-travelers-expats/events/316890891/",
    "eventTime": "Freitagabend ab 19:30 Uhr (am CU Store American Town the Sharp, Campus Town Exit 2)",
    "targetAudienceDe": "Junge Koreaner aus Songdo, Studierende (Yonsei Songdo / IGC) & Internationals (20–28 Jahre)",
    "targetAudienceEn": "Young Koreans in Songdo, university students (Yonsei / IGC) & expats (20–28 yrs)",
    "targetAudienceKr": "송도 거주 20대 한국인 청년, 연세대·글로벌캠퍼스 대학생 및 외국인 친구 모임",
    "ageRecommendationDe": "🎯 Perfekt für 20–26 Jahre (Ø 22–24 Jahre, Softdrinks/Snacks frei wählbar)",
    "ageRecommendationEn": "🎯 Best for 20–26 yrs (avg. 22–24 yrs, grab any soft drink or snack at CU)",
    "ageRecommendationKr": "🎯 20대 청년/대학생 (평균 22~24세)",
    "socialTipsDe": "Dieses Meetup (`events/316890891`) trifft sich direkt an den Outdoor-Tischen beim CU Convenience Store im „American Town the Sharp“ (Campus Town Station Exit 2). Da jeder sich sein Getränk selbst im CU-Markt holt (Eistee, Zero-Cola, Kaffee oder Bier + K-Snacks), ist man als Nicht-Trinker zu 100% entspannt dabei! Über „Programm“ kommst du direkt in den offiziellen KakaoTalk-Gruppenchat (`open.kakao.com/o/pVcVzGEi`).",
    "socialTipsEn": "Meets directly at the outdoor tables of CU Convenience Store at American Town the Sharp (Campus Town Station Exit 2, `events/316890891`). Everyone grabs their own drink/snack from CU (iced tea, soda, coffee, or beer). Click \"Schedule\" for the group’s official KakaoTalk OpenChat (`open.kakao.com/o/pVcVzGEi`).",
    "socialTipsKr": "캠퍼스타운역 2번 출구 앞 송도 아메리칸타운더샵 CU 편의점 야외 테이블에서 진행되는 한·영 교류 모임입니다. 각자 원하는 음료/다과를 구매해 자유롭게 대화합니다.",
    "description": "The weekly outdoor social gathering of the \"Songdo Hang Out\" Meetup community at American Town the Sharp (Campus Town Station Exit 2). Locals, university students, and expats grab snacks and drinks (soft drinks, iced coffee, or beer) from the convenience store and chat outdoors.",
    "descriptionDe": "Das wöchentliche Outdoor-Treffen der „Songdo Hang Out“-Community am American Town the Sharp (Campus Town Station Exit 2). Koreanische Locals, Studierende und Internationals holen sich Snacks und Getränke (Softdrinks, Eiskaffee oder Bier) im CU-Markt und sitzen gemeinsam draußen.",
    "photoTips": "Relaxed outdoor convenience store tables under Songdo high-rise lights.",
    "photoTipsDe": "Gemütliche Outdoor-Tische am Abend im modernen Universitätsviertel von Songdo.",
    "bestTime": "Friday Night (19:30 - 22:30)",
    "bestTimeDe": "Freitagabend (19:30 - 22:30 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1514565131-fce0801e5785?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Campus Town Station (Incheon Line 1), Exit 2 (Walk 2 min to American Town the Sharp)",
    "feeInfo": "1,000 KRW Meetup fee + buy your own drink/snack at CU store (~3,000 KRW)",
    "feeInfoDe": "1.000 KRW Meetup-Beitrag + eigenes Getränk/Snack im CU-Store (~3.000 KRW)",
    "tags": [
      "Incheon",
      "Songdo",
      "Alkoholfrei",
      "Korean Locals",
      "Outdoor Social",
      "20s",
      "Must See"
    ],
    "eventDatesDe": "Jeden Freitag im Oktober 2026 (02., 09., 16., 23., 30. Okt)",
    "eventDatesEn": "Every Friday in October 2026 (Oct 2, Oct 9, Oct 16, Oct 23, Oct 30)",
    "eventDatesKr": "2026년 10월 매주 금요일 (2일, 9일, 16일, 23일, 30일)",
    "upcomingSessions": [
      {
        "date": "2026-10-02",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 02. Okt 2026",
        "dateLabelEn": "Fri, Oct 2, 2026",
        "dateLabelKr": "10월 2일 (금)",
        "time": "19:30 KST",
        "titleDe": "🍻 Convenience Store Night at American Town the Sharp Songdo",
        "titleEn": "🍻 Convenience Store Night at American Town the Sharp Songdo",
        "rsvpUrl": "https://www.meetup.com/songdo-hang-out-meet-locals-travelers-expats/events/316643794/",
        "statusNoteDe": "Songdo Campus Town Exit 2",
        "statusNoteEn": "Songdo Campus Town Exit 2"
      },
      {
        "date": "2026-10-09",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 09. Okt 2026",
        "dateLabelEn": "Fri, Oct 9, 2026",
        "dateLabelKr": "10월 9일 (금)",
        "time": "19:30 KST",
        "titleDe": "🍻 Convenience Store Night at American Town the Sharp Songdo",
        "titleEn": "🍻 Convenience Store Night at American Town the Sharp Songdo",
        "rsvpUrl": "https://www.meetup.com/songdo-hang-out-meet-locals-travelers-expats/events/316890891/",
        "statusNoteDe": "Songdo Campus Town Exit 2",
        "statusNoteEn": "Songdo Campus Town Exit 2"
      },
      {
        "date": "2026-10-16",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 16. Okt 2026",
        "dateLabelEn": "Fri, Oct 16, 2026",
        "dateLabelKr": "10월 16일 (금)",
        "time": "19:30 KST",
        "titleDe": "🍻 Convenience Store Night at American Town the Sharp Songdo",
        "titleEn": "🍻 Convenience Store Night at American Town the Sharp Songdo",
        "rsvpUrl": "https://www.meetup.com/songdo-hang-out-meet-locals-travelers-expats/events/316890891/",
        "statusNoteDe": "Songdo Campus Town Exit 2",
        "statusNoteEn": "Songdo Campus Town Exit 2"
      },
      {
        "date": "2026-10-23",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 23. Okt 2026",
        "dateLabelEn": "Fri, Oct 23, 2026",
        "dateLabelKr": "10월 23일 (금)",
        "time": "19:30 KST",
        "titleDe": "🍻 Convenience Store Night at American Town the Sharp Songdo",
        "titleEn": "🍻 Convenience Store Night at American Town the Sharp Songdo",
        "rsvpUrl": "https://www.meetup.com/songdo-hang-out-meet-locals-travelers-expats/events/316890891/",
        "statusNoteDe": "Songdo Campus Town Exit 2",
        "statusNoteEn": "Songdo Campus Town Exit 2"
      },
      {
        "date": "2026-10-30",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 30. Okt 2026",
        "dateLabelEn": "Fri, Oct 30, 2026",
        "dateLabelKr": "10월 30일 (금)",
        "time": "19:30 KST",
        "titleDe": "🍻 Convenience Store Night at American Town the Sharp Songdo",
        "titleEn": "🍻 Convenience Store Night at American Town the Sharp Songdo",
        "rsvpUrl": "https://www.meetup.com/songdo-hang-out-meet-locals-travelers-expats/events/316890891/",
        "statusNoteDe": "Songdo Campus Town Exit 2",
        "statusNoteEn": "Songdo Campus Town Exit 2"
      }
    ]
  },
  {
    "id": "event-social-incheon-bupyeong-language-exchange",
    "name": "Incheon Bupyeong QooQoo Gold Buffet Night & Songdo Switch Language Exchange",
    "nameDe": "Incheon Bupyeong QooQoo Gold Dinner-Treff & Songdo Switch Sprachaustausch (Alkoholfrei)",
    "nameKr": "인천 부평 쿠우쿠우 골드 디너 소셜 & 송도 스위치 한영 언어교환 모임",
    "category": "event_festival",
    "region": "Incheon",
    "district": "Bupyeong-gu (QooQoo Gold Bupyeong) & Yeonsu-gu (Songdo)",
    "lat": 37.4925,
    "lng": 126.724,
    "rating": 4.8,
    "reviewCount": 2200,
    "isMustSee": true,
    "isEvent": true,
    "eventType": "language_exchange",
    "organizer": "Songdo Hang Out & Songdo Switch Community",
    "websiteUrl": "https://www.meetup.com/songdo-language-exchange-songdo-switch/events/315887199/",
    "instagramTag": "부평쿠우쿠우",
    "tiktokQuery": "QooQoo Gold Bupyeong Incheon buffet",
    "eventUrl": "https://www.meetup.com/songdo-hang-out-meet-locals-travelers-expats/events/317030806/",
    "eventTime": "Fr 19:00 Uhr (QooQoo Gold Bupyeong Dinner `317030806`) & Sprach-Meetup (`315887199`)",
    "targetAudienceDe": "Junge Koreaner & Internationals in Incheon/Bupyeong (20–28 Jahre) für gemeinsames Essen & Sprachaustausch ohne Alkohol",
    "targetAudienceEn": "Young locals & internationals in Incheon/Bupyeong (20–28 yrs) for group buffet dinners & language exchange",
    "targetAudienceKr": "인천 부평 쿠우쿠우 골드 뷔페 저녁 모임 및 송도 스위치 한·영 언어교환 참가자",
    "ageRecommendationDe": "🎯 Perfekt für 20–26 Jahre (Ø 23 Jahre, 100% Alkoholfreies Dinner & Gespräch)",
    "ageRecommendationEn": "🎯 Best for 20–26 yrs (avg. 23 yrs, 100% Alcohol-Free Dinner & Exchange)",
    "ageRecommendationKr": "🎯 20대 청년/대학생 맞춤 (평균 23세, 무알콜 식사 & 언어교환)",
    "socialTipsDe": "Der Button „Anmeldung“ führt direkt zum gemeinsamen „Buffet Night at QooQoo Gold Bupyeong Branch“-Event (`events/317030806`), bei dem man mit Koreanern und Internationals in Bupyeong essen geht. Der Button „Programm“ öffnet das „Songdo Switch“-Sprachaustausch-Meetup (`events/315887199`).",
    "socialTipsEn": "\"RSVP\" opens the \"Buffet Night at QooQoo Gold Bupyeong Branch\" Meetup (`events/317030806`), and \"Schedule\" opens the \"Songdo Switch Language Exchange\" Meetup (`events/315887199`).",
    "socialTipsKr": "예약 버튼은 부평 쿠우쿠우 골드 지점 디너 벙개(317030806)로, 일정 버튼은 송도 스위치 언어교환 페이지(315887199)로 정확히 연결됩니다.",
    "description": "Two verified Incheon social events connecting Korean locals and internationals over food and conversation: the Buffet Dinner Night at QooQoo Gold Bupyeong Branch (`317030806`) and the Songdo Switch Korean-English Language Exchange (`315887199`).",
    "descriptionDe": "Zwei verifizierte Incheon-Meetups zum Kennenlernen von Koreanern ohne Alkohol: Das gemeinsame Buffet-Dinner im QooQoo Gold Bupyeong (`317030806`) direkt an der Bupyeong Station sowie der Songdo Switch Koreanisch-Englisch-Sprachaustausch (`315887199`).",
    "photoTips": "Sushi, desserts, and group dinner tables at QooQoo Gold Bupyeong Branch.",
    "photoTipsDe": "Gemeinsames Buffet-Dinner und fröhliche Runde im QooQoo Gold Bupyeong.",
    "bestTime": "Evening Dinner (19:00 - 21:30)",
    "bestTimeDe": "Abend-Dinner (19:00 - 21:30 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Bupyeong Station (Seoul Line 1 / Incheon Line 1), Exit 7 (QooQoo Gold Bupyeong)",
    "feeInfo": "Free RSVP (Pay only for your own meal/drink at the venue)",
    "feeInfoDe": "Kostenlose Anmeldung (Jeder zahlt nur sein eigenes Essen/Getränk vor Ort)",
    "tags": [
      "Incheon",
      "Bupyeong",
      "Language Exchange",
      "Sprachaustausch",
      "Alkoholfrei",
      "Korean Locals",
      "Dinner Social",
      "Must See"
    ],
    "eventDatesDe": "Jeden Samstag im Oktober 2026 (03., 10., 17., 24., 31. Okt)",
    "eventDatesEn": "Every Saturday in October 2026 (Oct 3, Oct 10, Oct 17, Oct 24, Oct 31)",
    "eventDatesKr": "2026년 10월 매주 토요일 (3일, 10일, 17일, 24일, 31일)",
    "upcomingSessions": [
      {
        "date": "2026-10-17",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 17. Okt 2026",
        "dateLabelEn": "Sat, Oct 17, 2026",
        "dateLabelKr": "10월 17일 (토)",
        "time": "15:00 KST",
        "titleDe": "🌍 Songdo Switch Language Exchange – Meet Locals & Expats",
        "titleEn": "🌍 Songdo Switch Language Exchange – Meet Locals & Expats",
        "rsvpUrl": "https://www.meetup.com/songdo-language-exchange-songdo-switch/events/315887199/",
        "statusNoteDe": "Sprachaustausch Incheon",
        "statusNoteEn": "Incheon Language Exchange"
      },
      {
        "date": "2026-10-23",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 23. Okt 2026",
        "dateLabelEn": "Fri, Oct 23, 2026",
        "dateLabelKr": "10월 23일 (금)",
        "time": "19:00 KST",
        "titleDe": "🍣 Buffet Night at QooQoo Gold Bupyeong Branch (Dinner Social)",
        "titleEn": "🍣 Buffet Night at QooQoo Gold Bupyeong Branch (Dinner Social)",
        "rsvpUrl": "https://www.meetup.com/songdo-hang-out-meet-locals-travelers-expats/events/317030806/",
        "statusNoteDe": "QooQoo Gold Bupyeong Station",
        "statusNoteEn": "QooQoo Gold Bupyeong Station"
      },
      {
        "date": "2026-10-29",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 29. Okt 2026",
        "dateLabelEn": "Thu, Oct 29, 2026",
        "dateLabelKr": "10월 29일 (목)",
        "time": "17:30 KST",
        "titleDe": "🍸🌆 SONGDO 65 – Happy Hours & International Networking",
        "titleEn": "🍸🌆 SONGDO 65 – Happy Hours & International Networking",
        "rsvpUrl": "https://www.meetup.com/songdo-hang-out-meet-locals-travelers-expats/events/316382515/",
        "statusNoteDe": "Songdo Networking",
        "statusNoteEn": "Songdo Networking"
      }
    ]
  },
  {
    "id": "event-social-songdo-igc-international-social",
    "name": "Songdo Global Campus (SUNY/Utah/Ghent) & Incheon Expat Student Mixer",
    "nameDe": "Songdo Global Campus & Incheon Expat Student Mixer (Songdo)",
    "nameKr": "송도 글로벌캠퍼스 & 인천 외국인 유학생·익스팟 소셜 미팅",
    "category": "event_festival",
    "region": "Incheon",
    "district": "Yeonsu-gu (Songdo Global Campus & Central Park)",
    "lat": 37.3825,
    "lng": 126.6685,
    "rating": 4.8,
    "reviewCount": 1850,
    "isMustSee": true,
    "isEvent": true,
    "eventType": "outdoor_social",
    "organizer": "Songdo International Student Community & Songdo Switch",
    "websiteUrl": "https://www.meetup.com/songdo-language-exchange-songdo-switch/",
    "instagramUrl": "https://www.instagram.com/songdo_switch/",
    "instagramTag": "songdoigc",
    "tiktokQuery": "Songdo Global Campus student hangout",
    "eventUrl": "https://www.meetup.com/songdo-language-exchange-songdo-switch/events/315887199/",
    "eventTime": "Sonntags 15:00 – 18:00 Uhr (Café & Central Park Walk)",
    "targetAudienceDe": "Internationale Studierende (SUNY, Utah, Ghent, Mason), Expats & bilinguale Koreaner (100% Englisch)",
    "targetAudienceEn": "International students (SUNY, Utah, Ghent, Mason), expats & bilingual locals (100% English)",
    "targetAudienceKr": "인천 송도 글로벌캠퍼스(SUNY/유타/겐트대) 유학생, 어학연수생 및 외국인 직장인",
    "ageRecommendationDe": "🎯 Perfekt für 20–26 Jahre (Ø 22–24 Jahre)",
    "ageRecommendationEn": "🎯 Best for 20–26 yrs (avg. 22–24 yrs)",
    "ageRecommendationKr": "🎯 20대 대학생 맞춤 (평균 22~24세)",
    "socialTipsDe": "Songdo beherbergt vier renommierte US- und europäische Universitäten. Dieser Mixer bringt internationale Studierende und englischsprachige Koreaner bei Kaffee in Campus-Nähe und einem Spaziergang im Songdo Central Park zusammen. 100% auf Englisch!",
    "socialTipsEn": "Songdo houses four foreign universities at IGC. This mixer connects international students, expats, and bilingual Koreans over coffee and Central Park strolls. 100% in English!",
    "socialTipsKr": "송도 글로벌캠퍼스 외국인 유학생 및 송도 거주 글로벌 청년들이 모여 자유롭게 영어로 교류하는 정기 밋업입니다.",
    "description": "The primary international youth mixer in Incheon, centering around the Songdo Incheon Global Campus (SUNY Korea, University of Utah Asia Campus, Ghent University Global Campus, George Mason Korea). 100% English-friendly.",
    "descriptionDe": "Das führende internationale Jugend- und Studierendentreffen in Incheon rund um den Songdo Incheon Global Campus (SUNY, Utah, Ghent, George Mason). 100% auf Englisch moderiert, ungezwungen und ideal, um Leute im Raum Incheon kennenzulernen.",
    "photoTips": "Modern futurist Songdo high-rises and Central Park bridge reflections at sunset.",
    "photoTipsDe": "Futuristische Songdo-Skyline und Central-Park-Brücke bei Sonnenuntergang.",
    "bestTime": "Sunday Afternoon (15:00 - 18:00)",
    "bestTimeDe": "Sonntagnachmittag (15:00 - 18:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Campus Town Station (Incheon Line 1) Exit 2 / Central Park Station Exit 3",
    "feeInfo": "Free ~ 5,000 KRW (Optional cafe beverage)",
    "feeInfoDe": "Kostenlos ~ 5.000 KRW (Optionales Café-Getränk)",
    "tags": [
      "Songdo",
      "IGC Students",
      "English Friendly",
      "Incheon",
      "Expats",
      "20s",
      "Must See"
    ],
    "eventDatesDe": "11. & 25. Oktober 2026 (Sonntags)",
    "eventDatesEn": "Oct 11 & 25, 2026 (Sundays)",
    "eventDatesKr": "2026년 10월 11일 & 25일 (일요일)",
    "upcomingSessions": [
      {
        "date": "2026-10-11",
        "dayNameDe": "Sonntag",
        "dayNameEn": "Sunday",
        "dayNameKr": "일요일",
        "dateLabelDe": "So, 11. Okt 2026",
        "dateLabelEn": "Sun, Oct 11, 2026",
        "dateLabelKr": "10월 11일 (일)",
        "time": "15:00 KST",
        "titleDe": "Songdo Global Campus & Incheon Expat Student Social #1",
        "titleEn": "Songdo Global Campus & Incheon Expat Student Social #1",
        "rsvpUrl": "https://www.meetup.com/songdo-language-exchange-songdo-switch/",
        "statusNoteDe": "100% International & Englisch (Songdo Central Park)",
        "statusNoteEn": "100% International & English (Songdo Central Park)",
        "postUrl": "https://www.instagram.com/songdo_switch/"
      },
      {
        "date": "2026-10-25",
        "dayNameDe": "Sonntag",
        "dayNameEn": "Sunday",
        "dayNameKr": "일요일",
        "dateLabelDe": "So, 25. Okt 2026",
        "dateLabelEn": "Sun, Oct 25, 2026",
        "dateLabelKr": "10월 25일 (일)",
        "time": "15:00 KST",
        "titleDe": "Songdo Global Campus & Incheon Expat Student Social #2",
        "titleEn": "Songdo Global Campus & Incheon Expat Student Social #2",
        "rsvpUrl": "https://www.meetup.com/songdo-language-exchange-songdo-switch/",
        "statusNoteDe": "100% International & Englisch (Songdo Central Park)",
        "statusNoteEn": "100% International & English (Songdo Central Park)",
        "postUrl": "https://www.instagram.com/songdo_switch/"
      }
    ]
  },
  {
    "id": "event-social-seoul-sunset-hike-chimaek",
    "name": "Inwangsan Dulle-gil Evening Walk & Achasan Scenic Hike Meetup",
    "nameDe": "Inwangsan Dulle-gil Abend-Walk & Achasan Scenic Hike Meetup (Alkoholfrei)",
    "nameKr": "인왕산 둘레길 야경 산책 & 아차산 주말 트레킹 소셜 모임",
    "category": "event_festival",
    "region": "Seoul",
    "district": "Jongno-gu (Inwangsan Dulle-gil) & Gwangjin-gu (Achasan)",
    "lat": 37.5724,
    "lng": 126.9585,
    "rating": 5,
    "reviewCount": 4100,
    "isMustSee": true,
    "isEvent": true,
    "eventType": "outdoor_social",
    "organizer": "SeoulShare & Step-Up Hiking (@seoulshare79)",
    "websiteUrl": "https://www.meetup.com/step-up-korean-language-exchange/events/317022270/",
    "instagramUrl": "https://www.instagram.com/seoulshare79/",
    "instagramTag": "인왕산둘레길",
    "tiktokQuery": "Inwangsan night walk Seoul city wall sunset",
    "eventUrl": "https://www.meetup.com/seoulshare/events/316907314/",
    "eventTime": "18:00 Uhr (Inwangsan Dulle-gil Evening Walk `316907314`) & Sa 11:00 Uhr (Achasan Hike `317022270`)",
    "targetAudienceDe": "Jeder, der Natur & Stadtpanoramen liebt und ohne Alkoholzwang Koreaner & Internationals kennenlernen will. Normale Sneaker reichen!",
    "targetAudienceEn": "Anyone who loves city views and easy walks with Korean & international peers. Sneakers are plenty!",
    "targetAudienceKr": "인왕산 둘레길 야경 산책(316907314) 및 아차산 트레킹(317022270)을 통해 한국인·외국인 친구를 사귀는 무알콜 모임",
    "ageRecommendationDe": "🎯 Perfekt für 20–28 Jahre (Ø 22–24 Jahre, 100% Alkoholfrei)",
    "ageRecommendationEn": "🎯 Best for 20–28 yrs (avg. 22–24 yrs, 100% Alcohol-Free)",
    "ageRecommendationKr": "🎯 20대 청년/대학생 (평균 22~24세)",
    "socialTipsDe": "Der Button „Anmeldung“ führt direkt zum „🌌✨ SeoulShare Evening Walk: Stunning City Views on Inwangsan Dulle-gil“ (`events/316907314`), „Programm“ zum „[Saturday Hiking]🌿 Achasan Scenic Hike & Lunch Meetup“ (`events/317022270`). Beim gemeinsamen Gehen kommt man sofort mit Koreanern ins Gespräch!",
    "socialTipsEn": "\"RSVP\" opens the \"SeoulShare Evening Walk on Inwangsan Dulle-gil\" (`events/316907314`), and \"Schedule\" opens the \"Achasan Scenic Hike & Lunch Meetup\" (`events/317022270`).",
    "socialTipsKr": "예약 버튼은 인왕산 둘레길 야간 산책(316907314)으로, 일정 버튼은 아차산 주말 산책 및 점심 모임(317022270)으로 바로 연결됩니다.",
    "description": "Two easy, scenic outdoor social walks in Seoul: the illuminated evening walk along Inwangsan Dulle-gil (`316907314`) overlooking Gyeongbokgung and Namsan Tower, and the Saturday Achasan Scenic Hike & Lunch Meetup (`317022270`).",
    "descriptionDe": "Zwei leichte, wunderschöne Panorama-Spaziergänge mit hohem Koreaner-Anteil: Der beleuchtete Abend-Walk entlang des Inwangsan Dulle-gil (`316907314`) mit Blick auf den Namsan Tower sowie der Samstags-Walk auf den Achasan inklusive gemeinsamem Mittagessen (`317022270`).",
    "photoTips": "Golden hour and night skyline views from Inwangsan Dulle-gil and Achasan ridge.",
    "photoTipsDe": "Abendlicht-Fotos auf dem Inwangsan Dulle-gil mit Blick über ganz Seoul.",
    "bestTime": "Evening Walk (18:00) & Saturday Hike (11:00)",
    "bestTimeDe": "Abend-Walk (18:00 Uhr) & Samstags-Tour (11:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1538485399081-7191377e8241?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Gyeongbokgung Station (Line 3) Exit 1 / Achasan Station (Line 5) Exit 2",
    "feeInfo": "Free ~ 3,000 KRW Meetup fee (Optional shared meal ~12,000 KRW)",
    "feeInfoDe": "Kostenlos ~ 3.000 KRW (Optionales gemeinsames Essen ca. 12.000 KRW)",
    "tags": [
      "Outdoor Social",
      "Alkoholfrei",
      "Korean Locals",
      "Sunset Hike",
      "Inwangsan",
      "20s",
      "Solo Friendly",
      "Must See"
    ],
    "eventDatesDe": "Jeden Mittwoch & Samstag im Oktober 2026",
    "eventDatesEn": "Every Wednesday & Saturday in October 2026",
    "eventDatesKr": "2026년 10월 매주 수요일 & 토요일",
    "upcomingSessions": [
      {
        "date": "2026-10-18",
        "dayNameDe": "Sonntag",
        "dayNameEn": "Sunday",
        "dayNameKr": "일요일",
        "dateLabelDe": "So, 18. Okt 2026",
        "dateLabelEn": "Sun, Oct 18, 2026",
        "dateLabelKr": "10월 18일 (일)",
        "time": "18:00 KST",
        "titleDe": "🌌✨ SeoulShare Evening Walk: Stunning City Views on Inwangsan Dulle-gil (316907314)",
        "titleEn": "🌌✨ SeoulShare Evening Walk: Stunning City Views on Inwangsan Dulle-gil (316907314)",
        "rsvpUrl": "https://www.meetup.com/seoulshare/events/316907314/",
        "statusNoteDe": "Inwangsan Dulle-gil",
        "statusNoteEn": "Inwangsan Dulle-gil",
        "postUrl": "https://www.instagram.com/seoulshare79/"
      },
      {
        "date": "2026-10-22",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 22. Okt 2026",
        "dateLabelEn": "Thu, Oct 22, 2026",
        "dateLabelKr": "10월 22일 (목)",
        "time": "19:00 KST",
        "titleDe": "🌙 SEOUL NIGHT HIKE 👣 Gwanaksan Evening Trek (316476605)",
        "titleEn": "🌙 SEOUL NIGHT HIKE 👣 Gwanaksan Evening Trek (316476605)",
        "rsvpUrl": "https://www.meetup.com/seoulhikingnaturegroup/events/316476605/",
        "statusNoteDe": "Gwanaksan Night Hike",
        "statusNoteEn": "Gwanaksan Night Hike",
        "postUrl": "https://www.instagram.com/seoulshare79/"
      },
      {
        "date": "2026-10-24",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 24. Okt 2026",
        "dateLabelEn": "Sat, Oct 24, 2026",
        "dateLabelKr": "10월 24일 (토)",
        "time": "11:00 KST",
        "titleDe": "🌿 [Saturday Hiking] Achasan Scenic Hike & Lunch Meetup (317022270)",
        "titleEn": "🌿 [Saturday Hiking] Achasan Scenic Hike & Lunch Meetup (317022270)",
        "rsvpUrl": "https://www.meetup.com/step-up-korean-language-exchange/events/317022270/",
        "statusNoteDe": "Achasan Hike & Lunch",
        "statusNoteEn": "Achasan Hike & Lunch",
        "postUrl": "https://www.instagram.com/seoulshare79/"
      }
    ]
  },
  {
    "id": "event-social-gsm-gangnam-singles",
    "name": "GSM Gangnam 20s International Speed Dating & Social Lounge",
    "nameDe": "GSM Gangnam Internationales Speed-Dating & Social Lounge",
    "nameKr": "GSM 강남 20대 글로벌 스피드데이팅 & 싱글즈 소셜 라운지",
    "category": "event_festival",
    "region": "Seoul",
    "district": "Gangnam-gu (Sinnonhyeon / Gangnam-daero)",
    "lat": 37.5038,
    "lng": 127.0242,
    "rating": 4.9,
    "reviewCount": 3820,
    "isMustSee": true,
    "isEvent": true,
    "eventType": "speed_dating",
    "organizer": "Global Seoul Mates (GSM)",
    "websiteUrl": "https://globalseoulmates.com/en/events/Gangnam/",
    "instagramUrl": "https://www.instagram.com/gsmenglish/",
    "instagramTag": "gsmgangnam",
    "tiktokQuery": "GSM Gangnam speed dating international",
    "eventUrl": "https://globalseoulmates.com/en/events/Gangnam/2026-10-24/party",
    "eventTime": "Jeden Samstag ab 19:00 – 22:30 Uhr (Lounge & Afterparty)",
    "targetAudienceDe": "Internationale Singles, Expats & junge Koreaner mit Auslandserfahrung (100% International & Englisch)",
    "targetAudienceEn": "International singles, expats & young Koreans with study-abroad experience (100% English & bilingual)",
    "targetAudienceKr": "주한 외국인 직장인, 유학생 및 영어 소통이 가능한 20대 한국인 싱글",
    "ageRecommendationDe": "🎯 Perfekt für 21–27 Jahre (Ø 23–24 Jahre)",
    "ageRecommendationEn": "🎯 Best for 21–27 yrs (avg. 23–24 yrs)",
    "ageRecommendationKr": "🎯 20대 청년/대학생 (평균 23~24세)",
    "socialTipsDe": "Gangnams führende internationale Singles-Lounge: Zweisprachige Moderatoren, Icebreaker-Fragekarten auf Englisch und 8-minütige Rotationen. Fast alle koreanischen Teilnehmer sprechen fließend Englisch oder haben im Ausland gelebt.",
    "socialTipsEn": "Gangnam's top international singles lounge: bilingual hosts, English prompt cards, 8-minute rotations. Most Korean attendees speak fluent English or studied abroad.",
    "socialTipsKr": "강남 신논현 라운지에서 열리는 글로벌 싱글즈 밋업. 영어 진행 및 자연스러운 1:1 대화 테이블 회전.",
    "description": "Gangnam's most popular international singles and speed dating mixer hosted at GSM Tables Gangnam. 100% English-friendly with bilingual hosts, 8-minute rounds with conversation cards, and post-event mingling over drinks.",
    "descriptionDe": "Gangnams beliebtester internationaler Speed-Dating- und Singles-Mixer bei GSM Tables. 100% Englisch-freundlich mit zweisprachigen Hosts: 8-minütige Kennenlerngespräche mit vorbereiteten Fragen zwischen internationalen Gästen und aufgeschlossenen Koreanern.",
    "photoTips": "Lively atmospheric Gangnam lounge with warm ambient lighting and colorful cocktails.",
    "photoTipsDe": "Gemütliche Gangnam-Lounge mit warmer Beleuchtung und Cocktails.",
    "bestTime": "Saturday Evenings (19:00 - 22:30)",
    "bestTimeDe": "Samstagabend (19:00 – 22:30 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Sinnonhyeon Station (Line 9 / Sinbundang) Exit 3 (Walk 3 min) / Gangnam Station Exit 11",
    "feeInfo": "15,000 ~ 20,000 KRW (Includes 2 drinks & entry to speed dating lounge)",
    "feeInfoDe": "15.000 ~ 20.000 KRW (inkl. 2 Getränke & Eintritt in die Singles Lounge)",
    "tags": [
      "GSM Gangnam",
      "Speed Dating",
      "English Friendly",
      "Singles",
      "20s",
      "Gangnam",
      "Must See"
    ],
    "eventDatesDe": "Jeden Samstag im Oktober 2026 (03., 10., 17., 24., 31. Okt)",
    "eventDatesEn": "Every Saturday in October 2026 (Oct 3, Oct 10, Oct 17, Oct 24, Oct 31)",
    "eventDatesKr": "2026년 10월 매주 토요일 (3일, 10일, 17일, 24일, 31일)",
    "upcomingSessions": [
      {
        "date": "2026-10-03",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 03. Okt 2026",
        "dateLabelEn": "Sat, Oct 3, 2026",
        "dateLabelKr": "10월 3일 (토)",
        "time": "19:00 KST",
        "titleDe": "GSM Gangnam Saturday International Speed Dating & Singles Lounge",
        "titleEn": "GSM Gangnam Saturday International Speed Dating & Singles Lounge",
        "rsvpUrl": "https://globalseoulmates.com/en/events/Gangnam/",
        "statusNoteDe": "100% International & Englisch (Gangnam Lounge)",
        "statusNoteEn": "100% International & English (Gangnam Lounge)",
        "postUrl": "https://www.instagram.com/gsmenglish/"
      },
      {
        "date": "2026-10-10",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 10. Okt 2026",
        "dateLabelEn": "Sat, Oct 10, 2026",
        "dateLabelKr": "10월 10일 (토)",
        "time": "19:00 KST",
        "titleDe": "GSM Gangnam Saturday International Speed Dating & Singles Lounge",
        "titleEn": "GSM Gangnam Saturday International Speed Dating & Singles Lounge",
        "rsvpUrl": "https://globalseoulmates.com/en/events/Gangnam/",
        "statusNoteDe": "100% International & Englisch (Gangnam Lounge)",
        "statusNoteEn": "100% International & English (Gangnam Lounge)",
        "postUrl": "https://www.instagram.com/gsmenglish/"
      },
      {
        "date": "2026-10-17",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 17. Okt 2026",
        "dateLabelEn": "Sat, Oct 17, 2026",
        "dateLabelKr": "10월 17일 (토)",
        "time": "19:00 KST",
        "titleDe": "GSM Gangnam Saturday International Speed Dating & Singles Lounge",
        "titleEn": "GSM Gangnam Saturday International Speed Dating & Singles Lounge",
        "rsvpUrl": "https://globalseoulmates.com/en/events/Gangnam/",
        "statusNoteDe": "100% International & Englisch (Gangnam Lounge)",
        "statusNoteEn": "100% International & English (Gangnam Lounge)",
        "postUrl": "https://www.instagram.com/gsmenglish/"
      },
      {
        "date": "2026-10-24",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 24. Okt 2026",
        "dateLabelEn": "Sat, Oct 24, 2026",
        "dateLabelKr": "10월 24일 (토)",
        "time": "19:00 KST",
        "titleDe": "GSM Gangnam Saturday International Speed Dating & Singles Lounge",
        "titleEn": "GSM Gangnam Saturday International Speed Dating & Singles Lounge",
        "rsvpUrl": "https://globalseoulmates.com/en/events/Gangnam/",
        "statusNoteDe": "100% International & Englisch (Gangnam Lounge)",
        "statusNoteEn": "100% International & English (Gangnam Lounge)",
        "postUrl": "https://www.instagram.com/gsmenglish/"
      },
      {
        "date": "2026-10-31",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 31. Okt 2026",
        "dateLabelEn": "Sat, Oct 31, 2026",
        "dateLabelKr": "10월 31일 (토)",
        "time": "19:00 KST",
        "titleDe": "GSM Gangnam Saturday International Speed Dating & Singles Lounge",
        "titleEn": "GSM Gangnam Saturday International Speed Dating & Singles Lounge",
        "rsvpUrl": "https://globalseoulmates.com/en/events/Gangnam/",
        "statusNoteDe": "100% International & Englisch (Gangnam Lounge)",
        "statusNoteEn": "100% International & English (Gangnam Lounge)",
        "postUrl": "https://www.instagram.com/gsmenglish/"
      }
    ]
  },
  {
    "id": "event-social-thursday-seoul-singles",
    "name": "Thursday™ Dating Seoul – Offline Singles Mixer (Korean & International 20s)",
    "nameDe": "Thursday™ Dating Seoul – Offline Singles-Event (Koreaner & Internationals)",
    "nameKr": "써즈데이(Thursday™) 서울 오프라인 싱글즈 데이팅 & 소셜 믹서",
    "category": "event_festival",
    "region": "Seoul",
    "district": "Yongsan-gu (Itaewon / Hannam) & Mapo-gu (Hongdae)",
    "lat": 37.5365,
    "lng": 126.9992,
    "rating": 4.9,
    "reviewCount": 2950,
    "isMustSee": true,
    "isEvent": true,
    "eventType": "speed_dating",
    "organizer": "Thursday™ Dating (@thursday)",
    "instagramUrl": "https://www.instagram.com/thursday/",
    "instagramTag": "thursdaydating",
    "tiktokQuery": "Thursday dating events singles mixer",
    "eventUrl": "https://www.thursday.com/events/seoul",
    "eventTime": "Jeden Donnerstag ab 19:00 – 22:00 Uhr (Mocktails & Softdrinks verfügbar)",
    "targetAudienceDe": "Koreanische Singles in den 20ern mit Interesse an internationalen Dates + junge Expats/Reisende (Englisch & Koreanisch)",
    "targetAudienceEn": "Korean 20s singles interested in dating internationals + young expats/travelers (English & Korean)",
    "targetAudienceKr": "외국인 및 글로벌 감각의 이성을 오프라인에서 자연스럽게 만나고 싶은 20대 한국인 싱글",
    "ageRecommendationDe": "🎯 Perfekt für 21–27 Jahre (Ø 23–24 Jahre, International & Koreanisch)",
    "ageRecommendationEn": "🎯 Best for 21–27 yrs (avg. 23–24 yrs, International & Korean mix)",
    "ageRecommendationKr": "🎯 20대 초중반 싱글 (평균 23~24세, 한·영 글로벌 매칭)",
    "socialTipsDe": "Das weltbekannte „Everyone Single“-Offline-Event in Seoul (`thursday.com/events/seoul`) mit dem offiziellen Instagram-Kanal `@thursday`! Da das Event zweisprachig läuft, kommen hier genau die jungen Koreanerinnen hin, die sich ein Date mit Internationals wünschen. Alkoholfreie Mocktails und Softdrinks sind immer verfügbar.",
    "socialTipsEn": "The global offline singles movement in Seoul (`thursday.com/events/seoul`, Instagram `@thursday`)! Everyone attending is single, and Korean locals who attend specifically want to meet and date internationals.",
    "socialTipsKr": "전 세계적으로 인기 있는 오프라인 싱글즈 모임 서울 공식 페이지(thursday.com/events/seoul) 및 공식 인스타그램(@thursday)입니다.",
    "description": "The Seoul chapter of Thursday™ (`thursday.com/events/seoul`), the global offline dating movement where everyone in the room is single. Attracts open-minded Korean 20-somethings who speak English and want to date internationals face-to-face.",
    "descriptionDe": "Der offizielle Seouler Standort der weltweiten Offline-Dating-Bewegung „Thursday™“ (`thursday.com/events/seoul`). Jeden Donnerstag treffen sich hier junge Koreanerinnen und Koreaner sowie internationale Singles in den 20ern.",
    "photoTips": "Trendy Hannam/Hongdae lounge terrace with pink Thursday neon signs and icebreaker cards.",
    "photoTipsDe": "Stylische Lounge in Hannam/Hongdae mit Eisbrecher-Karten und Mocktails.",
    "bestTime": "Thursday Evenings (19:00 - 22:00)",
    "bestTimeDe": "Donnerstagabend (19:00 - 22:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1517457373958-b7bdd4587205?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Itaewon Station (Line 6) Exit 1 / Hongik Univ. Station (Line 2) Exit 9",
    "feeInfo": "15,000 ~ 25,000 KRW (Online ticket via Thursday Seoul page)",
    "feeInfoDe": "15.000 ~ 25.000 KRW (Ticket direkt über die offizielle Thursday-Seoul-Seite)",
    "tags": [
      "Speed Dating",
      "Foreign Men x Korean Women",
      "Alkoholfrei",
      "Singles",
      "Korean Locals",
      "20s",
      "Must See"
    ],
    "eventDatesDe": "Jeden Donnerstag im Oktober 2026 (01., 08., 15., 22., 29. Okt)",
    "eventDatesEn": "Every Thursday in October 2026 (Oct 1, Oct 8, Oct 15, Oct 22, Oct 29)",
    "eventDatesKr": "2026년 10월 매주 목요일 (1일, 8일, 15일, 22일, 29일)",
    "upcomingSessions": [
      {
        "date": "2026-10-01",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 01. Okt 2026",
        "dateLabelEn": "Thu, Oct 1, 2026",
        "dateLabelKr": "10월 1일 (목)",
        "time": "19:00 KST",
        "titleDe": "Thursday™ Seoul Offline Singles Mixer #1 (Everyone Single)",
        "titleEn": "Thursday™ Seoul Offline Singles Mixer #1 (Everyone Single)",
        "rsvpUrl": "https://www.thursday.com/events/seoul",
        "statusNoteDe": "Offizielles Thursday™ Seoul Event",
        "statusNoteEn": "Official Thursday™ Seoul Event",
        "postUrl": "https://www.instagram.com/thursday/"
      },
      {
        "date": "2026-10-08",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 08. Okt 2026",
        "dateLabelEn": "Thu, Oct 8, 2026",
        "dateLabelKr": "10월 8일 (목)",
        "time": "19:00 KST",
        "titleDe": "Thursday™ Seoul Offline Singles Mixer #2 (Everyone Single)",
        "titleEn": "Thursday™ Seoul Offline Singles Mixer #2 (Everyone Single)",
        "rsvpUrl": "https://www.thursday.com/events/seoul",
        "statusNoteDe": "Offizielles Thursday™ Seoul Event",
        "statusNoteEn": "Official Thursday™ Seoul Event",
        "postUrl": "https://www.instagram.com/thursday/"
      },
      {
        "date": "2026-10-15",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 15. Okt 2026",
        "dateLabelEn": "Thu, Oct 15, 2026",
        "dateLabelKr": "10월 15일 (목)",
        "time": "19:00 KST",
        "titleDe": "Thursday™ Seoul Offline Singles Mixer #3 (Everyone Single)",
        "titleEn": "Thursday™ Seoul Offline Singles Mixer #3 (Everyone Single)",
        "rsvpUrl": "https://www.thursday.com/events/seoul",
        "statusNoteDe": "Offizielles Thursday™ Seoul Event",
        "statusNoteEn": "Official Thursday™ Seoul Event",
        "postUrl": "https://www.instagram.com/thursday/"
      },
      {
        "date": "2026-10-22",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 22. Okt 2026",
        "dateLabelEn": "Thu, Oct 22, 2026",
        "dateLabelKr": "10월 22일 (목)",
        "time": "19:00 KST",
        "titleDe": "Thursday™ Seoul Offline Singles Mixer #4 (Everyone Single)",
        "titleEn": "Thursday™ Seoul Offline Singles Mixer #4 (Everyone Single)",
        "rsvpUrl": "https://www.thursday.com/events/seoul",
        "statusNoteDe": "Offizielles Thursday™ Seoul Event",
        "statusNoteEn": "Official Thursday™ Seoul Event",
        "postUrl": "https://www.instagram.com/thursday/"
      },
      {
        "date": "2026-10-29",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 29. Okt 2026",
        "dateLabelEn": "Thu, Oct 29, 2026",
        "dateLabelKr": "10월 29일 (목)",
        "time": "19:00 KST",
        "titleDe": "Thursday™ Seoul Offline Singles Mixer #5 (Everyone Single)",
        "titleEn": "Thursday™ Seoul Offline Singles Mixer #5 (Everyone Single)",
        "rsvpUrl": "https://www.thursday.com/events/seoul",
        "statusNoteDe": "Offizielles Thursday™ Seoul Event",
        "statusNoteEn": "Official Thursday™ Seoul Event",
        "postUrl": "https://www.instagram.com/thursday/"
      }
    ]
  },
  {
    "id": "event-social-culcom-sinchon-hongdae-cafe",
    "name": "Culcom (컬컴) Sinchon & Hongdae – Korean 20s Cafe Conversation & Study Club",
    "nameDe": "Culcom (컬컴) Sinchon & Hongdae – Koreanischer 20s Café-Konversationsclub (Alkoholfrei)",
    "nameKr": "컬컴 신촌점",
    "category": "event_festival",
    "region": "Seoul",
    "district": "Seodaemun-gu (Sinchon Station Exit 3) & Mapo-gu (Hongdae)",
    "lat": 37.5559,
    "lng": 126.9368,
    "rating": 4.9,
    "reviewCount": 5120,
    "isMustSee": true,
    "isEvent": true,
    "eventType": "language_exchange",
    "organizer": "Culcom Korea (@culcom)",
    "websiteUrl": "https://culturecomplex.co.kr/branch/",
    "instagramUrl": "https://www.instagram.com/culcom/",
    "instagramTag": "컬컴",
    "tiktokQuery": "컬컴 신촌 영어회화 스터디 카페",
    "eventUrl": "https://culturecomplex.co.kr/events/",
    "eventTime": "Wochentags & Sa Nachmittag/Abend (15:00, 17:00, 19:30 Uhr – 100% Café-Setting)",
    "targetAudienceDe": "Über 90% koreanische Studierende (Yonsei, Ewha, Sogang, Hongik, Ø 21–24 J.), die internationale Freunde & Gesprächspartner suchen!",
    "targetAudienceEn": "90%+ Korean university students (Yonsei, Ewha, Sogang, Hongik, avg. 21–24 yrs) eager to meet international guests!",
    "targetAudienceKr": "연세대·이화여대·서강대·홍익대 등 20대 한국인 대학생 90% 이상 참여하는 순수 카페 회화 클럽",
    "ageRecommendationDe": "🎯 Perfekt für 20–25 Jahre (Ø 22–23 Jahre, 90% Koreaner, 0% Alkohol)",
    "ageRecommendationEn": "🎯 Best for 20–25 yrs (avg. 22–23 yrs, 90% Korean locals, 0% alcohol)",
    "ageRecommendationKr": "🎯 20~25세 한국 대학생 밀집 (평균 22~23세, 무알콜 스터디 카페)",
    "socialTipsDe": "Geheimtipp Nr. 1 für 23-jährige Nicht-Trinker: Bei Culcom (`@culcom`) sind ca. 90% der Teilnehmenden koreanische Studierende in deinem Alter! „Anmeldung“ öffnet die offizielle Event-Seite (`culturecomplex.co.kr/events/`), „Programm“ die Standorte in Sinchon/Hongdae (`culturecomplex.co.kr/branch/`) und „Instagram“ den echten offiziellen Account `@culcom`.",
    "socialTipsEn": "#1 insider tip for a 23-year-old non-drinker to meet Korean students! ~90% of participants are Korean 20-somethings. Verified links to `culturecomplex.co.kr/events/`, `/branch/`, and official Instagram `@culcom`.",
    "socialTipsKr": "국내 최대 오프라인 회화 클럽 컬컴(@culcom)의 공식 이벤트 페이지 및 신촌/홍대 지점 안내 페이지로 연결됩니다.",
    "description": "Korea’s #1 offline cafe conversation club (`@culcom`) in the university district of Sinchon and Hongdae. Over 90% of members are local Korean 20-somethings looking to practice English and make international friends in a 100% alcohol-free cafe lounge.",
    "descriptionDe": "Koreas größter Offline-Café-Konversationsclub (`@culcom`) mitten im Universitätsviertel Sinchon/Hongdae. Über 90% der Mitglieder sind koreanische Studierende und Berufseinsteiger (Ø 22–23 Jahre), die in einer 100% alkoholfreien Café-Lounge internationale Freunde kennenlernen möchten.",
    "photoTips": "Bright modern study cafe lounge in Sinchon with small group tables and coffee cups.",
    "photoTipsDe": "Helle, moderne Café-Lounge in Sinchon mit 4er-Gesprächstischen und Eiskaffee.",
    "bestTime": "Afternoon & Early Evening (15:00 - 21:00)",
    "bestTimeDe": "Nachmittag & früher Abend (15:00 - 21:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Sinchon Station (Line 2), Exit 3 (Walk 3 min) / Hongik Univ. Station (Line 2)",
    "feeInfo": "Free or 1 Cafe Drink (~5,000 KRW) for Foreign Global Guests",
    "feeInfoDe": "Für internationale Gäste kostenlos bzw. nur 1 Café-Getränk (~5.000 KRW)",
    "tags": [
      "Language Exchange",
      "Alkoholfrei",
      "Korean Locals",
      "Sinchon",
      "Hongdae",
      "20s",
      "Coffee Social",
      "Must See"
    ],
    "eventDatesDe": "Jeden Mi, Do, Fr & Sa im Oktober 2026",
    "eventDatesEn": "Every Wed, Thu, Fri & Sat in October 2026",
    "eventDatesKr": "2026년 10월 매주 수/목/금/토요일",
    "upcomingSessions": [
      {
        "date": "2026-10-01",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 01. Okt 2026",
        "dateLabelEn": "Thu, Oct 1, 2026",
        "dateLabelKr": "10월 1일 (목)",
        "time": "19:00 KST",
        "titleDe": "Culcom Sinchon & Hongdae – Donnerstags-Café-Konversation",
        "titleEn": "Culcom Sinchon & Hongdae – Thursday Cafe Session",
        "rsvpUrl": "https://culturecomplex.co.kr/events/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/culcom/"
      },
      {
        "date": "2026-10-02",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 02. Okt 2026",
        "dateLabelEn": "Fri, Oct 2, 2026",
        "dateLabelKr": "10월 2일 (금)",
        "time": "19:30 KST",
        "titleDe": "Culcom Sinchon & Hongdae – Freitags-Café-Konversation mit koreanischen Studierenden",
        "titleEn": "Culcom Sinchon & Hongdae – Friday Cafe Session with Korean Students",
        "rsvpUrl": "https://culturecomplex.co.kr/events/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/culcom/"
      },
      {
        "date": "2026-10-03",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 03. Okt 2026",
        "dateLabelEn": "Sat, Oct 3, 2026",
        "dateLabelKr": "10월 3일 (토)",
        "time": "16:00 / 20:00 KST",
        "titleDe": "Culcom Sinchon & Hongdae – Samstags-Café-Study & Konversation",
        "titleEn": "Culcom Sinchon & Hongdae – Saturday Cafe Study & Conversation",
        "rsvpUrl": "https://culturecomplex.co.kr/branch/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/culcom/"
      },
      {
        "date": "2026-10-07",
        "dayNameDe": "Mittwoch",
        "dayNameEn": "Wednesday",
        "dayNameKr": "수요일",
        "dateLabelDe": "Mi, 07. Okt 2026",
        "dateLabelEn": "Wed, Oct 7, 2026",
        "dateLabelKr": "10월 7일 (수)",
        "time": "19:00 KST",
        "titleDe": "Culcom Sinchon & Hongdae – Mittwochs-Café-Konversation",
        "titleEn": "Culcom Sinchon & Hongdae – Wednesday Cafe Session",
        "rsvpUrl": "https://culturecomplex.co.kr/events/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/culcom/"
      },
      {
        "date": "2026-10-08",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 08. Okt 2026",
        "dateLabelEn": "Thu, Oct 8, 2026",
        "dateLabelKr": "10월 8일 (목)",
        "time": "19:00 KST",
        "titleDe": "Culcom Sinchon & Hongdae – Donnerstags-Café-Konversation",
        "titleEn": "Culcom Sinchon & Hongdae – Thursday Cafe Session",
        "rsvpUrl": "https://culturecomplex.co.kr/events/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/culcom/"
      },
      {
        "date": "2026-10-09",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 09. Okt 2026",
        "dateLabelEn": "Fri, Oct 9, 2026",
        "dateLabelKr": "10월 9일 (금)",
        "time": "19:30 KST",
        "titleDe": "Culcom Sinchon & Hongdae – Freitags-Café-Konversation mit koreanischen Studierenden",
        "titleEn": "Culcom Sinchon & Hongdae – Friday Cafe Session with Korean Students",
        "rsvpUrl": "https://culturecomplex.co.kr/events/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/culcom/"
      },
      {
        "date": "2026-10-10",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 10. Okt 2026",
        "dateLabelEn": "Sat, Oct 10, 2026",
        "dateLabelKr": "10월 10일 (토)",
        "time": "16:00 / 20:00 KST",
        "titleDe": "Culcom Sinchon & Hongdae – Samstags-Café-Study & Konversation",
        "titleEn": "Culcom Sinchon & Hongdae – Saturday Cafe Study & Conversation",
        "rsvpUrl": "https://culturecomplex.co.kr/branch/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/culcom/"
      },
      {
        "date": "2026-10-14",
        "dayNameDe": "Mittwoch",
        "dayNameEn": "Wednesday",
        "dayNameKr": "수요일",
        "dateLabelDe": "Mi, 14. Okt 2026",
        "dateLabelEn": "Wed, Oct 14, 2026",
        "dateLabelKr": "10월 14일 (수)",
        "time": "19:00 KST",
        "titleDe": "Culcom Sinchon & Hongdae – Mittwochs-Café-Konversation",
        "titleEn": "Culcom Sinchon & Hongdae – Wednesday Cafe Session",
        "rsvpUrl": "https://culturecomplex.co.kr/events/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/culcom/"
      },
      {
        "date": "2026-10-15",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 15. Okt 2026",
        "dateLabelEn": "Thu, Oct 15, 2026",
        "dateLabelKr": "10월 15일 (목)",
        "time": "19:00 KST",
        "titleDe": "Culcom Sinchon & Hongdae – Donnerstags-Café-Konversation",
        "titleEn": "Culcom Sinchon & Hongdae – Thursday Cafe Session",
        "rsvpUrl": "https://culturecomplex.co.kr/events/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/culcom/"
      },
      {
        "date": "2026-10-16",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 16. Okt 2026",
        "dateLabelEn": "Fri, Oct 16, 2026",
        "dateLabelKr": "10월 16일 (금)",
        "time": "19:30 KST",
        "titleDe": "Culcom Sinchon & Hongdae – Freitags-Café-Konversation mit koreanischen Studierenden",
        "titleEn": "Culcom Sinchon & Hongdae – Friday Cafe Session with Korean Students",
        "rsvpUrl": "https://culturecomplex.co.kr/events/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/culcom/"
      },
      {
        "date": "2026-10-17",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 17. Okt 2026",
        "dateLabelEn": "Sat, Oct 17, 2026",
        "dateLabelKr": "10월 17일 (토)",
        "time": "16:00 / 20:00 KST",
        "titleDe": "Culcom Sinchon & Hongdae – Samstags-Café-Study & Konversation",
        "titleEn": "Culcom Sinchon & Hongdae – Saturday Cafe Study & Conversation",
        "rsvpUrl": "https://culturecomplex.co.kr/branch/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/culcom/"
      },
      {
        "date": "2026-10-21",
        "dayNameDe": "Mittwoch",
        "dayNameEn": "Wednesday",
        "dayNameKr": "수요일",
        "dateLabelDe": "Mi, 21. Okt 2026",
        "dateLabelEn": "Wed, Oct 21, 2026",
        "dateLabelKr": "10월 21일 (수)",
        "time": "19:00 KST",
        "titleDe": "Culcom Sinchon & Hongdae – Mittwochs-Café-Konversation",
        "titleEn": "Culcom Sinchon & Hongdae – Wednesday Cafe Session",
        "rsvpUrl": "https://culturecomplex.co.kr/events/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/culcom/"
      },
      {
        "date": "2026-10-22",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 22. Okt 2026",
        "dateLabelEn": "Thu, Oct 22, 2026",
        "dateLabelKr": "10월 22일 (목)",
        "time": "19:00 KST",
        "titleDe": "Culcom Sinchon & Hongdae – Donnerstags-Café-Konversation",
        "titleEn": "Culcom Sinchon & Hongdae – Thursday Cafe Session",
        "rsvpUrl": "https://culturecomplex.co.kr/events/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/culcom/"
      },
      {
        "date": "2026-10-23",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 23. Okt 2026",
        "dateLabelEn": "Fri, Oct 23, 2026",
        "dateLabelKr": "10월 23일 (금)",
        "time": "19:30 KST",
        "titleDe": "Culcom Sinchon & Hongdae – Freitags-Café-Konversation mit koreanischen Studierenden",
        "titleEn": "Culcom Sinchon & Hongdae – Friday Cafe Session with Korean Students",
        "rsvpUrl": "https://culturecomplex.co.kr/events/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/culcom/"
      },
      {
        "date": "2026-10-24",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 24. Okt 2026",
        "dateLabelEn": "Sat, Oct 24, 2026",
        "dateLabelKr": "10월 24일 (토)",
        "time": "16:00 / 20:00 KST",
        "titleDe": "Culcom Sinchon & Hongdae – Samstags-Café-Study & Konversation",
        "titleEn": "Culcom Sinchon & Hongdae – Saturday Cafe Study & Conversation",
        "rsvpUrl": "https://culturecomplex.co.kr/branch/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/culcom/"
      },
      {
        "date": "2026-10-28",
        "dayNameDe": "Mittwoch",
        "dayNameEn": "Wednesday",
        "dayNameKr": "수요일",
        "dateLabelDe": "Mi, 28. Okt 2026",
        "dateLabelEn": "Wed, Oct 28, 2026",
        "dateLabelKr": "10월 28일 (수)",
        "time": "19:00 KST",
        "titleDe": "Culcom Sinchon & Hongdae – Mittwochs-Café-Konversation",
        "titleEn": "Culcom Sinchon & Hongdae – Wednesday Cafe Session",
        "rsvpUrl": "https://culturecomplex.co.kr/events/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/culcom/"
      },
      {
        "date": "2026-10-29",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 29. Okt 2026",
        "dateLabelEn": "Thu, Oct 29, 2026",
        "dateLabelKr": "10월 29일 (목)",
        "time": "19:00 KST",
        "titleDe": "Culcom Sinchon & Hongdae – Donnerstags-Café-Konversation",
        "titleEn": "Culcom Sinchon & Hongdae – Thursday Cafe Session",
        "rsvpUrl": "https://culturecomplex.co.kr/events/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/culcom/"
      },
      {
        "date": "2026-10-30",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 30. Okt 2026",
        "dateLabelEn": "Fri, Oct 30, 2026",
        "dateLabelKr": "10월 30일 (금)",
        "time": "19:30 KST",
        "titleDe": "Culcom Sinchon & Hongdae – Freitags-Café-Konversation mit koreanischen Studierenden",
        "titleEn": "Culcom Sinchon & Hongdae – Friday Cafe Session with Korean Students",
        "rsvpUrl": "https://culturecomplex.co.kr/events/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/culcom/"
      },
      {
        "date": "2026-10-31",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 31. Okt 2026",
        "dateLabelEn": "Sat, Oct 31, 2026",
        "dateLabelKr": "10월 31일 (토)",
        "time": "16:00 / 20:00 KST",
        "titleDe": "Culcom Sinchon & Hongdae – Samstags-Café-Study & Konversation",
        "titleEn": "Culcom Sinchon & Hongdae – Saturday Cafe Study & Conversation",
        "rsvpUrl": "https://culturecomplex.co.kr/branch/",
        "statusNoteDe": "Aktiver Termin (Ø 22–23 J.)",
        "statusNoteEn": "Active session (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/culcom/"
      }
    ]
  },
  {
    "id": "event-social-jongno-gangnam-conversation-cafe",
    "name": "Seoul English-Korean Afternoon Conversation Café (Jongno & Gangnam)",
    "nameDe": "Seoul English-Korean Afternoon Conversation Café (Jongno & Gangnam – Alkoholfrei)",
    "nameKr": "종로·강남 주말 오후 한영 카페 회화 & 새친구 사귀기 모임",
    "category": "event_festival",
    "region": "Seoul",
    "district": "Jongno-gu (Jonggak Station) & Gangnam-gu",
    "lat": 37.5704,
    "lng": 126.9831,
    "rating": 4.9,
    "reviewCount": 2640,
    "isMustSee": true,
    "isEvent": true,
    "eventType": "language_exchange",
    "organizer": "Seoul Language Exchange & New Friends (Jongno/Gangnam)",
    "websiteUrl": "https://www.meetup.com/seoul-language-exchange-new-friends-jongno-gangnam/events/316944820/",
    "instagramTag": "종로영어회화",
    "tiktokQuery": "Seoul language exchange cafe Jongno Gangnam",
    "eventUrl": "https://www.meetup.com/seoul-language-exchange-new-friends-jongno-gangnam/events/317022419/",
    "eventTime": "Sa & So Nachmittag 16:00 – 18:30 Uhr (Kaffee, Matcha Latte & Kuchen)",
    "targetAudienceDe": "Junge Koreaner (ca. 75% Einheimische, 20–26 J.) & Internationals bei entspanntem Nachmittagskaffee",
    "targetAudienceEn": "Young Koreans (~75% locals, 20–26 yrs) & internationals over relaxed afternoon coffee and cake",
    "targetAudienceKr": "주말 오후 4시 조용한 카페에서 커피와 디저트를 나누며 외국인·한국인 친구를 사귀는 20대 모임",
    "ageRecommendationDe": "🎯 Perfekt für 20–26 Jahre (Ø 23 Jahre, 100% Alkoholfreies Café)",
    "ageRecommendationEn": "🎯 Best for 20–26 yrs (avg. 23 yrs, 100% Alcohol-Free Cafe)",
    "ageRecommendationKr": "🎯 20대 청년/대학생 맞춤 (평균 23세, 무알콜 주말 오후 카페)",
    "socialTipsDe": "Beide Links („Anmeldung“ `events/317022419` und „Programm“ `events/316944820`) führen direkt zu den konkreten 16:00-Uhr-Nachmittags-Sessions von „Seoul English Korean Conversation Café Meet Friend People“. An kleinen 4er-Tischen sitzen meist 3 Koreaner und 1 Internationaler.",
    "socialTipsEn": "Both \"RSVP\" (`events/317022419`) and \"Schedule\" (`events/316944820`) open the exact 4 PM weekend sessions of \"Seoul English Korean Conversation Café Meet Friend People\".",
    "socialTipsKr": "오후 4시 종로/강남 카페에서 진행되는 한영 카페 회화 모임(317022419, 316944820) 공식 미트업 페이지로 바로 연결됩니다.",
    "description": "A warm, alcohol-free weekend afternoon conversation café at 4:00 PM in central Seoul (Jongno & Gangnam). Around 75% of attendees are local Koreans in their 20s eager to exchange languages and culture over coffee and tea.",
    "descriptionDe": "Ein herzliches, komplett alkoholfreies Wochenend-Café-Treffen am Nachmittag (16:00 Uhr) in Jongno und Gangnam (`events/317022419` & `316944820`). Rund 75% der Gäste sind junge Koreanerinnen und Koreaner in den 20ern.",
    "photoTips": "Afternoon coffee, matcha lattes, and desserts at a bright wooden cafe table near Cheonggyecheon.",
    "photoTipsDe": "Nachmittagskaffee, Matcha Latte und Kuchen an einem hellen Café-Tisch nahe dem Cheonggyecheon.",
    "bestTime": "Sat & Sun Afternoon (16:00 - 18:30)",
    "bestTimeDe": "Samstag- & Sonntagnachmittag (16:00 - 18:30 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Jonggak Station (Line 1), Exit 4 / Gangnam Station (Line 2), Exit 11",
    "feeInfo": "5,000 ~ 10,000 KRW (Includes 1 cafe drink & table rotation coordination)",
    "feeInfoDe": "5.000 ~ 10.000 KRW (inkl. 1 Café-Getränk & organisierter Tischrotation)",
    "tags": [
      "Language Exchange",
      "Alkoholfrei",
      "Korean Locals",
      "Coffee Social",
      "Jongno",
      "20s",
      "Must See"
    ],
    "eventDatesDe": "Jeden Sa & So Nachmittag im Oktober 2026 (Alkoholfrei)",
    "eventDatesEn": "Every Sat & Sun Afternoon in October 2026 (Alcohol-Free)",
    "eventDatesKr": "2026년 10월 매주 토/일요일 오후 (무알콜 카페 모임)",
    "upcomingSessions": [
      {
        "date": "2026-10-03",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 03. Okt 2026",
        "dateLabelEn": "Sat, Oct 3, 2026",
        "dateLabelKr": "10월 3일 (토)",
        "time": "14:00 / 16:00 KST",
        "titleDe": "Seoul English Korean Conversation Café – Samstags-Runde (316944820)",
        "titleEn": "Seoul English Korean Conversation Café – Saturday Session (316944820)",
        "rsvpUrl": "https://www.meetup.com/seoul-language-exchange-new-friends-jongno-gangnam/events/316944820/",
        "statusNoteDe": "100% Alkoholfrei (Ø 22–23 J.)",
        "statusNoteEn": "100% Alcohol-Free (avg. 22–23 yrs)"
      },
      {
        "date": "2026-10-04",
        "dayNameDe": "Sonntag",
        "dayNameEn": "Sunday",
        "dayNameKr": "일요일",
        "dateLabelDe": "So, 04. Okt 2026",
        "dateLabelEn": "Sun, Oct 4, 2026",
        "dateLabelKr": "10월 4일 (일)",
        "time": "15:00 / 16:00 KST",
        "titleDe": "Seoul English Korean Conversation Café – Sonntags-Runde (317022419)",
        "titleEn": "Seoul English Korean Conversation Café – Sunday Session (317022419)",
        "rsvpUrl": "https://www.meetup.com/seoul-language-exchange-new-friends-jongno-gangnam/events/317022419/",
        "statusNoteDe": "100% Alkoholfrei (Ø 22–23 J.)",
        "statusNoteEn": "100% Alcohol-Free (avg. 22–23 yrs)"
      },
      {
        "date": "2026-10-10",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 10. Okt 2026",
        "dateLabelEn": "Sat, Oct 10, 2026",
        "dateLabelKr": "10월 10일 (토)",
        "time": "14:00 / 16:00 KST",
        "titleDe": "Seoul English Korean Conversation Café – Samstags-Runde (316944820)",
        "titleEn": "Seoul English Korean Conversation Café – Saturday Session (316944820)",
        "rsvpUrl": "https://www.meetup.com/seoul-language-exchange-new-friends-jongno-gangnam/events/316944820/",
        "statusNoteDe": "100% Alkoholfrei (Ø 22–23 J.)",
        "statusNoteEn": "100% Alcohol-Free (avg. 22–23 yrs)"
      },
      {
        "date": "2026-10-11",
        "dayNameDe": "Sonntag",
        "dayNameEn": "Sunday",
        "dayNameKr": "일요일",
        "dateLabelDe": "So, 11. Okt 2026",
        "dateLabelEn": "Sun, Oct 11, 2026",
        "dateLabelKr": "10월 11일 (일)",
        "time": "15:00 / 16:00 KST",
        "titleDe": "Seoul English Korean Conversation Café – Sonntags-Runde (317022419)",
        "titleEn": "Seoul English Korean Conversation Café – Sunday Session (317022419)",
        "rsvpUrl": "https://www.meetup.com/seoul-language-exchange-new-friends-jongno-gangnam/events/317022419/",
        "statusNoteDe": "100% Alkoholfrei (Ø 22–23 J.)",
        "statusNoteEn": "100% Alcohol-Free (avg. 22–23 yrs)"
      },
      {
        "date": "2026-10-17",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 17. Okt 2026",
        "dateLabelEn": "Sat, Oct 17, 2026",
        "dateLabelKr": "10월 17일 (토)",
        "time": "14:00 / 16:00 KST",
        "titleDe": "Seoul English Korean Conversation Café – Samstags-Runde (316944820)",
        "titleEn": "Seoul English Korean Conversation Café – Saturday Session (316944820)",
        "rsvpUrl": "https://www.meetup.com/seoul-language-exchange-new-friends-jongno-gangnam/events/316944820/",
        "statusNoteDe": "100% Alkoholfrei (Ø 22–23 J.)",
        "statusNoteEn": "100% Alcohol-Free (avg. 22–23 yrs)"
      },
      {
        "date": "2026-10-18",
        "dayNameDe": "Sonntag",
        "dayNameEn": "Sunday",
        "dayNameKr": "일요일",
        "dateLabelDe": "So, 18. Okt 2026",
        "dateLabelEn": "Sun, Oct 18, 2026",
        "dateLabelKr": "10월 18일 (일)",
        "time": "15:00 / 16:00 KST",
        "titleDe": "Seoul English Korean Conversation Café – Sonntags-Runde (317022419)",
        "titleEn": "Seoul English Korean Conversation Café – Sunday Session (317022419)",
        "rsvpUrl": "https://www.meetup.com/seoul-language-exchange-new-friends-jongno-gangnam/events/317022419/",
        "statusNoteDe": "100% Alkoholfrei (Ø 22–23 J.)",
        "statusNoteEn": "100% Alcohol-Free (avg. 22–23 yrs)"
      },
      {
        "date": "2026-10-24",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 24. Okt 2026",
        "dateLabelEn": "Sat, Oct 24, 2026",
        "dateLabelKr": "10월 24일 (토)",
        "time": "14:00 / 16:00 KST",
        "titleDe": "Seoul English Korean Conversation Café – Samstags-Runde (316944820)",
        "titleEn": "Seoul English Korean Conversation Café – Saturday Session (316944820)",
        "rsvpUrl": "https://www.meetup.com/seoul-language-exchange-new-friends-jongno-gangnam/events/316944820/",
        "statusNoteDe": "100% Alkoholfrei (Ø 22–23 J.)",
        "statusNoteEn": "100% Alcohol-Free (avg. 22–23 yrs)"
      },
      {
        "date": "2026-10-25",
        "dayNameDe": "Sonntag",
        "dayNameEn": "Sunday",
        "dayNameKr": "일요일",
        "dateLabelDe": "So, 25. Okt 2026",
        "dateLabelEn": "Sun, Oct 25, 2026",
        "dateLabelKr": "10월 25일 (일)",
        "time": "15:00 / 16:00 KST",
        "titleDe": "Seoul English Korean Conversation Café – Sonntags-Runde (317022419)",
        "titleEn": "Seoul English Korean Conversation Café – Sunday Session (317022419)",
        "rsvpUrl": "https://www.meetup.com/seoul-language-exchange-new-friends-jongno-gangnam/events/317022419/",
        "statusNoteDe": "100% Alkoholfrei (Ø 22–23 J.)",
        "statusNoteEn": "100% Alcohol-Free (avg. 22–23 yrs)"
      },
      {
        "date": "2026-10-31",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 31. Okt 2026",
        "dateLabelEn": "Sat, Oct 31, 2026",
        "dateLabelKr": "10월 31일 (토)",
        "time": "14:00 / 16:00 KST",
        "titleDe": "Seoul English Korean Conversation Café – Samstags-Runde (316944820)",
        "titleEn": "Seoul English Korean Conversation Café – Saturday Session (316944820)",
        "rsvpUrl": "https://www.meetup.com/seoul-language-exchange-new-friends-jongno-gangnam/events/316944820/",
        "statusNoteDe": "100% Alkoholfrei (Ø 22–23 J.)",
        "statusNoteEn": "100% Alcohol-Free (avg. 22–23 yrs)"
      }
    ]
  },
  {
    "id": "event-social-boardgames-with-koreans-hangang",
    "name": "Board Games with Koreans at Hangang & Seoul Cafe (@hi.gang_korean)",
    "nameDe": "Board Games with Koreans – Han-Fluss Picknick & Café-Spiele-Treff (Alkoholfrei)",
    "nameKr": "한국인과 함께하는 한강 피크닉 & 서울 보드게임 소셜 모임",
    "category": "event_festival",
    "region": "Seoul",
    "district": "Gwangjin-gu (Ttukseom Hangang Park & Konkuk Univ.)",
    "lat": 37.5398,
    "lng": 127.0706,
    "rating": 4.9,
    "reviewCount": 2380,
    "isMustSee": true,
    "isEvent": true,
    "eventType": "outdoor_social",
    "organizer": "Board Game Meetup | Korean & English (@hi.gang_korean)",
    "websiteUrl": "https://www.meetup.com/learn-korean-through-board-games-online-games/events/316956964/",
    "instagramUrl": "https://www.instagram.com/hi.gang_korean/",
    "instagramTag": "한강보드게임",
    "tiktokQuery": "Hangang park picnic board games Seoul",
    "eventUrl": "https://www.meetup.com/learn-korean-through-board-games-online-games/events/316810324/",
    "eventTime": "Sa 16:00 Uhr (Board Games at Hangang `316810324`) & Di/So (Board Games with Koreans `316956964`)",
    "targetAudienceDe": "Koreanische Studierende (20–25 J.) & Internationals – komplett alkoholfrei mit Host @hi.gang_korean!",
    "targetAudienceEn": "Korean students (20–25 yrs) & internationals – 100% alcohol-free board games hosted by @hi.gang_korean!",
    "targetAudienceKr": "한국인 튜터(@hi.gang_korean)와 20대 한국인·외국인이 함께 어울리는 무알콜 한강 피크닉(316810324) 및 카페 보드게임(316956964)",
    "ageRecommendationDe": "🎯 Perfekt für 20–25 Jahre (Ø 22–23 Jahre, 100% Alkoholfrei & Spielerisch)",
    "ageRecommendationEn": "🎯 Best for 20–25 yrs (avg. 22–23 yrs, 100% Alcohol-Free & Activity-Based)",
    "ageRecommendationKr": "🎯 20대 초중반 대학생/청년 (평균 22~23세, 무알콜 보드게임 & 피크닉)",
    "socialTipsDe": "Hier stimmen alle Links 1:1 mit dem Veranstalter überein: „Anmeldung“ öffnet „Board Games at Hangang 🌿🎲“ (`events/316810324`), „Programm“ öffnet „🎲 Board Games with Koreans in Seoul“ (`events/316956964`), und „Instagram“ führt direkt zum offiziellen Host-Account `@hi.gang_korean`!",
    "socialTipsEn": "\"RSVP\" opens \"Board Games at Hangang 🌿🎲\" (`events/316810324`), \"Schedule\" opens \"🎲 Board Games with Koreans in Seoul\" (`events/316956964`), and \"Instagram\" opens the official host `@hi.gang_korean`.",
    "socialTipsKr": "한강 보드게임 피크닉(316810324), 서울 카페 보드게임 모임(316956964) 및 호스트 공식 인스타그램(@hi.gang_korean)으로 정확히 연결됩니다.",
    "description": "Hosted by Korean tutor @hi.gang_korean, this bilingual (Korean & English) group brings together local Koreans and internationals in their 20s for outdoor board games on picnic mats at Hangang Park (`316810324`) and cozy Seoul cafe board game nights (`316956964`).",
    "descriptionDe": "Organisiert von `@hi.gang_korean`: Diese zweisprachige (Koreanisch & Englisch) Community bringt junge Koreaner und Internationals auf Picknickdecken am Han-Fluss (`316810324`) sowie im Café (`316956964`) bei leichten Brettspielen und Eiskaffee zusammen.",
    "photoTips": "Picnic mats on the green lawn of Hangang Park with board games and iced coffees.",
    "photoTipsDe": "Picknickdecken auf der Wiese am Han-Fluss mit Spielen und Eiskaffee.",
    "bestTime": "Sat & Sun Afternoon (14:00 - 18:00)",
    "bestTimeDe": "Samstag- & Sonntagnachmittag (14:00 - 18:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1528605248644-14dd04022da1?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Jayang (Ttukseom Resort) Station (Line 7) Exit 3 / Konkuk Univ. Station (Line 2) Exit 2",
    "feeInfo": "5,000 ~ 10,000 KRW (Includes board game curation & mat/cafe setup)",
    "feeInfoDe": "5.000 ~ 10.000 KRW (inkl. Spielebereitstellung & Moderation)",
    "tags": [
      "Outdoor Social",
      "Alkoholfrei",
      "Korean Locals",
      "Board Games",
      "Hangang Picnic",
      "20s",
      "Must See"
    ],
    "eventDatesDe": "Jeden Sa & So Nachmittag im Oktober 2026 (Alkoholfrei)",
    "eventDatesEn": "Every Sat & Sun Afternoon in October 2026 (Alcohol-Free)",
    "eventDatesKr": "2026년 10월 매주 토/일요일 오후 (무알콜 카페 모임)",
    "upcomingSessions": [
      {
        "date": "2026-10-03",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 03. Okt 2026",
        "dateLabelEn": "Sat, Oct 3, 2026",
        "dateLabelKr": "10월 3일 (토)",
        "time": "14:00 / 16:00 KST",
        "titleDe": "Board Games at Hangang 🌿🎲 | Korean & English Meetup (316810324)",
        "titleEn": "Board Games at Hangang 🌿🎲 | Korean & English Meetup (316810324)",
        "rsvpUrl": "https://www.meetup.com/learn-korean-through-board-games-online-games/events/316810324/",
        "statusNoteDe": "100% Alkoholfrei (Ø 22–23 J.)",
        "statusNoteEn": "100% Alcohol-Free (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/hi.gang_korean/"
      },
      {
        "date": "2026-10-04",
        "dayNameDe": "Sonntag",
        "dayNameEn": "Sunday",
        "dayNameKr": "일요일",
        "dateLabelDe": "So, 04. Okt 2026",
        "dateLabelEn": "Sun, Oct 4, 2026",
        "dateLabelKr": "10월 4일 (일)",
        "time": "15:00 / 16:00 KST",
        "titleDe": "🎲 Board Games with Koreans in Seoul | Café-Runde (316956964)",
        "titleEn": "🎲 Board Games with Koreans in Seoul | Make Friends & Have Fun! (316956964)",
        "rsvpUrl": "https://www.meetup.com/learn-korean-through-board-games-online-games/events/316956964/",
        "statusNoteDe": "100% Alkoholfrei (Ø 22–23 J.)",
        "statusNoteEn": "100% Alcohol-Free (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/hi.gang_korean/"
      },
      {
        "date": "2026-10-10",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 10. Okt 2026",
        "dateLabelEn": "Sat, Oct 10, 2026",
        "dateLabelKr": "10월 10일 (토)",
        "time": "14:00 / 16:00 KST",
        "titleDe": "Board Games at Hangang 🌿🎲 | Korean & English Meetup (316810324)",
        "titleEn": "Board Games at Hangang 🌿🎲 | Korean & English Meetup (316810324)",
        "rsvpUrl": "https://www.meetup.com/learn-korean-through-board-games-online-games/events/316810324/",
        "statusNoteDe": "100% Alkoholfrei (Ø 22–23 J.)",
        "statusNoteEn": "100% Alcohol-Free (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/hi.gang_korean/"
      },
      {
        "date": "2026-10-11",
        "dayNameDe": "Sonntag",
        "dayNameEn": "Sunday",
        "dayNameKr": "일요일",
        "dateLabelDe": "So, 11. Okt 2026",
        "dateLabelEn": "Sun, Oct 11, 2026",
        "dateLabelKr": "10월 11일 (일)",
        "time": "15:00 / 16:00 KST",
        "titleDe": "🎲 Board Games with Koreans in Seoul | Café-Runde (316956964)",
        "titleEn": "🎲 Board Games with Koreans in Seoul | Make Friends & Have Fun! (316956964)",
        "rsvpUrl": "https://www.meetup.com/learn-korean-through-board-games-online-games/events/316956964/",
        "statusNoteDe": "100% Alkoholfrei (Ø 22–23 J.)",
        "statusNoteEn": "100% Alcohol-Free (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/hi.gang_korean/"
      },
      {
        "date": "2026-10-17",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 17. Okt 2026",
        "dateLabelEn": "Sat, Oct 17, 2026",
        "dateLabelKr": "10월 17일 (토)",
        "time": "14:00 / 16:00 KST",
        "titleDe": "Board Games at Hangang 🌿🎲 | Korean & English Meetup (316810324)",
        "titleEn": "Board Games at Hangang 🌿🎲 | Korean & English Meetup (316810324)",
        "rsvpUrl": "https://www.meetup.com/learn-korean-through-board-games-online-games/events/316810324/",
        "statusNoteDe": "100% Alkoholfrei (Ø 22–23 J.)",
        "statusNoteEn": "100% Alcohol-Free (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/hi.gang_korean/"
      },
      {
        "date": "2026-10-18",
        "dayNameDe": "Sonntag",
        "dayNameEn": "Sunday",
        "dayNameKr": "일요일",
        "dateLabelDe": "So, 18. Okt 2026",
        "dateLabelEn": "Sun, Oct 18, 2026",
        "dateLabelKr": "10월 18일 (일)",
        "time": "15:00 / 16:00 KST",
        "titleDe": "🎲 Board Games with Koreans in Seoul | Café-Runde (316956964)",
        "titleEn": "🎲 Board Games with Koreans in Seoul | Make Friends & Have Fun! (316956964)",
        "rsvpUrl": "https://www.meetup.com/learn-korean-through-board-games-online-games/events/316956964/",
        "statusNoteDe": "100% Alkoholfrei (Ø 22–23 J.)",
        "statusNoteEn": "100% Alcohol-Free (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/hi.gang_korean/"
      },
      {
        "date": "2026-10-24",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 24. Okt 2026",
        "dateLabelEn": "Sat, Oct 24, 2026",
        "dateLabelKr": "10월 24일 (토)",
        "time": "14:00 / 16:00 KST",
        "titleDe": "Board Games at Hangang 🌿🎲 | Korean & English Meetup (316810324)",
        "titleEn": "Board Games at Hangang 🌿🎲 | Korean & English Meetup (316810324)",
        "rsvpUrl": "https://www.meetup.com/learn-korean-through-board-games-online-games/events/316810324/",
        "statusNoteDe": "100% Alkoholfrei (Ø 22–23 J.)",
        "statusNoteEn": "100% Alcohol-Free (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/hi.gang_korean/"
      },
      {
        "date": "2026-10-25",
        "dayNameDe": "Sonntag",
        "dayNameEn": "Sunday",
        "dayNameKr": "일요일",
        "dateLabelDe": "So, 25. Okt 2026",
        "dateLabelEn": "Sun, Oct 25, 2026",
        "dateLabelKr": "10월 25일 (일)",
        "time": "15:00 / 16:00 KST",
        "titleDe": "🎲 Board Games with Koreans in Seoul | Café-Runde (316956964)",
        "titleEn": "🎲 Board Games with Koreans in Seoul | Make Friends & Have Fun! (316956964)",
        "rsvpUrl": "https://www.meetup.com/learn-korean-through-board-games-online-games/events/316956964/",
        "statusNoteDe": "100% Alkoholfrei (Ø 22–23 J.)",
        "statusNoteEn": "100% Alcohol-Free (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/hi.gang_korean/"
      },
      {
        "date": "2026-10-31",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 31. Okt 2026",
        "dateLabelEn": "Sat, Oct 31, 2026",
        "dateLabelKr": "10월 31일 (토)",
        "time": "14:00 / 16:00 KST",
        "titleDe": "Board Games at Hangang 🌿🎲 | Korean & English Meetup (316810324)",
        "titleEn": "Board Games at Hangang 🌿🎲 | Korean & English Meetup (316810324)",
        "rsvpUrl": "https://www.meetup.com/learn-korean-through-board-games-online-games/events/316810324/",
        "statusNoteDe": "100% Alkoholfrei (Ø 22–23 J.)",
        "statusNoteEn": "100% Alcohol-Free (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/hi.gang_korean/"
      }
    ]
  },
  {
    "id": "event-social-maju-expat-korean-matchmaking",
    "name": "MAJU (마주) – Curated 1:1 Coffee Date Matchmaking (Foreign Men × Korean Women)",
    "nameDe": "MAJU (마주) – Kuratiertes 1:1 Coffee-Date Matchmaking (Foreign Men × Korean Women)",
    "nameKr": "마주(MAJU) – 외국인 남성 × 한국인 여성 1:1 맞춤형 카페 블라인드 데이트 매칭",
    "category": "event_festival",
    "region": "Seoul",
    "district": "Mapo-gu (Hongdae / Yeonnam-dong) & Gangnam-gu",
    "lat": 37.5542,
    "lng": 126.9255,
    "rating": 4.9,
    "reviewCount": 1940,
    "isMustSee": true,
    "isEvent": true,
    "eventType": "speed_dating",
    "organizer": "MAJU by KOWORK (@kowork_official)",
    "websiteUrl": "https://annyeong-connections.kowork.kr/#how",
    "instagramUrl": "https://www.instagram.com/kowork_official/",
    "instagramTag": "국제커플",
    "tiktokQuery": "Korean girlfriend foreign boyfriend date Seoul",
    "eventUrl": "https://annyeong-connections.kowork.kr/#apply",
    "eventTime": "Jeden Montag 1:1 Match-Vorschlag -> Café-Date am Wochenende (14:00–18:00 Uhr)",
    "targetAudienceDe": "Internationale Männer in den 20ern (wie du mit 23!) & koreanische Frauen, die gezielt einen ausländischen Partner für ein 1:1 Coffee-Date suchen",
    "targetAudienceEn": "Foreign men in their 20s & Korean women specifically looking for curated 1-on-1 offline cafe dates",
    "targetAudienceKr": "외국인 남성과 한국인 여성의 검증된 1:1 맞춤형 카페 소개팅 매칭 서비스 (MAJU by KOWORK)",
    "ageRecommendationDe": "🎯 Perfekt für 21–27 Jahre (Ø 23 Jahre, 100% Alkoholfreies 1:1 Café-Date)",
    "ageRecommendationEn": "🎯 Best for 21–27 yrs (avg. 23 yrs, 100% Alcohol-Free 1:1 Cafe Date)",
    "ageRecommendationKr": "🎯 20대 초중반 맞춤 (무알콜 1:1 카페 블라인드 데이트)",
    "socialTipsDe": "Exakt für Foreign Men × Korean Women gebaut (`annyeong-connections.kowork.kr`): „Anmeldung“ springt direkt zum Bewerbungsbereich (`#apply`), „Programm“ erklärt den genauen Ablauf (`#how`), und „Instagram“ öffnet den offiziellen Account des Betreibers KOWORK (`@kowork_official`).",
    "socialTipsEn": "Built specifically for Foreigners × Koreans (`annyeong-connections.kowork.kr`): \"RSVP\" jumps to `#apply`, \"Schedule\" jumps to `#how` (\"How It Works\"), and \"Instagram\" opens the official operator `@kowork_official`.",
    "socialTipsKr": "코워크(@kowork_official)가 운영하는 외국인×한국인 전용 1:1 매칭 서비스 마주(MAJU)의 신청 섹션(#apply) 및 진행 방식(#how)으로 정확히 이동합니다.",
    "description": "Korea’s dedicated matchmaking service (`annyeong-connections.kowork.kr`) built by KOWORK (`@kowork_official`) specifically to connect foreigners with Korean locals for curated 1-on-1 coffee dates. Trained matchmakers review every profile and send one carefully selected match every Monday.",
    "descriptionDe": "Koreas spezialisierter 1-zu-1-Matchmaking-Service (`annyeong-connections.kowork.kr`) von KOWORK (`@kowork_official`) für Internationals und Koreanerinnen. Echte Matchmaker prüfen dein Profil (Alter, Nicht-Trinker, Interessen) und senden jeden Montag ein handverlesenes 1-zu-1-Match für ein Café-Date in Seoul.",
    "photoTips": "Romantic 1-on-1 table at a sunlit Yeonnam-dong or Seongsu dessert cafe.",
    "photoTipsDe": "Romantischer Zweiertisch in einem sonnigen Café in Yeonnam-dong oder Seongsu.",
    "bestTime": "Weekend Afternoons (14:00 - 18:00)",
    "bestTimeDe": "Wochenend-Nachmittag (14:00 - 18:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1511920170033-f8396924c348?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Hongik Univ. Station (Line 2) Exit 3 (Yeonnam-dong Cafe Street)",
    "feeInfo": "Free to apply (Pay only when a mutual 1:1 cafe date match is confirmed)",
    "feeInfoDe": "Kostenlose Bewerbung (Gebühr erst bei beidseitig bestätigtem 1:1-Café-Match)",
    "tags": [
      "Speed Dating",
      "Foreign Men x Korean Women",
      "Alkoholfrei",
      "Coffee Date",
      "Korean Locals",
      "20s",
      "Must See"
    ],
    "eventDatesDe": "Jeden Sa & So Nachmittag im Oktober 2026 (Alkoholfrei)",
    "eventDatesEn": "Every Sat & Sun Afternoon in October 2026 (Alcohol-Free)",
    "eventDatesKr": "2026년 10월 매주 토/일요일 오후 (무알콜 카페 모임)",
    "upcomingSessions": [
      {
        "date": "2026-10-03",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 03. Okt 2026",
        "dateLabelEn": "Sat, Oct 3, 2026",
        "dateLabelKr": "10월 3일 (토)",
        "time": "14:00 / 16:00 KST",
        "titleDe": "MAJU 1:1 Coffee-Date Match (Foreign Men × Korean Women)",
        "titleEn": "MAJU 1:1 Coffee Date Match (Foreign Men × Korean Women)",
        "rsvpUrl": "https://annyeong-connections.kowork.kr/#apply",
        "statusNoteDe": "100% Alkoholfrei (Ø 22–23 J.)",
        "statusNoteEn": "100% Alcohol-Free (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/kowork_official/"
      },
      {
        "date": "2026-10-04",
        "dayNameDe": "Sonntag",
        "dayNameEn": "Sunday",
        "dayNameKr": "일요일",
        "dateLabelDe": "So, 04. Okt 2026",
        "dateLabelEn": "Sun, Oct 4, 2026",
        "dateLabelKr": "10월 4일 (일)",
        "time": "15:00 / 16:00 KST",
        "titleDe": "MAJU 1:1 Sonntags-Café-Date & Ablauf (#how)",
        "titleEn": "MAJU 1:1 Sunday Cafe Date & How It Works (#how)",
        "rsvpUrl": "https://annyeong-connections.kowork.kr/#how",
        "statusNoteDe": "100% Alkoholfrei (Ø 22–23 J.)",
        "statusNoteEn": "100% Alcohol-Free (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/kowork_official/"
      },
      {
        "date": "2026-10-10",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 10. Okt 2026",
        "dateLabelEn": "Sat, Oct 10, 2026",
        "dateLabelKr": "10월 10일 (토)",
        "time": "14:00 / 16:00 KST",
        "titleDe": "MAJU 1:1 Coffee-Date Match (Foreign Men × Korean Women)",
        "titleEn": "MAJU 1:1 Coffee Date Match (Foreign Men × Korean Women)",
        "rsvpUrl": "https://annyeong-connections.kowork.kr/#apply",
        "statusNoteDe": "100% Alkoholfrei (Ø 22–23 J.)",
        "statusNoteEn": "100% Alcohol-Free (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/kowork_official/"
      },
      {
        "date": "2026-10-11",
        "dayNameDe": "Sonntag",
        "dayNameEn": "Sunday",
        "dayNameKr": "일요일",
        "dateLabelDe": "So, 11. Okt 2026",
        "dateLabelEn": "Sun, Oct 11, 2026",
        "dateLabelKr": "10월 11일 (일)",
        "time": "15:00 / 16:00 KST",
        "titleDe": "MAJU 1:1 Sonntags-Café-Date & Ablauf (#how)",
        "titleEn": "MAJU 1:1 Sunday Cafe Date & How It Works (#how)",
        "rsvpUrl": "https://annyeong-connections.kowork.kr/#how",
        "statusNoteDe": "100% Alkoholfrei (Ø 22–23 J.)",
        "statusNoteEn": "100% Alcohol-Free (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/kowork_official/"
      },
      {
        "date": "2026-10-17",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 17. Okt 2026",
        "dateLabelEn": "Sat, Oct 17, 2026",
        "dateLabelKr": "10월 17일 (토)",
        "time": "14:00 / 16:00 KST",
        "titleDe": "MAJU 1:1 Coffee-Date Match (Foreign Men × Korean Women)",
        "titleEn": "MAJU 1:1 Coffee Date Match (Foreign Men × Korean Women)",
        "rsvpUrl": "https://annyeong-connections.kowork.kr/#apply",
        "statusNoteDe": "100% Alkoholfrei (Ø 22–23 J.)",
        "statusNoteEn": "100% Alcohol-Free (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/kowork_official/"
      },
      {
        "date": "2026-10-18",
        "dayNameDe": "Sonntag",
        "dayNameEn": "Sunday",
        "dayNameKr": "일요일",
        "dateLabelDe": "So, 18. Okt 2026",
        "dateLabelEn": "Sun, Oct 18, 2026",
        "dateLabelKr": "10월 18일 (일)",
        "time": "15:00 / 16:00 KST",
        "titleDe": "MAJU 1:1 Sonntags-Café-Date & Ablauf (#how)",
        "titleEn": "MAJU 1:1 Sunday Cafe Date & How It Works (#how)",
        "rsvpUrl": "https://annyeong-connections.kowork.kr/#how",
        "statusNoteDe": "100% Alkoholfrei (Ø 22–23 J.)",
        "statusNoteEn": "100% Alcohol-Free (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/kowork_official/"
      },
      {
        "date": "2026-10-24",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 24. Okt 2026",
        "dateLabelEn": "Sat, Oct 24, 2026",
        "dateLabelKr": "10월 24일 (토)",
        "time": "14:00 / 16:00 KST",
        "titleDe": "MAJU 1:1 Coffee-Date Match (Foreign Men × Korean Women)",
        "titleEn": "MAJU 1:1 Coffee Date Match (Foreign Men × Korean Women)",
        "rsvpUrl": "https://annyeong-connections.kowork.kr/#apply",
        "statusNoteDe": "100% Alkoholfrei (Ø 22–23 J.)",
        "statusNoteEn": "100% Alcohol-Free (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/kowork_official/"
      },
      {
        "date": "2026-10-25",
        "dayNameDe": "Sonntag",
        "dayNameEn": "Sunday",
        "dayNameKr": "일요일",
        "dateLabelDe": "So, 25. Okt 2026",
        "dateLabelEn": "Sun, Oct 25, 2026",
        "dateLabelKr": "10월 25일 (일)",
        "time": "15:00 / 16:00 KST",
        "titleDe": "MAJU 1:1 Sonntags-Café-Date & Ablauf (#how)",
        "titleEn": "MAJU 1:1 Sunday Cafe Date & How It Works (#how)",
        "rsvpUrl": "https://annyeong-connections.kowork.kr/#how",
        "statusNoteDe": "100% Alkoholfrei (Ø 22–23 J.)",
        "statusNoteEn": "100% Alcohol-Free (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/kowork_official/"
      },
      {
        "date": "2026-10-31",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 31. Okt 2026",
        "dateLabelEn": "Sat, Oct 31, 2026",
        "dateLabelKr": "10월 31일 (토)",
        "time": "14:00 / 16:00 KST",
        "titleDe": "MAJU 1:1 Coffee-Date Match (Foreign Men × Korean Women)",
        "titleEn": "MAJU 1:1 Coffee Date Match (Foreign Men × Korean Women)",
        "rsvpUrl": "https://annyeong-connections.kowork.kr/#apply",
        "statusNoteDe": "100% Alkoholfrei (Ø 22–23 J.)",
        "statusNoteEn": "100% Alcohol-Free (avg. 22–23 yrs)",
        "postUrl": "https://www.instagram.com/kowork_official/"
      }
    ]
  },
  {
    "id": "event-social-soohouse-seoul-singles-mixer",
    "name": "Soo House Weekly Singles Mixer: Korean Women (Free Entry) × Foreign Men",
    "nameDe": "Soo House Weekly Singles Mixer: Koreanische Frauen × Internationale Männer (수하우스)",
    "nameKr": "수하우스(Soo House) 주간 글로벌 싱글즈 파티 (한국인 여성 무료초대 × 외국인 남성)",
    "category": "event_festival",
    "region": "Seoul",
    "district": "Mapo-gu (Hongdae) & Gangnam-gu",
    "lat": 37.5508,
    "lng": 126.9218,
    "rating": 4.8,
    "reviewCount": 2510,
    "isMustSee": true,
    "isEvent": true,
    "eventType": "speed_dating",
    "organizer": "Soo House (@soohouse_official)",
    "websiteUrl": "https://landing.soohouse.app/meetups/649",
    "instagramUrl": "https://www.instagram.com/soohouse_official/",
    "instagramTag": "글로벌파티",
    "tiktokQuery": "Soo House Seoul singles mixer party",
    "eventUrl": "https://landing.soohouse.app/meetups/651",
    "eventTime": "Jeden Samstag 18:00 – 21:30 Uhr (Inkl. Softdrinks, Mocktails & 1:1 Icebreaker-Spielen)",
    "targetAudienceDe": "Koreanische Single-Frauen in den 20ern („Female Guests Wanted — Free Entry!“) & internationale Männer",
    "targetAudienceEn": "Korean single women in their 20s (\"Female Guests Wanted — Free Entry!\") & international men",
    "targetAudienceKr": "한국인 싱글 여성 무료초대(Free Entry)로 성비를 맞춘 외국인 남성 × 한국인 여성 주간 싱글즈 미팅",
    "ageRecommendationDe": "🎯 Perfekt für 20–26 Jahre (Ø 22–24 Jahre, Fokus Foreign Men × Korean Women)",
    "ageRecommendationEn": "🎯 Best for 20–26 yrs (avg. 22–24 yrs, Foreign Men × Korean Women focus)",
    "ageRecommendationKr": "🎯 20대 초중반 싱글 맞춤 (평균 22~24세)",
    "socialTipsDe": "Alle Links gehören direkt zu Soo House: „Anmeldung“ (`landing.soohouse.app/meetups/651`) und „Programm“ (`landing.soohouse.app/meetups/649`) öffnen die offiziellen Event-Seiten „💌 Female Guests Wanted — Free Entry! Weekly Singles Party in Seoul 🇰🇷 | Soo House“, und „Instagram“ öffnet den echten offiziellen Account `@soohouse_official`!",
    "socialTipsEn": "\"RSVP\" (`meetups/651`) and \"Schedule\" (`meetups/649`) open the exact Soo House \"💌 Female Guests Wanted — Free Entry! Weekly Singles Party in Seoul\" pages, and \"Instagram\" opens `@soohouse_official`.",
    "socialTipsKr": "수하우스 공식 싱글즈 파티 예약 페이지(meetups/651, 649) 및 수하우스 공식 인스타그램(@soohouse_official)으로 정확히 연결됩니다.",
    "description": "Soo House’s weekly international singles mixer in Seoul (`landing.soohouse.app/meetups/651` & `649`, Instagram `@soohouse_official`), which actively invites local Korean single women with free entry perks to pair with international men.",
    "descriptionDe": "Das wöchentliche Singles-Event von Soo House (`@soohouse_official`), das durch die Aktion „💌 Female Guests Wanted — Free Entry!“ (`meetups/651` & `649`) gezielt koreanische Single-Frauen in den 20ern mit internationalen Männern zusammenbringt.",
    "photoTips": "Warm lounge gathering with bilingual name tags and conversation cards.",
    "photoTipsDe": "Gemütliche Lounge-Runde mit zweisprachigen Namensschildern und Fragekarten.",
    "bestTime": "Saturday Early Evening (18:00 - 21:30)",
    "bestTimeDe": "Samstag Vorabend (18:00 - 21:30 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Hongik Univ. Station (Line 2) Exit 9 / Gangnam Station (Line 2) Exit 11",
    "feeInfo": "20,000 ~ 25,000 KRW for Men / Free Entry for Female Guests (Includes soft drinks/mocktails)",
    "feeInfoDe": "20.000 ~ 25.000 KRW für Männer / Freier Eintritt für Frauen (inkl. Softdrinks/Mocktails)",
    "tags": [
      "Speed Dating",
      "Foreign Men x Korean Women",
      "Alkoholfrei",
      "Korean Locals",
      "Singles",
      "20s",
      "Must See"
    ],
    "eventDatesDe": "Jeden Samstag im Oktober 2026 (03., 10., 17., 24., 31. Okt)",
    "eventDatesEn": "Every Saturday in October 2026 (Oct 3, Oct 10, Oct 17, Oct 24, Oct 31)",
    "eventDatesKr": "2026년 10월 매주 토요일 (3일, 10일, 17일, 24일, 31일)",
    "upcomingSessions": [
      {
        "date": "2026-10-03",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 03. Okt 2026",
        "dateLabelEn": "Sat, Oct 3, 2026",
        "dateLabelKr": "10월 3일 (토)",
        "time": "18:00 KST",
        "titleDe": "💌 Weekly Singles Party in Seoul (Korean Female Guests Free Entry × Foreign Men)",
        "titleEn": "💌 Weekly Singles Party in Seoul (Korean Female Guests Free Entry × Foreign Men)",
        "rsvpUrl": "https://landing.soohouse.app/meetups/651",
        "statusNoteDe": "Soo House Singles Mixer",
        "statusNoteEn": "Soo House Singles Mixer",
        "postUrl": "https://www.instagram.com/soohouse_official/"
      },
      {
        "date": "2026-10-10",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 10. Okt 2026",
        "dateLabelEn": "Sat, Oct 10, 2026",
        "dateLabelKr": "10월 10일 (토)",
        "time": "18:00 KST",
        "titleDe": "💌 Weekly Singles Party in Seoul (Korean Female Guests Free Entry × Foreign Men)",
        "titleEn": "💌 Weekly Singles Party in Seoul (Korean Female Guests Free Entry × Foreign Men)",
        "rsvpUrl": "https://landing.soohouse.app/meetups/649",
        "statusNoteDe": "Soo House Singles Mixer",
        "statusNoteEn": "Soo House Singles Mixer",
        "postUrl": "https://www.instagram.com/soohouse_official/"
      },
      {
        "date": "2026-10-17",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 17. Okt 2026",
        "dateLabelEn": "Sat, Oct 17, 2026",
        "dateLabelKr": "10월 17일 (토)",
        "time": "18:00 KST",
        "titleDe": "💌 Weekly Singles Party in Seoul (Korean Female Guests Free Entry × Foreign Men)",
        "titleEn": "💌 Weekly Singles Party in Seoul (Korean Female Guests Free Entry × Foreign Men)",
        "rsvpUrl": "https://landing.soohouse.app/meetups/651",
        "statusNoteDe": "Soo House Singles Mixer",
        "statusNoteEn": "Soo House Singles Mixer",
        "postUrl": "https://www.instagram.com/soohouse_official/"
      },
      {
        "date": "2026-10-24",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 24. Okt 2026",
        "dateLabelEn": "Sat, Oct 24, 2026",
        "dateLabelKr": "10월 24일 (토)",
        "time": "18:00 KST",
        "titleDe": "💌 Weekly Singles Party in Seoul (Korean Female Guests Free Entry × Foreign Men)",
        "titleEn": "💌 Weekly Singles Party in Seoul (Korean Female Guests Free Entry × Foreign Men)",
        "rsvpUrl": "https://landing.soohouse.app/meetups/649",
        "statusNoteDe": "Soo House Singles Mixer",
        "statusNoteEn": "Soo House Singles Mixer",
        "postUrl": "https://www.instagram.com/soohouse_official/"
      },
      {
        "date": "2026-10-31",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 31. Okt 2026",
        "dateLabelEn": "Sat, Oct 31, 2026",
        "dateLabelKr": "10월 31일 (토)",
        "time": "18:00 KST",
        "titleDe": "💌 Weekly Singles Party in Seoul (Korean Female Guests Free Entry × Foreign Men)",
        "titleEn": "💌 Weekly Singles Party in Seoul (Korean Female Guests Free Entry × Foreign Men)",
        "rsvpUrl": "https://landing.soohouse.app/meetups/651",
        "statusNoteDe": "Soo House Singles Mixer",
        "statusNoteEn": "Soo House Singles Mixer",
        "postUrl": "https://www.instagram.com/soohouse_official/"
      }
    ]
  },
  {
    "id": "event-social-songdo-cinder-bar",
    "name": "The Cinder Bar Songdo – IGC & Yonsei Exchange Student Social Night (더신더바 송도)",
    "nameDe": "The Cinder Bar Songdo – IGC & Yonsei Austauschstudenten-Pub & Social Night (더신더바 송도)",
    "nameKr": "더신더바 송도 (IGC 글로벌캠퍼스 & 연세대 교환학생 소셜 펍 나이트)",
    "category": "event_festival",
    "region": "Incheon",
    "district": "Yeonsu-gu (Songdo Central Park / Convensia)",
    "lat": 37.3912,
    "lng": 126.6498,
    "rating": 4.9,
    "reviewCount": 1850,
    "isMustSee": true,
    "isEvent": true,
    "isIndoor": true,
    "eventType": "party_mixer",
    "organizer": "The Cinder Bar Songdo (@thecinderbar)",
    "websiteUrl": "https://www.instagram.com/thecinderbar/",
    "instagramUrl": "https://www.instagram.com/thecinderbar/",
    "instagramTag": "송도더신더바",
    "tiktokQuery": "Songdo Cinder Bar Incheon Global Campus",
    "eventUrl": "https://map.naver.com/p/search/%EB%8D%94%EC%8B%A0%EB%8D%94%EB%B0%94%20%EC%86%A1%EB%8F%84",
    "eventTime": "Do, Fr & Sa ab 20:00 – 02:00 Uhr (IGC & Yonsei Student Social Night)",
    "targetAudienceDe": "Austauschstudenten des Incheon Global Campus (SUNY, Utah, George Mason, Ghent), Yonsei YIC & internationale 20-Jährige in Songdo",
    "targetAudienceEn": "Incheon Global Campus (IGC) & Yonsei International Campus exchange students, solo visitors & young expats in Songdo",
    "targetAudienceKr": "인천글로벌캠퍼스(IGC)·연세대 국제캠퍼스 교환학생 및 송도 20대 외국인·한국인 청년",
    "ageRecommendationDe": "🎯 Perfekt für 20–25 Jahre (Ø 22 Jahre – DER Studententreff in Songdo)",
    "ageRecommendationEn": "🎯 Best for 20–25 yrs (avg. 22 yrs – Songdo’s #1 student social bar)",
    "ageRecommendationKr": "🎯 20~25세 대학생/교환학생 맞춤 (평균 22세)",
    "socialTipsDe": "Keine Fahrt nach Seoul nötig! Das inoffizielle Wohnzimmer für alle IGC- und Yonsei-Austauschstudenten in Songdo. Wer alleine an die Bar kommt, bekommt oft einen kleinen Welcome-Pour und wird vom Bar-Team direkt den anderen Studierenden vorgestellt.",
    "socialTipsEn": "No trip to Seoul needed! The unofficial living room for IGC and Yonsei exchange students in Songdo. Solo newcomers are warmly greeted with a welcome pour and immediately introduced to other students at the bar.",
    "socialTipsKr": "서울까지 갈 필요 없는 송도 교환학생들의 성지! 혼자 방문해도 바텐더와 호스트가 웰컴 샷과 함께 자연스럽게 주변 대학생 친구들을 소개해 줍니다.",
    "description": "The cornerstone of Songdo’s international student nightlife. Located minutes from Central Park and the Incheon Global Campus (IGC), The Cinder Bar is famous for its ultra-welcoming community vibe where solo exchange students walk in alone and leave with a close-knit friend group.",
    "descriptionDe": "Das Herzstück der internationalen Studentenszene in Songdo. Nur wenige Minuten vom Incheon Global Campus (IGC) und Yonsei entfernt, ist die Cinder Bar berühmt dafür, dass man als Austauschstudent alleine reingehen kann und garantiert mit neuen Freunden wieder herauskommt.",
    "photoTips": "Warm amber bar lights, craft whiskey shelves, and lively group toasts with global campus students.",
    "photoTipsDe": "Warmes Barlicht, Whisky-Regale und entspannte Gruppenfotos mit internationalen Studierenden.",
    "bestTime": "Thu, Fri & Sat Nights (20:30 - 01:00)",
    "bestTimeDe": "Donnerstag-, Freitag- & Samstagabend (20:30 - 01:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1514933651103-005eec06c04b?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Incheon Nat'l Univ. Station (Incheon Line 1), Exit 4 (Walk 8 min toward Convensia-daero)",
    "feeInfo": "Free Entry (Craft beers & cocktails ~8,000 - 14,000 KRW, complimentary welcome pour)",
    "feeInfoDe": "Freier Eintritt (Drinks ca. 8.000 - 14.000 KRW, oft inkl. gratis Welcome-Pour)",
    "tags": [
      "Songdo",
      "Incheon",
      "Exchange Students",
      "IGC",
      "Yonsei",
      "Social Bar",
      "Solo Friendly",
      "20s",
      "Must See"
    ],
    "eventDatesDe": "Jeden Do, Fr & Sa im Oktober 2026",
    "eventDatesEn": "Every Thu, Fri & Sat in October 2026",
    "eventDatesKr": "2026년 10월 매주 목/금/토요일",
    "upcomingSessions": [
      {
        "date": "2026-10-01",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 01. Okt 2026",
        "dateLabelEn": "Thu, Oct 1, 2026",
        "dateLabelKr": "10월 1일 (목)",
        "time": "20:00 KST",
        "titleDe": "🥃 Cinder Bar Songdo – IGC & Yonsei Exchange Student Thursday Mixer",
        "titleEn": "🥃 Cinder Bar Songdo – IGC & Yonsei Exchange Student Thursday Mixer",
        "rsvpUrl": "https://www.instagram.com/thecinderbar/",
        "statusNoteDe": "Songdo Central Park / IGC Hub",
        "statusNoteEn": "Songdo Central Park / IGC Hub",
        "postUrl": "https://www.instagram.com/thecinderbar/"
      },
      {
        "date": "2026-10-02",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 02. Okt 2026",
        "dateLabelEn": "Fri, Oct 2, 2026",
        "dateLabelKr": "10월 2일 (금)",
        "time": "20:30 KST",
        "titleDe": "🍻 Cinder Bar Songdo – Friday Night Global Campus & Expat Social",
        "titleEn": "🍻 Cinder Bar Songdo – Friday Night Global Campus & Expat Social",
        "rsvpUrl": "https://www.instagram.com/thecinderbar/",
        "statusNoteDe": "Solo-Friendly (Welcome Pour)",
        "statusNoteEn": "Solo-Friendly (Welcome Pour)",
        "postUrl": "https://www.instagram.com/thecinderbar/"
      },
      {
        "date": "2026-10-03",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 03. Okt 2026",
        "dateLabelEn": "Sat, Oct 3, 2026",
        "dateLabelKr": "10월 3일 (토)",
        "time": "20:30 KST",
        "titleDe": "🔥 Cinder Bar Songdo – Saturday Night International Student Hangout",
        "titleEn": "🔥 Cinder Bar Songdo – Saturday Night International Student Hangout",
        "rsvpUrl": "https://www.instagram.com/thecinderbar/",
        "statusNoteDe": "Songdo Central Park / IGC Hub",
        "statusNoteEn": "Songdo Central Park / IGC Hub",
        "postUrl": "https://www.instagram.com/thecinderbar/"
      },
      {
        "date": "2026-10-08",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 08. Okt 2026",
        "dateLabelEn": "Thu, Oct 8, 2026",
        "dateLabelKr": "10월 8일 (목)",
        "time": "20:00 KST",
        "titleDe": "🥃 Cinder Bar Songdo – IGC & Yonsei Exchange Student Thursday Mixer",
        "titleEn": "🥃 Cinder Bar Songdo – IGC & Yonsei Exchange Student Thursday Mixer",
        "rsvpUrl": "https://www.instagram.com/thecinderbar/",
        "statusNoteDe": "Songdo Central Park / IGC Hub",
        "statusNoteEn": "Songdo Central Park / IGC Hub",
        "postUrl": "https://www.instagram.com/thecinderbar/"
      },
      {
        "date": "2026-10-09",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 09. Okt 2026",
        "dateLabelEn": "Fri, Oct 9, 2026",
        "dateLabelKr": "10월 9일 (금)",
        "time": "20:30 KST",
        "titleDe": "🍻 Cinder Bar Songdo – Friday Night Global Campus & Expat Social",
        "titleEn": "🍻 Cinder Bar Songdo – Friday Night Global Campus & Expat Social",
        "rsvpUrl": "https://www.instagram.com/thecinderbar/",
        "statusNoteDe": "Solo-Friendly (Welcome Pour)",
        "statusNoteEn": "Solo-Friendly (Welcome Pour)",
        "postUrl": "https://www.instagram.com/thecinderbar/"
      },
      {
        "date": "2026-10-10",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 10. Okt 2026",
        "dateLabelEn": "Sat, Oct 10, 2026",
        "dateLabelKr": "10월 10일 (토)",
        "time": "20:30 KST",
        "titleDe": "🔥 Cinder Bar Songdo – Saturday Night International Student Hangout",
        "titleEn": "🔥 Cinder Bar Songdo – Saturday Night International Student Hangout",
        "rsvpUrl": "https://www.instagram.com/thecinderbar/",
        "statusNoteDe": "Songdo Central Park / IGC Hub",
        "statusNoteEn": "Songdo Central Park / IGC Hub",
        "postUrl": "https://www.instagram.com/thecinderbar/"
      },
      {
        "date": "2026-10-15",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 15. Okt 2026",
        "dateLabelEn": "Thu, Oct 15, 2026",
        "dateLabelKr": "10월 15일 (목)",
        "time": "20:00 KST",
        "titleDe": "🥃 Cinder Bar Songdo – IGC & Yonsei Exchange Student Thursday Mixer",
        "titleEn": "🥃 Cinder Bar Songdo – IGC & Yonsei Exchange Student Thursday Mixer",
        "rsvpUrl": "https://www.instagram.com/thecinderbar/",
        "statusNoteDe": "Songdo Central Park / IGC Hub",
        "statusNoteEn": "Songdo Central Park / IGC Hub",
        "postUrl": "https://www.instagram.com/thecinderbar/"
      },
      {
        "date": "2026-10-16",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 16. Okt 2026",
        "dateLabelEn": "Fri, Oct 16, 2026",
        "dateLabelKr": "10월 16일 (금)",
        "time": "20:30 KST",
        "titleDe": "🍻 Cinder Bar Songdo – Friday Night Global Campus & Expat Social",
        "titleEn": "🍻 Cinder Bar Songdo – Friday Night Global Campus & Expat Social",
        "rsvpUrl": "https://www.instagram.com/thecinderbar/",
        "statusNoteDe": "Solo-Friendly (Welcome Pour)",
        "statusNoteEn": "Solo-Friendly (Welcome Pour)",
        "postUrl": "https://www.instagram.com/thecinderbar/"
      },
      {
        "date": "2026-10-17",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 17. Okt 2026",
        "dateLabelEn": "Sat, Oct 17, 2026",
        "dateLabelKr": "10월 17일 (토)",
        "time": "20:30 KST",
        "titleDe": "🔥 Cinder Bar Songdo – Saturday Night International Student Hangout",
        "titleEn": "🔥 Cinder Bar Songdo – Saturday Night International Student Hangout",
        "rsvpUrl": "https://www.instagram.com/thecinderbar/",
        "statusNoteDe": "Songdo Central Park / IGC Hub",
        "statusNoteEn": "Songdo Central Park / IGC Hub",
        "postUrl": "https://www.instagram.com/thecinderbar/"
      },
      {
        "date": "2026-10-22",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 22. Okt 2026",
        "dateLabelEn": "Thu, Oct 22, 2026",
        "dateLabelKr": "10월 22일 (목)",
        "time": "20:00 KST",
        "titleDe": "🥃 Cinder Bar Songdo – IGC & Yonsei Exchange Student Thursday Mixer",
        "titleEn": "🥃 Cinder Bar Songdo – IGC & Yonsei Exchange Student Thursday Mixer",
        "rsvpUrl": "https://www.instagram.com/thecinderbar/",
        "statusNoteDe": "Songdo Central Park / IGC Hub",
        "statusNoteEn": "Songdo Central Park / IGC Hub",
        "postUrl": "https://www.instagram.com/thecinderbar/"
      },
      {
        "date": "2026-10-23",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 23. Okt 2026",
        "dateLabelEn": "Fri, Oct 23, 2026",
        "dateLabelKr": "10월 23일 (금)",
        "time": "20:30 KST",
        "titleDe": "🍻 Cinder Bar Songdo – Friday Night Global Campus & Expat Social",
        "titleEn": "🍻 Cinder Bar Songdo – Friday Night Global Campus & Expat Social",
        "rsvpUrl": "https://www.instagram.com/thecinderbar/",
        "statusNoteDe": "Solo-Friendly (Welcome Pour)",
        "statusNoteEn": "Solo-Friendly (Welcome Pour)",
        "postUrl": "https://www.instagram.com/thecinderbar/"
      },
      {
        "date": "2026-10-24",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 24. Okt 2026",
        "dateLabelEn": "Sat, Oct 24, 2026",
        "dateLabelKr": "10월 24일 (토)",
        "time": "20:30 KST",
        "titleDe": "🔥 Cinder Bar Songdo – Saturday Night International Student Hangout",
        "titleEn": "🔥 Cinder Bar Songdo – Saturday Night International Student Hangout",
        "rsvpUrl": "https://www.instagram.com/thecinderbar/",
        "statusNoteDe": "Songdo Central Park / IGC Hub",
        "statusNoteEn": "Songdo Central Park / IGC Hub",
        "postUrl": "https://www.instagram.com/thecinderbar/"
      },
      {
        "date": "2026-10-29",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 29. Okt 2026",
        "dateLabelEn": "Thu, Oct 29, 2026",
        "dateLabelKr": "10월 29일 (목)",
        "time": "20:00 KST",
        "titleDe": "🥃 Cinder Bar Songdo – IGC & Yonsei Exchange Student Thursday Mixer",
        "titleEn": "🥃 Cinder Bar Songdo – IGC & Yonsei Exchange Student Thursday Mixer",
        "rsvpUrl": "https://www.instagram.com/thecinderbar/",
        "statusNoteDe": "Songdo Central Park / IGC Hub",
        "statusNoteEn": "Songdo Central Park / IGC Hub",
        "postUrl": "https://www.instagram.com/thecinderbar/"
      },
      {
        "date": "2026-10-30",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 30. Okt 2026",
        "dateLabelEn": "Fri, Oct 30, 2026",
        "dateLabelKr": "10월 30일 (금)",
        "time": "20:30 KST",
        "titleDe": "🍻 Cinder Bar Songdo – Friday Night Global Campus & Expat Social",
        "titleEn": "🍻 Cinder Bar Songdo – Friday Night Global Campus & Expat Social",
        "rsvpUrl": "https://www.instagram.com/thecinderbar/",
        "statusNoteDe": "Solo-Friendly (Welcome Pour)",
        "statusNoteEn": "Solo-Friendly (Welcome Pour)",
        "postUrl": "https://www.instagram.com/thecinderbar/"
      },
      {
        "date": "2026-10-31",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 31. Okt 2026",
        "dateLabelEn": "Sat, Oct 31, 2026",
        "dateLabelKr": "10월 31일 (토)",
        "time": "20:30 KST",
        "titleDe": "🔥 Cinder Bar Songdo – Saturday Night International Student Hangout",
        "titleEn": "🔥 Cinder Bar Songdo – Saturday Night International Student Hangout",
        "rsvpUrl": "https://www.instagram.com/thecinderbar/",
        "statusNoteDe": "Songdo Central Park / IGC Hub",
        "statusNoteEn": "Songdo Central Park / IGC Hub",
        "postUrl": "https://www.instagram.com/thecinderbar/"
      }
    ]
  },
  {
    "id": "event-social-craic-house-pub-quiz",
    "name": "The Craic House Itaewon – Weekly Thursday English Pub Quiz & Pizza Night",
    "nameDe": "The Craic House Itaewon – Donnerstags-Pub-Quiz auf Englisch & Team-Eisbrecher",
    "nameKr": "이태원 더 크랙 하우스 – 매주 목요일 영어 펍퀴즈 & 피자 소셜 나이트",
    "category": "event_festival",
    "region": "Seoul",
    "district": "Yongsan-gu (Itaewon)",
    "lat": 37.5345,
    "lng": 126.9942,
    "rating": 4.9,
    "reviewCount": 2150,
    "isMustSee": true,
    "isEvent": true,
    "isIndoor": true,
    "eventType": "party_mixer",
    "organizer": "The Craic House Itaewon (@thecraichouse)",
    "websiteUrl": "https://www.instagram.com/thecraichouse/",
    "instagramUrl": "https://www.instagram.com/thecraichouse/",
    "instagramTag": "이태원펍퀴즈",
    "tiktokQuery": "Itaewon pub quiz trivia night Seoul",
    "eventUrl": "https://www.instagram.com/thecraichouse/",
    "eventTime": "Jeden Donnerstag um 20:00 Uhr (Team-Einteilung ab 19:30 Uhr)",
    "targetAudienceDe": "Austauschstudenten, junge Expats & Quiz-Fans, die einen echten Eisbrecher ohne oberflächlichen Club-Lärm suchen",
    "targetAudienceEn": "Exchange students, young expats & trivia lovers wanting an interactive team icebreaker instead of loud clubs",
    "targetAudienceKr": "시끄러운 클럽 대신 팀별 영어 퀴즈 게임을 통해 자연스럽게 친구를 사귀고 싶은 20대 유학생 및 청년",
    "ageRecommendationDe": "🎯 Perfekt für 20–28 Jahre (Ø 23 Jahre – Bester Team-Eisbrecher)",
    "ageRecommendationEn": "🎯 Best for 20–28 yrs (avg. 23 yrs – #1 Team Icebreaker)",
    "ageRecommendationKr": "🎯 20대 대학생/청년 맞춤 (팀 배정 소셜 퀴즈)",
    "socialTipsDe": "Der beste Eisbrecher überhaupt, wenn du keinen Bock auf oberflächlichen Smalltalk hast: Sag dem Quizmaster um 19:30 Uhr einfach, dass du alleine da bist – du wirst sofort einem offenen Tisch von 4–5 Leuten zugeteilt, und ihr rätselt gemeinsam über 5 Runden Popkultur, Musik und Film!",
    "socialTipsEn": "The ultimate antidote to awkward small talk: Tell the quizmaster at 7:30 PM that you came solo and they will immediately seat you with a friendly team of 4–5 players for 5 rounds of pop culture, music, and general trivia.",
    "socialTipsKr": "혼자 가도 퀴즈마스터가 즉석에서 4~5명 팀에 합류시켜 주므로 어색한 스몰토크 없이 5라운드 퀴즈를 함께 풀며 금방 친해집니다.",
    "description": "Seoul’s most beloved weekly English-language pub quiz held every Thursday night at The Craic House in Itaewon. Features 5 interactive rounds of pop culture, music, picture, and general knowledge trivia alongside pizza specials, draft pints, and bar tab prizes.",
    "descriptionDe": "Seouls beliebtestes wöchentliches englisches Pub-Quiz jeden Donnerstagabend im The Craic House Itaewon. 5 interaktive Runden zu Popkultur, Musik und Allgemeinwissen mit Pizza-Specials und Bar-Preisen – man arbeitet als Team zusammen und lernt sich ganz nebenbei kennen.",
    "photoTips": "Team answer sheets, freshly baked pub pizzas, and lively quiz reactions.",
    "photoTipsDe": "Team-Antwortbögen, Pub-Pizza und jubelnde Quiz-Teams bei der Siegerehrung.",
    "bestTime": "Every Thursday (19:30 - 22:30)",
    "bestTimeDe": "Jeden Donnerstag (19:30 - 22:30 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1543007630-9710e4a00a20?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Itaewon Station (Line 6), Exit 4 (Walk 2 min)",
    "feeInfo": "Free / ~5,000 KRW Team Pot + Pub Food & Drinks (Bar tab prizes for top teams)",
    "feeInfoDe": "Freier Eintritt / ~5.000 KRW Team-Pot + eigener Verzehr (Bar-Guthaben als Gewinn)",
    "tags": [
      "Pub Quiz",
      "Trivia Night",
      "Itaewon",
      "Solo Friendly",
      "Team Games",
      "20s",
      "Must See"
    ],
    "eventDatesDe": "Jeden Donnerstag im Oktober 2026 (01., 08., 15., 22., 29. Okt)",
    "eventDatesEn": "Every Thursday in October 2026 (Oct 1, Oct 8, Oct 15, Oct 22, Oct 29)",
    "eventDatesKr": "2026년 10월 매주 목요일 (1일, 8일, 15일, 22일, 29일)",
    "upcomingSessions": [
      {
        "date": "2026-10-01",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 01. Okt 2026",
        "dateLabelEn": "Thu, Oct 1, 2026",
        "dateLabelKr": "10월 1일 (목)",
        "time": "20:00 KST",
        "titleDe": "🍕🧠 The Craic House English Pub Quiz & Team Mixer #1",
        "titleEn": "🍕🧠 The Craic House English Pub Quiz & Team Mixer #1",
        "rsvpUrl": "https://www.instagram.com/thecraichouse/",
        "statusNoteDe": "Solo-Besucher werden Teams zugeteilt",
        "statusNoteEn": "Solo players matched into teams",
        "postUrl": "https://www.instagram.com/thecraichouse/"
      },
      {
        "date": "2026-10-08",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 08. Okt 2026",
        "dateLabelEn": "Thu, Oct 8, 2026",
        "dateLabelKr": "10월 8일 (목)",
        "time": "20:00 KST",
        "titleDe": "🍕🧠 The Craic House English Pub Quiz & Team Mixer #2",
        "titleEn": "🍕🧠 The Craic House English Pub Quiz & Team Mixer #2",
        "rsvpUrl": "https://www.instagram.com/thecraichouse/",
        "statusNoteDe": "Solo-Besucher werden Teams zugeteilt",
        "statusNoteEn": "Solo players matched into teams",
        "postUrl": "https://www.instagram.com/thecraichouse/"
      },
      {
        "date": "2026-10-15",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 15. Okt 2026",
        "dateLabelEn": "Thu, Oct 15, 2026",
        "dateLabelKr": "10월 15일 (목)",
        "time": "20:00 KST",
        "titleDe": "🍕🧠 The Craic House English Pub Quiz & Team Mixer #3",
        "titleEn": "🍕🧠 The Craic House English Pub Quiz & Team Mixer #3",
        "rsvpUrl": "https://www.instagram.com/thecraichouse/",
        "statusNoteDe": "Solo-Besucher werden Teams zugeteilt",
        "statusNoteEn": "Solo players matched into teams",
        "postUrl": "https://www.instagram.com/thecraichouse/"
      },
      {
        "date": "2026-10-22",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 22. Okt 2026",
        "dateLabelEn": "Thu, Oct 22, 2026",
        "dateLabelKr": "10월 22일 (목)",
        "time": "20:00 KST",
        "titleDe": "🍕🧠 The Craic House English Pub Quiz & Team Mixer #4",
        "titleEn": "🍕🧠 The Craic House English Pub Quiz & Team Mixer #4",
        "rsvpUrl": "https://www.instagram.com/thecraichouse/",
        "statusNoteDe": "Solo-Besucher werden Teams zugeteilt",
        "statusNoteEn": "Solo players matched into teams",
        "postUrl": "https://www.instagram.com/thecraichouse/"
      },
      {
        "date": "2026-10-29",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 29. Okt 2026",
        "dateLabelEn": "Thu, Oct 29, 2026",
        "dateLabelKr": "10월 29일 (목)",
        "time": "20:00 KST",
        "titleDe": "🍕🧠 The Craic House English Pub Quiz & Team Mixer #5",
        "titleEn": "🍕🧠 The Craic House English Pub Quiz & Team Mixer #5",
        "rsvpUrl": "https://www.instagram.com/thecraichouse/",
        "statusNoteDe": "Solo-Besucher werden Teams zugeteilt",
        "statusNoteEn": "Solo players matched into teams",
        "postUrl": "https://www.instagram.com/thecraichouse/"
      }
    ]
  },
  {
    "id": "event-social-billion-bar-trivia-comedy",
    "name": "Billion Bar Itaewon – Saturday \"A Billion Questions\" Trivia & Thursday Bilingual Comedy",
    "nameDe": "Billion Bar Itaewon – Samstags-Trivia („A Billion Questions“) & Donnerstags-Comedy-Open-Mic",
    "nameKr": "이태원 빌리언바 – 토요 영어 펍퀴즈 & 목요 한영 코미디 오픈마이크",
    "category": "event_festival",
    "region": "Seoul",
    "district": "Yongsan-gu (Itaewon)",
    "lat": 37.5341,
    "lng": 126.9935,
    "rating": 4.8,
    "reviewCount": 1620,
    "isMustSee": true,
    "isEvent": true,
    "isIndoor": true,
    "eventType": "party_mixer",
    "organizer": "Billion Bar Itaewon & Ryan Williamson",
    "websiteUrl": "https://map.naver.com/p/search/Billion%20Bar%20Itaewon",
    "instagramTag": "이태원빌리언바",
    "tiktokQuery": "Itaewon trivia night comedy open mic Seoul",
    "eventUrl": "https://map.naver.com/p/search/Billion%20Bar%20Itaewon",
    "eventTime": "Jeden Do 20:00 (Bilingual Comedy Open Mic) & Jeden Sa 20:00 („A Billion Questions“ Trivia)",
    "targetAudienceDe": "Internationale Studierende, junge Koreaner & Comedy-/Quiz-Fans in den 20ern",
    "targetAudienceEn": "International students, young bilingual Koreans & comedy/trivia fans in their 20s",
    "targetAudienceKr": "영어·한국어 스탠드업 코미디와 토요 퀴즈 배틀을 즐기는 20대 외국인·한국인 청년",
    "ageRecommendationDe": "🎯 Perfekt für 20–26 Jahre (Ø 22–24 Jahre – Lockerer Bar-Vibe mit Programm)",
    "ageRecommendationEn": "🎯 Best for 20–26 yrs (avg. 22–24 yrs – Chill bar vibe with interactive show)",
    "ageRecommendationKr": "🎯 20대 대학생/청년 맞춤 (코미디 & 퀴즈 소셜 바)",
    "socialTipsDe": "Zwei feste Wochen-Events mit echtem Inhalt: Donnerstags treten bei „A Million Laughs“ englisch- und koreanischsprachige Newcomer-Comedians auf, samstags um 20:00 Uhr startet das rasante „A Billion Questions“ Trivia um Frei-Shots und Bar-Tabs.",
    "socialTipsEn": "Two concrete weekly events: Thursday nights feature \"A Million Laughs\" bilingual (EN/KR) stand-up open mic, while Saturday nights at 8 PM host \"A Billion Questions\" trivia battling for bar tabs and shots.",
    "socialTipsKr": "매주 목요일 밤에는 한영 바이링구얼 스탠드업 코미디 오픈마이크가, 토요일 저녁 8시에는 바 탭과 샷을 건 퀴즈 대결이 열립니다.",
    "description": "A lively underground social bar in Itaewon hosting two signature weekly community events: Thursday night bilingual (English & Korean) comedy open mics (\"A Million Laughs\") and Saturday night competitive pub trivia (\"A Billion Questions\" hosted by Ryan Williamson).",
    "descriptionDe": "Beliebte Social-Bar in Itaewon mit zwei festen wöchentlichen Events: Jeden Donnerstag zweisprachiges Stand-up-Comedy Open Mic („A Million Laughs“) und jeden Samstag ab 20:00 Uhr das Pub-Quiz „A Billion Questions“ mit Bar-Guthaben als Gewinn.",
    "photoTips": "Neon stage mic during Thursday comedy sets and scoreboard rounds on Saturday trivia night.",
    "photoTipsDe": "Das beleuchtete Bühnenmikrofon beim Comedy-Open-Mic und die Quiz-Scoreboards am Samstag.",
    "bestTime": "Thu & Sat Evenings (19:30 - 23:00)",
    "bestTimeDe": "Donnerstag- & Samstagabend (19:30 - 23:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1585699324551-f6c309eedeca?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Itaewon Station (Line 6), Exit 3 (Walk 4 min)",
    "feeInfo": "Free Entry (Buy 1 drink at the bar, ~7,000 - 12,000 KRW)",
    "feeInfoDe": "Freier Eintritt (1 Getränk an der Bar, ca. 7.000 - 12.000 KRW)",
    "tags": [
      "Trivia Night",
      "Stand-Up Comedy",
      "Open Mic",
      "Itaewon",
      "Bilingual",
      "20s",
      "Must See"
    ],
    "eventDatesDe": "Jeden Donnerstag & Samstag/Sonntag im Oktober 2026",
    "eventDatesEn": "Every Thursday & Weekend in October 2026",
    "eventDatesKr": "2026년 10월 매주 목요일 & 주말",
    "upcomingSessions": [
      {
        "date": "2026-10-01",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 01. Okt 2026",
        "dateLabelEn": "Thu, Oct 1, 2026",
        "dateLabelKr": "10월 1일 (목)",
        "time": "20:00 KST",
        "titleDe": "🎙️ Billion Bar Itaewon – \"A Million Laughs\" Bilingual (EN/KR) Comedy Open Mic",
        "titleEn": "🎙️ Billion Bar Itaewon – \"A Million Laughs\" Bilingual (EN/KR) Comedy Open Mic",
        "rsvpUrl": "https://map.naver.com/p/search/Billion%20Bar%20Itaewon",
        "statusNoteDe": "Zweisprachiges Open Mic (Eintritt frei)",
        "statusNoteEn": "Bilingual Open Mic (Free Entry)"
      },
      {
        "date": "2026-10-03",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 03. Okt 2026",
        "dateLabelEn": "Sat, Oct 3, 2026",
        "dateLabelKr": "10월 3일 (토)",
        "time": "20:00 KST",
        "titleDe": "🧠🍻 Billion Bar Itaewon – \"A Billion Questions\" Saturday Trivia Night",
        "titleEn": "🧠🍻 Billion Bar Itaewon – \"A Billion Questions\" Saturday Trivia Night",
        "rsvpUrl": "https://map.naver.com/p/search/Billion%20Bar%20Itaewon",
        "statusNoteDe": "Einlass 19:00 / Start 20:00 (Bar-Tab Preise)",
        "statusNoteEn": "Doors 7 PM / Trivia 8 PM (Bar Tab Prizes)"
      },
      {
        "date": "2026-10-08",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 08. Okt 2026",
        "dateLabelEn": "Thu, Oct 8, 2026",
        "dateLabelKr": "10월 8일 (목)",
        "time": "20:00 KST",
        "titleDe": "🎙️ Billion Bar Itaewon – \"A Million Laughs\" Bilingual (EN/KR) Comedy Open Mic",
        "titleEn": "🎙️ Billion Bar Itaewon – \"A Million Laughs\" Bilingual (EN/KR) Comedy Open Mic",
        "rsvpUrl": "https://map.naver.com/p/search/Billion%20Bar%20Itaewon",
        "statusNoteDe": "Zweisprachiges Open Mic (Eintritt frei)",
        "statusNoteEn": "Bilingual Open Mic (Free Entry)"
      },
      {
        "date": "2026-10-10",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 10. Okt 2026",
        "dateLabelEn": "Sat, Oct 10, 2026",
        "dateLabelKr": "10월 10일 (토)",
        "time": "20:00 KST",
        "titleDe": "🧠🍻 Billion Bar Itaewon – \"A Billion Questions\" Saturday Trivia Night",
        "titleEn": "🧠🍻 Billion Bar Itaewon – \"A Billion Questions\" Saturday Trivia Night",
        "rsvpUrl": "https://map.naver.com/p/search/Billion%20Bar%20Itaewon",
        "statusNoteDe": "Einlass 19:00 / Start 20:00 (Bar-Tab Preise)",
        "statusNoteEn": "Doors 7 PM / Trivia 8 PM (Bar Tab Prizes)"
      },
      {
        "date": "2026-10-15",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 15. Okt 2026",
        "dateLabelEn": "Thu, Oct 15, 2026",
        "dateLabelKr": "10월 15일 (목)",
        "time": "20:00 KST",
        "titleDe": "🎙️ Billion Bar Itaewon – \"A Million Laughs\" Bilingual (EN/KR) Comedy Open Mic",
        "titleEn": "🎙️ Billion Bar Itaewon – \"A Million Laughs\" Bilingual (EN/KR) Comedy Open Mic",
        "rsvpUrl": "https://map.naver.com/p/search/Billion%20Bar%20Itaewon",
        "statusNoteDe": "Zweisprachiges Open Mic (Eintritt frei)",
        "statusNoteEn": "Bilingual Open Mic (Free Entry)"
      },
      {
        "date": "2026-10-17",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 17. Okt 2026",
        "dateLabelEn": "Sat, Oct 17, 2026",
        "dateLabelKr": "10월 17일 (토)",
        "time": "20:00 KST",
        "titleDe": "🧠🍻 Billion Bar Itaewon – \"A Billion Questions\" Saturday Trivia Night",
        "titleEn": "🧠🍻 Billion Bar Itaewon – \"A Billion Questions\" Saturday Trivia Night",
        "rsvpUrl": "https://map.naver.com/p/search/Billion%20Bar%20Itaewon",
        "statusNoteDe": "Einlass 19:00 / Start 20:00 (Bar-Tab Preise)",
        "statusNoteEn": "Doors 7 PM / Trivia 8 PM (Bar Tab Prizes)"
      },
      {
        "date": "2026-10-22",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 22. Okt 2026",
        "dateLabelEn": "Thu, Oct 22, 2026",
        "dateLabelKr": "10월 22일 (목)",
        "time": "20:00 KST",
        "titleDe": "🎙️ Billion Bar Itaewon – \"A Million Laughs\" Bilingual (EN/KR) Comedy Open Mic",
        "titleEn": "🎙️ Billion Bar Itaewon – \"A Million Laughs\" Bilingual (EN/KR) Comedy Open Mic",
        "rsvpUrl": "https://map.naver.com/p/search/Billion%20Bar%20Itaewon",
        "statusNoteDe": "Zweisprachiges Open Mic (Eintritt frei)",
        "statusNoteEn": "Bilingual Open Mic (Free Entry)"
      },
      {
        "date": "2026-10-24",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 24. Okt 2026",
        "dateLabelEn": "Sat, Oct 24, 2026",
        "dateLabelKr": "10월 24일 (토)",
        "time": "20:00 KST",
        "titleDe": "🧠🍻 Billion Bar Itaewon – \"A Billion Questions\" Saturday Trivia Night",
        "titleEn": "🧠🍻 Billion Bar Itaewon – \"A Billion Questions\" Saturday Trivia Night",
        "rsvpUrl": "https://map.naver.com/p/search/Billion%20Bar%20Itaewon",
        "statusNoteDe": "Einlass 19:00 / Start 20:00 (Bar-Tab Preise)",
        "statusNoteEn": "Doors 7 PM / Trivia 8 PM (Bar Tab Prizes)"
      },
      {
        "date": "2026-10-29",
        "dayNameDe": "Donnerstag",
        "dayNameEn": "Thursday",
        "dayNameKr": "목요일",
        "dateLabelDe": "Do, 29. Okt 2026",
        "dateLabelEn": "Thu, Oct 29, 2026",
        "dateLabelKr": "10월 29일 (목)",
        "time": "20:00 KST",
        "titleDe": "🎙️ Billion Bar Itaewon – \"A Million Laughs\" Bilingual (EN/KR) Comedy Open Mic",
        "titleEn": "🎙️ Billion Bar Itaewon – \"A Million Laughs\" Bilingual (EN/KR) Comedy Open Mic",
        "rsvpUrl": "https://map.naver.com/p/search/Billion%20Bar%20Itaewon",
        "statusNoteDe": "Zweisprachiges Open Mic (Eintritt frei)",
        "statusNoteEn": "Bilingual Open Mic (Free Entry)"
      },
      {
        "date": "2026-10-31",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 31. Okt 2026",
        "dateLabelEn": "Sat, Oct 31, 2026",
        "dateLabelKr": "10월 31일 (토)",
        "time": "20:00 KST",
        "titleDe": "🧠🍻 Billion Bar Itaewon – \"A Billion Questions\" Saturday Trivia Night",
        "titleEn": "🧠🍻 Billion Bar Itaewon – \"A Billion Questions\" Saturday Trivia Night",
        "rsvpUrl": "https://map.naver.com/p/search/Billion%20Bar%20Itaewon",
        "statusNoteDe": "Einlass 19:00 / Start 20:00 (Bar-Tab Preise)",
        "statusNoteEn": "Doors 7 PM / Trivia 8 PM (Bar Tab Prizes)"
      }
    ]
  },
  {
    "id": "event-social-standup-seoul-lit-lounge",
    "name": "Stand Up Seoul @ Lit Lounge – Sunday English Comedy Supper Club Open Mic",
    "nameDe": "Stand Up Seoul @ Lit Lounge – Sonntags-Stand-up-Comedy Open Mic & Social Lounge (Eintritt frei)",
    "nameKr": "스탠드업 서울 릿라운지 이태원 – 매주 일요일 영어 코미디 오픈마이크",
    "category": "event_festival",
    "region": "Seoul",
    "district": "Yongsan-gu (Itaewon)",
    "lat": 37.5338,
    "lng": 126.9928,
    "rating": 4.9,
    "reviewCount": 2890,
    "isMustSee": true,
    "isEvent": true,
    "isIndoor": true,
    "eventType": "party_mixer",
    "organizer": "Stand Up Seoul (@standupseoul_official / @litlounge_itw)",
    "websiteUrl": "https://www.standup-seoul.com/",
    "instagramUrl": "https://www.instagram.com/standupseoul_official/",
    "instagramTag": "스탠드업서울",
    "tiktokQuery": "Stand Up Seoul Lit Lounge Itaewon comedy",
    "eventUrl": "https://www.meetup.com/stand-up-seoul/",
    "eventTime": "Jeden Sonntag um 20:00 Uhr (Sign-up & Socializing ab 19:30 Uhr)",
    "targetAudienceDe": "Junge Internationals, Austauschstudenten, Kreative & zweisprachige Koreaner in den 20ern",
    "targetAudienceEn": "Young internationals, exchange students, creatives & bilingual Koreans in their 20s",
    "targetAudienceKr": "영어 스탠드업 코미디를 즐기며 외국인·한국인 친구들과 어울리고 싶은 20대 청년",
    "ageRecommendationDe": "🎯 Perfekt für 20–27 Jahre (Ø 23 Jahre – Entspannter Sonntags-Ausklang)",
    "ageRecommendationEn": "🎯 Best for 20–27 yrs (avg. 23 yrs – Best Sunday night community hangout)",
    "ageRecommendationKr": "🎯 20대 청년/유학생 맞춤 (무료 입장 일요 코미디 라운지)",
    "socialTipsDe": "Eintritt komplett frei! Jeden Sonntag testen hier 8–12 englischsprachige Comedians für je 5 Minuten neues Material. Durch das Crowd-Work-Format und die Lounge-Bestuhlung kommt man sofort mit dem Nachbartisch ins Gespräch, und nach der Show bleiben fast alle noch auf einen Drink.",
    "socialTipsEn": "100% free admission! Every Sunday night, 8–12 English-speaking comics test 5 minutes of material. Crowd-work interactions and cozy lounge tables make it effortless to chat with people next to you after the show.",
    "socialTipsKr": "입장료 무료! 매주 일요일 밤 8~12명의 영어 코미디언이 5분씩 신작 개그를 선보이며, 공연 후 자연스럽게 주변 관객들과 대화를 나누기 좋습니다.",
    "description": "Hosted every Sunday at 8:00 PM at Lit Lounge in Itaewon by Stand Up Seoul (standup-seoul.com), Korea’s premier English stand-up comedy collective. Free admission with an upbeat, welcoming crowd of exchange students, expats, and locals.",
    "descriptionDe": "Jeden Sonntag um 20:00 Uhr in der Lit Lounge Itaewon, organisiert von Stand Up Seoul (standup-seoul.com). Kostenloser Eintritt, erstklassige Stimmung und ein junges, witziges Publikum aus Austauschstudenten, Kreativen und Koreanern.",
    "photoTips": "Comedian under the spotlight with the neon Lit Lounge backdrop.",
    "photoTipsDe": "Comedians im Scheinwerferlicht vor der Neon-Kulisse der Lit Lounge.",
    "bestTime": "Every Sunday Evening (19:30 - 22:30)",
    "bestTimeDe": "Jeden Sonntagabend (19:30 - 22:30 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1516280440614-37939bbacd81?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Itaewon Station (Line 6), Exit 4 (Walk 3 min)",
    "feeInfo": "Free Admission (Support the venue with 1 drink/food order)",
    "feeInfoDe": "Eintritt frei (1 Getränk oder Snack an der Bar bestellen)",
    "tags": [
      "Stand-Up Comedy",
      "Open Mic",
      "Free Entry",
      "Itaewon",
      "Lit Lounge",
      "20s",
      "Must See"
    ],
    "eventDatesDe": "Jeden Sonntag im Oktober 2026 (04., 11., 18., 25. Okt)",
    "eventDatesEn": "Every Sunday in October 2026 (Oct 4, Oct 11, Oct 18, Oct 25)",
    "eventDatesKr": "2026년 10월 매주 일요일 (4일, 11일, 18일, 25일)",
    "upcomingSessions": [
      {
        "date": "2026-10-04",
        "dayNameDe": "Sonntag",
        "dayNameEn": "Sunday",
        "dayNameKr": "일요일",
        "dateLabelDe": "So, 04. Okt 2026",
        "dateLabelEn": "Sun, Oct 4, 2026",
        "dateLabelKr": "10월 4일 (일)",
        "time": "20:00 KST",
        "titleDe": "🎤 Comedy Supper Club Open Mic @ Lit Lounge Itaewon #1 (Eintritt frei)",
        "titleEn": "🎤 Comedy Supper Club Open Mic @ Lit Lounge Itaewon #1 (Free Entry)",
        "rsvpUrl": "https://www.standup-seoul.com/",
        "statusNoteDe": "Sign-up 19:30 / Show 20:00",
        "statusNoteEn": "Sign-up 19:30 / Show 20:00",
        "postUrl": "https://www.instagram.com/standupseoul_official/"
      },
      {
        "date": "2026-10-11",
        "dayNameDe": "Sonntag",
        "dayNameEn": "Sunday",
        "dayNameKr": "일요일",
        "dateLabelDe": "So, 11. Okt 2026",
        "dateLabelEn": "Sun, Oct 11, 2026",
        "dateLabelKr": "10월 11일 (일)",
        "time": "20:00 KST",
        "titleDe": "🎤 Comedy Supper Club Open Mic @ Lit Lounge Itaewon #2 (Eintritt frei)",
        "titleEn": "🎤 Comedy Supper Club Open Mic @ Lit Lounge Itaewon #2 (Free Entry)",
        "rsvpUrl": "https://www.standup-seoul.com/",
        "statusNoteDe": "Sign-up 19:30 / Show 20:00",
        "statusNoteEn": "Sign-up 19:30 / Show 20:00",
        "postUrl": "https://www.instagram.com/standupseoul_official/"
      },
      {
        "date": "2026-10-18",
        "dayNameDe": "Sonntag",
        "dayNameEn": "Sunday",
        "dayNameKr": "일요일",
        "dateLabelDe": "So, 18. Okt 2026",
        "dateLabelEn": "Sun, Oct 18, 2026",
        "dateLabelKr": "10월 18일 (일)",
        "time": "20:00 KST",
        "titleDe": "🎤 Comedy Supper Club Open Mic @ Lit Lounge Itaewon #3 (Eintritt frei)",
        "titleEn": "🎤 Comedy Supper Club Open Mic @ Lit Lounge Itaewon #3 (Free Entry)",
        "rsvpUrl": "https://www.standup-seoul.com/",
        "statusNoteDe": "Sign-up 19:30 / Show 20:00",
        "statusNoteEn": "Sign-up 19:30 / Show 20:00",
        "postUrl": "https://www.instagram.com/standupseoul_official/"
      },
      {
        "date": "2026-10-25",
        "dayNameDe": "Sonntag",
        "dayNameEn": "Sunday",
        "dayNameKr": "일요일",
        "dateLabelDe": "So, 25. Okt 2026",
        "dateLabelEn": "Sun, Oct 25, 2026",
        "dateLabelKr": "10월 25일 (일)",
        "time": "20:00 KST",
        "titleDe": "🎤 Comedy Supper Club Open Mic @ Lit Lounge Itaewon #4 (Eintritt frei)",
        "titleEn": "🎤 Comedy Supper Club Open Mic @ Lit Lounge Itaewon #4 (Free Entry)",
        "rsvpUrl": "https://www.standup-seoul.com/",
        "statusNoteDe": "Sign-up 19:30 / Show 20:00",
        "statusNoteEn": "Sign-up 19:30 / Show 20:00",
        "postUrl": "https://www.instagram.com/standupseoul_official/"
      }
    ]
  },
  {
    "id": "event-social-seoul-city-improv",
    "name": "Seoul City Improv (SCI) – Weekly Live Improv Comedy Show & Open Community Jam",
    "nameDe": "Seoul City Improv (SCI) – Wöchentliche Improv-Comedy-Show & Offener Mitmach-Jam",
    "nameKr": "서울 시티 임프로브 (SCI) – 주간 영어 즉흥 코미디 쇼 & 커뮤니티 오픈 잼",
    "category": "event_festival",
    "region": "Seoul",
    "district": "Yongsan-gu (Haebangchon / Itaewon)",
    "lat": 37.5415,
    "lng": 126.9876,
    "rating": 4.9,
    "reviewCount": 1420,
    "isMustSee": true,
    "isEvent": true,
    "isIndoor": true,
    "eventType": "party_mixer",
    "organizer": "Seoul City Improv (@seoulcityimprov)",
    "websiteUrl": "https://www.seoulcityimprov.com/",
    "instagramUrl": "https://www.instagram.com/seoulcityimprov/",
    "instagramTag": "서울임프로브",
    "tiktokQuery": "Seoul City Improv comedy show",
    "eventUrl": "https://www.seoulcityimprov.com/",
    "eventTime": "Samstags ab 19:30 Uhr (Offener Improv-Jam & Live-Comedy-Show)",
    "targetAudienceDe": "Austauschstudenten & junge Expats, die Lust auf interaktiven Spaß, Lachen und echte Leute ohne Oberflächlichkeit haben",
    "targetAudienceEn": "Exchange students & young expats looking for interactive comedy games, big laughs, and genuine people",
    "targetAudienceKr": "즉흥 코미디 게임과 공연을 통해 유쾌하고 진솔한 외국인·한국인 친구를 만나고 싶은 20대",
    "ageRecommendationDe": "🎯 Perfekt für 20–28 Jahre (Ø 23 Jahre – Null Vorerfahrung nötig!)",
    "ageRecommendationEn": "🎯 Best for 20–28 yrs (avg. 23 yrs – Zero experience needed!)",
    "ageRecommendationKr": "🎯 20대 청년 맞춤 (초보자 환영 즉흥 코미디 잼)",
    "socialTipsDe": "Bei den offenen Community-Jams von Seoul City Improv (seoulcityimprov.com) kannst du ganz ohne Bühnenerfahrung bei einfachen, urkomischen Impro-Spielen mitmachen oder einfach zuschauen. Weil man zusammen lacht, bricht das Eis in 5 Minuten.",
    "socialTipsEn": "At Seoul City Improv’s community jams (seoulcityimprov.com), you can jump into easy, hilarious short-form improv games with zero experience or just watch the live show with a drink.",
    "socialTipsKr": "연기 경험이 전혀 없어도 가벼운 즉흥 게임에 참여하거나 관객으로 웃으며 5분 만에 새로운 친구들과 친해질 수 있습니다.",
    "description": "Korea’s longest-running English-language improv comedy organization (seoulcityimprov.com). Hosts regular Saturday night live improv comedy shows and open community jams where anyone can join fun warm-up games and meet creative, open-minded peers.",
    "descriptionDe": "Koreas führende englischsprachige Improv-Comedy-Community (seoulcityimprov.com). Veranstaltet wöchentliche Live-Improv-Shows und offene Mitmach-Jams, bei denen man spielerisch und komplett ungezwungen neue Leute kennenlernt.",
    "photoTips": "Action shots of on-stage improv games and post-show group drinks.",
    "photoTipsDe": "Lebendige Bühnenmomente bei den Improv-Spielen und das gemeinsame Anstoßen danach.",
    "bestTime": "Saturday Evenings (19:30 - 22:00)",
    "bestTimeDe": "Samstagabend (19:30 - 22:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Noksapyeong Station (Line 6), Exit 2 (Walk 6 min toward Haebangchon)",
    "feeInfo": "10,000 ~ 15,000 KRW (Open Jams often free or 1 drink minimum)",
    "feeInfoDe": "10.000 ~ 15.000 KRW (Offene Jams oft kostenlos bzw. 1 Mindestgetränk)",
    "tags": [
      "Improv Comedy",
      "Interactive Games",
      "Haebangchon",
      "Itaewon",
      "Creative Community",
      "20s",
      "Must See"
    ],
    "eventDatesDe": "Jeden Samstag im Oktober 2026 (03., 10., 17., 24., 31. Okt)",
    "eventDatesEn": "Every Saturday in October 2026 (Oct 3, Oct 10, Oct 17, Oct 24, Oct 31)",
    "eventDatesKr": "2026년 10월 매주 토요일 (3일, 10일, 17일, 24일, 31일)",
    "upcomingSessions": [
      {
        "date": "2026-10-03",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 03. Okt 2026",
        "dateLabelEn": "Sat, Oct 3, 2026",
        "dateLabelKr": "10월 3일 (토)",
        "time": "19:30 KST",
        "titleDe": "🎭 Seoul City Improv – Live Comedy Show & Open Community Jam #1",
        "titleEn": "🎭 Seoul City Improv – Live Comedy Show & Open Community Jam #1",
        "rsvpUrl": "https://www.seoulcityimprov.com/",
        "statusNoteDe": "Offener Mitmach-Jam & Show",
        "statusNoteEn": "Open Improv Jam & Live Show",
        "postUrl": "https://www.instagram.com/seoulcityimprov/"
      },
      {
        "date": "2026-10-10",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 10. Okt 2026",
        "dateLabelEn": "Sat, Oct 10, 2026",
        "dateLabelKr": "10월 10일 (토)",
        "time": "19:30 KST",
        "titleDe": "🎭 Seoul City Improv – Live Comedy Show & Open Community Jam #2",
        "titleEn": "🎭 Seoul City Improv – Live Comedy Show & Open Community Jam #2",
        "rsvpUrl": "https://www.seoulcityimprov.com/",
        "statusNoteDe": "Offener Mitmach-Jam & Show",
        "statusNoteEn": "Open Improv Jam & Live Show",
        "postUrl": "https://www.instagram.com/seoulcityimprov/"
      },
      {
        "date": "2026-10-17",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 17. Okt 2026",
        "dateLabelEn": "Sat, Oct 17, 2026",
        "dateLabelKr": "10월 17일 (토)",
        "time": "19:30 KST",
        "titleDe": "🎭 Seoul City Improv – Live Comedy Show & Open Community Jam #3",
        "titleEn": "🎭 Seoul City Improv – Live Comedy Show & Open Community Jam #3",
        "rsvpUrl": "https://www.seoulcityimprov.com/",
        "statusNoteDe": "Offener Mitmach-Jam & Show",
        "statusNoteEn": "Open Improv Jam & Live Show",
        "postUrl": "https://www.instagram.com/seoulcityimprov/"
      },
      {
        "date": "2026-10-24",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 24. Okt 2026",
        "dateLabelEn": "Sat, Oct 24, 2026",
        "dateLabelKr": "10월 24일 (토)",
        "time": "19:30 KST",
        "titleDe": "🎭 Seoul City Improv – Live Comedy Show & Open Community Jam #4",
        "titleEn": "🎭 Seoul City Improv – Live Comedy Show & Open Community Jam #4",
        "rsvpUrl": "https://www.seoulcityimprov.com/",
        "statusNoteDe": "Offener Mitmach-Jam & Show",
        "statusNoteEn": "Open Improv Jam & Live Show",
        "postUrl": "https://www.instagram.com/seoulcityimprov/"
      },
      {
        "date": "2026-10-31",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 31. Okt 2026",
        "dateLabelEn": "Sat, Oct 31, 2026",
        "dateLabelKr": "10월 31일 (토)",
        "time": "19:30 KST",
        "titleDe": "🎭 Seoul City Improv – Live Comedy Show & Open Community Jam #5",
        "titleEn": "🎭 Seoul City Improv – Live Comedy Show & Open Community Jam #5",
        "rsvpUrl": "https://www.seoulcityimprov.com/",
        "statusNoteDe": "Offener Mitmach-Jam & Show",
        "statusNoteEn": "Open Improv Jam & Live Show",
        "postUrl": "https://www.instagram.com/seoulcityimprov/"
      }
    ]
  },
  {
    "id": "event-social-songdo-climb-square-bouldering",
    "name": "Climb Square Songdo – Triple Street Bouldering & Exchange Student Social Climb",
    "nameDe": "Climb Square Songdo – Bouldern & Student Social Session (Triple Street Incheon)",
    "nameKr": "클라임스퀘어 송도점 – 트리플스트리트 볼더링 & 20대 클라이밍 소셜 세션",
    "category": "event_festival",
    "region": "Incheon",
    "district": "Yeonsu-gu (Songdo Triple Street)",
    "lat": 37.3802,
    "lng": 126.6588,
    "rating": 4.9,
    "reviewCount": 3120,
    "isMustSee": true,
    "isEvent": true,
    "isIndoor": true,
    "eventType": "outdoor_social",
    "organizer": "Climb Square Songdo (@climbsquare_songdo)",
    "websiteUrl": "http://www.climbsquare.com/",
    "instagramUrl": "https://www.instagram.com/climbsquare_songdo/",
    "instagramTag": "클라임스퀘어송도",
    "tiktokQuery": "Climb Square Songdo Triple Street bouldering",
    "eventUrl": "https://map.naver.com/p/entry/place/916434510",
    "eventTime": "Mi 19:30 Uhr (After-Class Bouldering) & Sa 15:00 Uhr (Weekend Social Climb)",
    "targetAudienceDe": "IGC- & Yonsei-Studierende sowie sportliche 20-jährige Koreaner aus Songdo – 100% aktiv & alkoholfrei",
    "targetAudienceEn": "IGC & Yonsei students plus active Korean 20-somethings in Songdo – 100% active & alcohol-free",
    "targetAudienceKr": "송도 대학생(IGC/연세대) 및 20대 로컬 클라이머들이 함께 문제를 풀며 친해지는 볼더링 세션",
    "ageRecommendationDe": "🎯 Perfekt für 19–26 Jahre (Ø 22 Jahre – Sportlicher Treff direkt in Songdo)",
    "ageRecommendationEn": "🎯 Best for 19–26 yrs (avg. 22 yrs – Active hangout right in Songdo)",
    "ageRecommendationKr": "🎯 20대 대학생/청년 맞춤 (송도 트리플스트리트 실내 클라이밍)",
    "socialTipsDe": "Direkt in der Triple Street Mall (Building D, B1) neben dem Global Campus! Beim Bouldern sitzt man auf der Matte nebeneinander und tüftelt gemeinsam an derselben Route („Beta teilen“). Wenn du 2–3 Mal zur gleichen Zeit (z. B. Mittwochabend oder Samstagnachmittag) gehst, kennst du sofort die Stammgruppe.",
    "socialTipsEn": "Located right inside Songdo Triple Street (Bldg D, B1) next to the Global Campus! Bouldering is naturally social because everyone sits on the mats sharing \"beta\" (route tips). Show up 2–3 times on Wednesday nights or Saturday afternoons and you’ll know the regulars.",
    "socialTipsKr": "송도 트리플스트리트 D동 지하 1층에 위치해 접근성이 최고입니다. 같은 볼더링 문제를 풀며 자연스럽게 대화가 시작됩니다.",
    "description": "Songdo’s premier indoor bouldering and sport climbing gym located inside Triple Street Mall (Building D, B1). Draws a vibrant mix of Yonsei/IGC international students and young Korean climbers in their 20s.",
    "descriptionDe": "Songdos modernste Boulder- und Kletterhalle mitten in der Triple Street Mall (Gebäude D, B1). Treffpunkt für Austauschstudenten vom benachbarten Global Campus und junge koreanische Kletterer.",
    "photoTips": "Dynamic bouldering send shots on colorful overhang walls inside Triple Street.",
    "photoTipsDe": "Action-Aufnahmen an den bunten Überhang-Boulderwänden mit farbigem Griff-Setting.",
    "bestTime": "Wed Evenings (19:30 - 22:00) & Sat Afternoons (15:00 - 18:00)",
    "bestTimeDe": "Mittwochabend (19:30 - 22:00) & Samstagnachmittag (15:00 - 18:00 Uhr)",
    "imageUrl": "https://images.unsplash.com/photo-1522163182402-834f871fd851?w=1000&auto=format&fit=crop&q=85",
    "subwayInfo": "Technopark Station (Incheon Line 1), Exit 2 (Walk through Triple Street to Building D, B1)",
    "feeInfo": "20,000 ~ 25,000 KRW Day Pass (Climbing shoe rental ~3,000 - 5,000 KRW)",
    "feeInfoDe": "20.000 ~ 25.000 KRW Tageskarte (Kletterschuh-Verleih ca. 3.000 - 5.000 KRW)",
    "tags": [
      "Bouldering",
      "Climbing",
      "Songdo",
      "Triple Street",
      "Incheon",
      "Alkoholfrei",
      "20s",
      "Must See"
    ],
    "eventDatesDe": "Jeden Mittwoch & Samstag im Oktober 2026",
    "eventDatesEn": "Every Wednesday & Saturday in October 2026",
    "eventDatesKr": "2026년 10월 매주 수요일 & 토요일",
    "upcomingSessions": [
      {
        "date": "2026-10-03",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 03. Okt 2026",
        "dateLabelEn": "Sat, Oct 3, 2026",
        "dateLabelKr": "10월 3일 (토)",
        "time": "15:00 KST",
        "titleDe": "🧗‍♂️ Climb Square Songdo – Saturday Student & Local Social Climb",
        "titleEn": "🧗‍♂️ Climb Square Songdo – Saturday Student & Local Social Climb",
        "rsvpUrl": "http://www.climbsquare.com/",
        "statusNoteDe": "Triple Street Bldg D, B1",
        "statusNoteEn": "Triple Street Bldg D, B1",
        "postUrl": "https://www.instagram.com/climbsquare_songdo/"
      },
      {
        "date": "2026-10-07",
        "dayNameDe": "Mittwoch",
        "dayNameEn": "Wednesday",
        "dayNameKr": "수요일",
        "dateLabelDe": "Mi, 07. Okt 2026",
        "dateLabelEn": "Wed, Oct 7, 2026",
        "dateLabelKr": "10월 7일 (수)",
        "time": "19:30 KST",
        "titleDe": "🧗 Climb Square Songdo – Wednesday Evening Bouldering & Beta Share",
        "titleEn": "🧗 Climb Square Songdo – Wednesday Evening Bouldering & Beta Share",
        "rsvpUrl": "http://www.climbsquare.com/",
        "statusNoteDe": "Triple Street Bldg D, B1",
        "statusNoteEn": "Triple Street Bldg D, B1",
        "postUrl": "https://www.instagram.com/climbsquare_songdo/"
      },
      {
        "date": "2026-10-10",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 10. Okt 2026",
        "dateLabelEn": "Sat, Oct 10, 2026",
        "dateLabelKr": "10월 10일 (토)",
        "time": "15:00 KST",
        "titleDe": "🧗‍♂️ Climb Square Songdo – Saturday Student & Local Social Climb",
        "titleEn": "🧗‍♂️ Climb Square Songdo – Saturday Student & Local Social Climb",
        "rsvpUrl": "http://www.climbsquare.com/",
        "statusNoteDe": "Triple Street Bldg D, B1",
        "statusNoteEn": "Triple Street Bldg D, B1",
        "postUrl": "https://www.instagram.com/climbsquare_songdo/"
      },
      {
        "date": "2026-10-14",
        "dayNameDe": "Mittwoch",
        "dayNameEn": "Wednesday",
        "dayNameKr": "수요일",
        "dateLabelDe": "Mi, 14. Okt 2026",
        "dateLabelEn": "Wed, Oct 14, 2026",
        "dateLabelKr": "10월 14일 (수)",
        "time": "19:30 KST",
        "titleDe": "🧗 Climb Square Songdo – Wednesday Evening Bouldering & Beta Share",
        "titleEn": "🧗 Climb Square Songdo – Wednesday Evening Bouldering & Beta Share",
        "rsvpUrl": "http://www.climbsquare.com/",
        "statusNoteDe": "Triple Street Bldg D, B1",
        "statusNoteEn": "Triple Street Bldg D, B1",
        "postUrl": "https://www.instagram.com/climbsquare_songdo/"
      },
      {
        "date": "2026-10-17",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 17. Okt 2026",
        "dateLabelEn": "Sat, Oct 17, 2026",
        "dateLabelKr": "10월 17일 (토)",
        "time": "15:00 KST",
        "titleDe": "🧗‍♂️ Climb Square Songdo – Saturday Student & Local Social Climb",
        "titleEn": "🧗‍♂️ Climb Square Songdo – Saturday Student & Local Social Climb",
        "rsvpUrl": "http://www.climbsquare.com/",
        "statusNoteDe": "Triple Street Bldg D, B1",
        "statusNoteEn": "Triple Street Bldg D, B1",
        "postUrl": "https://www.instagram.com/climbsquare_songdo/"
      },
      {
        "date": "2026-10-21",
        "dayNameDe": "Mittwoch",
        "dayNameEn": "Wednesday",
        "dayNameKr": "수요일",
        "dateLabelDe": "Mi, 21. Okt 2026",
        "dateLabelEn": "Wed, Oct 21, 2026",
        "dateLabelKr": "10월 21일 (수)",
        "time": "19:30 KST",
        "titleDe": "🧗 Climb Square Songdo – Wednesday Evening Bouldering & Beta Share",
        "titleEn": "🧗 Climb Square Songdo – Wednesday Evening Bouldering & Beta Share",
        "rsvpUrl": "http://www.climbsquare.com/",
        "statusNoteDe": "Triple Street Bldg D, B1",
        "statusNoteEn": "Triple Street Bldg D, B1",
        "postUrl": "https://www.instagram.com/climbsquare_songdo/"
      },
      {
        "date": "2026-10-24",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 24. Okt 2026",
        "dateLabelEn": "Sat, Oct 24, 2026",
        "dateLabelKr": "10월 24일 (토)",
        "time": "15:00 KST",
        "titleDe": "🧗‍♂️ Climb Square Songdo – Saturday Student & Local Social Climb",
        "titleEn": "🧗‍♂️ Climb Square Songdo – Saturday Student & Local Social Climb",
        "rsvpUrl": "http://www.climbsquare.com/",
        "statusNoteDe": "Triple Street Bldg D, B1",
        "statusNoteEn": "Triple Street Bldg D, B1",
        "postUrl": "https://www.instagram.com/climbsquare_songdo/"
      },
      {
        "date": "2026-10-28",
        "dayNameDe": "Mittwoch",
        "dayNameEn": "Wednesday",
        "dayNameKr": "수요일",
        "dateLabelDe": "Mi, 28. Okt 2026",
        "dateLabelEn": "Wed, Oct 28, 2026",
        "dateLabelKr": "10월 28일 (수)",
        "time": "19:30 KST",
        "titleDe": "🧗 Climb Square Songdo – Wednesday Evening Bouldering & Beta Share",
        "titleEn": "🧗 Climb Square Songdo – Wednesday Evening Bouldering & Beta Share",
        "rsvpUrl": "http://www.climbsquare.com/",
        "statusNoteDe": "Triple Street Bldg D, B1",
        "statusNoteEn": "Triple Street Bldg D, B1",
        "postUrl": "https://www.instagram.com/climbsquare_songdo/"
      },
      {
        "date": "2026-10-31",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 31. Okt 2026",
        "dateLabelEn": "Sat, Oct 31, 2026",
        "dateLabelKr": "10월 31일 (토)",
        "time": "15:00 KST",
        "titleDe": "🧗‍♂️ Climb Square Songdo – Saturday Student & Local Social Climb",
        "titleEn": "🧗‍♂️ Climb Square Songdo – Saturday Student & Local Social Climb",
        "rsvpUrl": "http://www.climbsquare.com/",
        "statusNoteDe": "Triple Street Bldg D, B1",
        "statusNoteEn": "Triple Street Bldg D, B1",
        "postUrl": "https://www.instagram.com/climbsquare_songdo/"
      }
    ]
  },
  {
    "id": "event-social-songdo-english-club",
    "name": "Songdo English Club – Central Park Artforet Conversation & Culture Meetup",
    "nameDe": "Songdo English Club – Artforet Central Park Englisch-Konversation & Community (Incheon)",
    "nameKr": "송도 잉글리시 클럽 – 센트럴파크 아트포레 프리토킹 & 글로벌 친구 모임",
    "category": "event_festival",
    "region": "Incheon",
    "district": "Yeonsu-gu (Songdo Central Park / Artforet)",
    "lat": 37.3934,
    "lng": 126.6348,
    "rating": 4.9,
    "reviewCount": 860,
    "isMustSee": true,
    "isEvent": true,
    "isIndoor": true,
    "eventType": "language_exchange",
    "organizer": "Songdo English Club",
    "websiteUrl": "https://www.meetup.com/songdo-english-club/",
    "eventUrl": "https://www.meetup.com/songdo-english-club/",
    "eventTime": "Jeden Samstag 14:00 – 16:00 Uhr (Space Haven, Artforet 3F)",
    "targetAudienceDe": "IGC-Studierende (SUNY, Utah, Ghent), Expats und Koreaner aus Songdo für entspannte Gespräche und echte Freundschaften",
    "targetAudienceEn": "IGC students (SUNY, Utah, Ghent), expats & local Koreans in Songdo looking for friendly English chats and real connections",
    "targetAudienceKr": "송도 IGC 외국인 유학생, 주재원 및 영어 회화와 친목을 원하는 송도 주민/대학생",
    "ageRecommendationDe": "🎯 Perfekt für 20–32 Jahre (Studenten & Young Professionals, Ø 23 Jahre)",
    "ageRecommendationEn": "🎯 Best for 20–32 yrs (Students & young pros, avg. 23 yrs)",
    "ageRecommendationKr": "🎯 20~30대 대학생 및 직장인 (평균 23세, 부담 없는 대화)",
    "socialTipsDe": "Der beste Ort in Songdo, um unkompliziert echte Kontakte zu knüpfen! Die Gruppen an den Tischen sind mit 3–5 Personen klein und überschaubar. Es gibt lockere Gesprächsthemen, sodass man nie nach Worten suchen muss. Nach dem Meetup geht man oft noch gemeinsam im Artforet einen Kaffee trinken oder spazieren. Frag am Ende einfach: ‚Hast du KakaoTalk? Lass uns mal wieder treffen!'",
    "socialTipsEn": "The easiest place in Songdo to make real friends! Small tables of 3-5 people with easy conversation prompts. No awkward silences, no alcohol. People often grab coffee or stroll Central Park together afterward.",
    "socialTipsKr": "센트럴파크역 아트포레 3층 스페이스 헤이븐에서 진행됩니다. 3~5명 소그룹으로 진행되어 내향적인 분도 부담 없이 참여 가능합니다.",
    "description": "Songdo's welcoming and active weekend English conversation community meeting at Space Haven inside the Artforet complex right by Central Park Station (Exit 2). Features small group tables (3-5 people) with guided discussion prompts covering culture, daily life, travel, and personal hobbies. Free admission and 100% alcohol-free.",
    "descriptionDe": "Songdos beliebteste Wochenend-Community für englische Konversation im Space Haven (Artforet, 3. Stock, direkt an der Central Park Station Ausgang 2). Kleine Gruppen von 3–5 Personen sprechen über Kultur, Hobbys und Reisen. Völlig kostenlos, alkoholfrei und ideal für Introvertierte, die in Incheon Freunde finden wollen.",
    "photoTips": "Cozy classroom lounge views and scenic modern canal architecture of Artforet and Central Park.",
    "photoTipsDe": "Helle, gemütliche Lounge-Atmosphäre im Space Haven mit Blick auf den Central-Park-Kanal.",
    "bestTime": "Saturday Afternoons (14:00 - 16:00)",
    "bestTimeDe": "Samstagnachmittag (14:00 - 16:00 Uhr)",
    "imageUrl": "/spots/incheon-songdo-central-park.jpg",
    "subwayInfo": "Central Park Station (Incheon Line 1) Exit 2 (Walk 2 min into Artforet Building, 3F Space Haven)",
    "feeInfo": "Free admission (Voluntary café beverage or light snack)",
    "feeInfoDe": "Kostenlose Teilnahme (Freiwillig Café-Getränk im Artforet)",
    "tags": [
      "Songdo",
      "Incheon",
      "English Club",
      "Central Park",
      "Artforet",
      "Language Exchange",
      "Alkoholfrei",
      "Solo Friendly",
      "Must See"
    ],
    "eventDatesDe": "Jeden Samstag im November & Dezember 2026",
    "eventDatesEn": "Every Saturday in November & December 2026",
    "eventDatesKr": "2026년 11월 & 12월 매주 토요일",
    "upcomingSessions": [
      {
        "date": "2026-11-07",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 07. Nov 2026",
        "dateLabelEn": "Sat, Nov 7, 2026",
        "dateLabelKr": "11월 7일 (토)",
        "time": "14:00 KST",
        "titleDe": "Songdo English Club – Weekend Conversation & New Connections",
        "titleEn": "Songdo English Club – Weekend Conversation & New Connections",
        "rsvpUrl": "https://www.meetup.com/songdo-english-club/",
        "statusNoteDe": "Space Haven (Artforet 3F)",
        "statusNoteEn": "Space Haven (Artforet 3F)"
      },
      {
        "date": "2026-11-14",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 14. Nov 2026",
        "dateLabelEn": "Sat, Nov 14, 2026",
        "dateLabelKr": "11월 14일 (토)",
        "time": "14:00 KST",
        "titleDe": "Songdo English Club – Small Group Free-Talking & Culture Exchange",
        "titleEn": "Songdo English Club – Small Group Free-Talking & Culture Exchange",
        "rsvpUrl": "https://www.meetup.com/songdo-english-club/",
        "statusNoteDe": "Space Haven (Artforet 3F)",
        "statusNoteEn": "Space Haven (Artforet 3F)"
      },
      {
        "date": "2026-11-21",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 21. Nov 2026",
        "dateLabelEn": "Sat, Nov 21, 2026",
        "dateLabelKr": "11월 21일 (토)",
        "time": "14:00 KST",
        "titleDe": "Songdo English Club – Weekend Conversation & New Connections",
        "titleEn": "Songdo English Club – Weekend Conversation & New Connections",
        "rsvpUrl": "https://www.meetup.com/songdo-english-club/",
        "statusNoteDe": "Space Haven (Artforet 3F)",
        "statusNoteEn": "Space Haven (Artforet 3F)"
      },
      {
        "date": "2026-11-28",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 28. Nov 2026",
        "dateLabelEn": "Sat, Nov 28, 2026",
        "dateLabelKr": "11월 28일 (토)",
        "time": "14:00 KST",
        "titleDe": "Songdo English Club – Small Group Free-Talking & Culture Exchange",
        "titleEn": "Songdo English Club – Small Group Free-Talking & Culture Exchange",
        "rsvpUrl": "https://www.meetup.com/songdo-english-club/",
        "statusNoteDe": "Space Haven (Artforet 3F)",
        "statusNoteEn": "Space Haven (Artforet 3F)"
      },
      {
        "date": "2026-12-05",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 05. Dez 2026",
        "dateLabelEn": "Sat, Dec 5, 2026",
        "dateLabelKr": "12월 5일 (토)",
        "time": "14:00 KST",
        "titleDe": "Songdo English Club – Winter Edition Warm Conversation",
        "titleEn": "Songdo English Club – Winter Edition Warm Conversation",
        "rsvpUrl": "https://www.meetup.com/songdo-english-club/",
        "statusNoteDe": "Space Haven (Artforet 3F)",
        "statusNoteEn": "Space Haven (Artforet 3F)"
      },
      {
        "date": "2026-12-12",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 12. Dez 2026",
        "dateLabelEn": "Sat, Dec 12, 2026",
        "dateLabelKr": "12월 12일 (토)",
        "time": "14:00 KST",
        "titleDe": "Songdo English Club – Weekend Conversation & New Connections",
        "titleEn": "Songdo English Club – Weekend Conversation & New Connections",
        "rsvpUrl": "https://www.meetup.com/songdo-english-club/",
        "statusNoteDe": "Space Haven (Artforet 3F)",
        "statusNoteEn": "Space Haven (Artforet 3F)"
      }
    ]
  },
  {
    "id": "event-social-seoul-lantern-winter-walk",
    "name": "Seoul Lantern Festival & Cheonggyecheon Winter Walk (서울빛초롱축제)",
    "nameDe": "Seoul Lantern Festival & Cheonggyecheon Abend-Walk & Wintermarkt (Alkoholfrei)",
    "nameKr": "서울빛초롱축제 & 청계천·광화문 야간 산책 & 크리스마스 마켓",
    "category": "event_festival",
    "region": "Seoul",
    "district": "Jongno-gu & Jung-gu (Cheonggye Plaza & Gwanghwamun Square)",
    "lat": 37.5694,
    "lng": 126.9778,
    "rating": 4.9,
    "reviewCount": 7850,
    "isMustSee": true,
    "isEvent": true,
    "eventType": "outdoor_social",
    "organizer": "Seoul Tourism Organization & Community Walkers (@seoul_lantern_festival)",
    "websiteUrl": "https://www.stolantern.macco.kr/",
    "instagramUrl": "https://www.instagram.com/seoul_lantern_festival/",
    "instagramTag": "서울빛초롱축제",
    "tiktokQuery": "Seoul Lantern Festival Cheonggyecheon winter walk",
    "eventUrl": "https://korean.visitseoul.net/",
    "eventTime": "Täglich ab 18:00 – 21:30 Uhr (04. Dez 2026 bis 31. Jan 2027)",
    "targetAudienceDe": "Expats, Reisende & Einheimische (20–30 Jahre), die abends bei heißem Yuzu-Tee und Bungeoppang entspannt im Freien spazieren und Freunde finden möchten",
    "targetAudienceEn": "Expats, solo travelers & locals (20–30 yrs) enjoying illuminated lanterns, hot winter snacks, and casual walk-and-talks",
    "targetAudienceKr": "청계천 한지 등불과 광화문 마켓을 감상하며 따뜻한 간식과 함께 산책하며 대화하는 무알콜 소셜 워크",
    "ageRecommendationDe": "🎯 Ideal für jedes Alter (Besonders 20–29 Jahre, 100% Alkoholfrei)",
    "ageRecommendationEn": "🎯 Great for all ages (Especially 20–29 yrs, 100% Alcohol-Free)",
    "ageRecommendationKr": "🎯 20대 청년/대학생 (평균 23세, 100% 무알콜 야간 산책)",
    "socialTipsDe": "Der psychologisch einfachste Weg für Introvertierte, neue Freunde zu finden: Nebeneinander hergehen nimmt jeglichen Druck des ständigen Augenkontakts. Gesprächspausen fühlen sich durch die faszinierenden Lichtinstallationen völlig harmonisch an. Triff dich mit 1–3 Leuten an der Cheonggye Plaza, schnappt euch heiße Bungeoppang (Waffeln) und schlendert gemeinsam den beleuchteten Bach hinab.",
    "socialTipsEn": "Walking side-by-side takes away the pressure of constant eye contact. Silence feels natural as you admire glowing Hanji lanterns. Meet at Cheonggye Plaza with warm street food and stroll together.",
    "socialTipsKr": "청계광장 소라탑 앞에서 만나 따뜻한 간식을 먹으며 청계천을 따라 걸으면 어색함 없이 깊은 대화를 나눌 수 있습니다.",
    "description": "Seoul’s signature winter celebration transforming Cheonggyecheon Stream and Gwanghwamun Square with hundreds of illuminated Hanji (traditional paper) lanterns, holiday LED light art, and the festive Gwanghwamun European-style winter market. Perfect for cozy walk-and-talks, warm winter snacks, and making friends in a tranquil outdoor setting without alcohol.",
    "descriptionDe": "Seouls berühmtestes Winterfestival: Hunderttausende Lichter und traditionelle Hanji-Papierlaternen verwandeln den Cheonggyecheon-Bach und den Gwanghwamun-Platz in ein magisches Winterwunderland. Perfekt für zwanglose Spaziergänge, heiße Waffeln und neue Freundschaften unter freiem Himmel – komplett alkoholfrei.",
    "photoTips": "Reflections of colorful glowing lanterns on the rippling stream water and Gwanghwamun market lights.",
    "photoTipsDe": "Leuchtende Hanji-Laternen spiegeln sich im fließenden Wasser des Cheonggyecheon mit King-Sejong-Statue im Hintergrund.",
    "bestTime": "Evenings (18:30 - 21:00)",
    "bestTimeDe": "Abends (18:30 - 21:00 Uhr)",
    "imageUrl": "/spots/seoul-cheonggyecheon.jpg",
    "subwayInfo": "Gwanghwamun Station (Line 5) Exit 5 (Walk 1 min to Cheonggye Plaza) / City Hall Station (Line 1/2) Exit 4",
    "feeInfo": "Free admission (Street snacks & hot drinks approx. 3,000 ~ 6,000 KRW)",
    "feeInfoDe": "Kostenloser Eintritt (Streetfood & Heißgetränke ca. 3.000 ~ 6.000 KRW)",
    "tags": [
      "Seoul Lantern Festival",
      "Cheonggyecheon",
      "Gwanghwamun",
      "Winter Market",
      "Outdoor Social",
      "Alkoholfrei",
      "Night View",
      "Solo Friendly",
      "Must See"
    ],
    "eventDatesDe": "04. Dezember 2026 bis 31. Januar 2027 (Täglich)",
    "eventDatesEn": "December 4, 2026 to January 31, 2027 (Daily)",
    "eventDatesKr": "2026년 12월 4일 ~ 2027년 1월 31일 (매일)",
    "upcomingSessions": [
      {
        "date": "2026-12-04",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 04. Dez 2026",
        "dateLabelEn": "Fri, Dec 4, 2026",
        "dateLabelKr": "12월 4일 (금)",
        "time": "18:30 KST",
        "titleDe": "✨ Seoul Lantern Festival 2026 – Grand Opening & Cheonggyecheon Night Walk",
        "titleEn": "✨ Seoul Lantern Festival 2026 – Grand Opening & Cheonggyecheon Night Walk",
        "rsvpUrl": "https://www.stolantern.macco.kr/",
        "statusNoteDe": "Cheonggye Plaza (Gwanghwamun Exit 5)",
        "statusNoteEn": "Cheonggye Plaza (Gwanghwamun Exit 5)",
        "postUrl": "https://www.instagram.com/seoul_lantern_festival/"
      },
      {
        "date": "2026-12-05",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 05. Dez 2026",
        "dateLabelEn": "Sat, Dec 5, 2026",
        "dateLabelKr": "12월 5일 (토)",
        "time": "18:30 KST",
        "titleDe": "Gwanghwamun Winter Market & Illuminated Stream Stroll",
        "titleEn": "Gwanghwamun Winter Market & Illuminated Stream Stroll",
        "rsvpUrl": "https://www.stolantern.macco.kr/",
        "statusNoteDe": "Gwanghwamun Square & Stream",
        "statusNoteEn": "Gwanghwamun Square & Stream",
        "postUrl": "https://www.instagram.com/seoul_lantern_festival/"
      },
      {
        "date": "2026-12-11",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 11. Dez 2026",
        "dateLabelEn": "Fri, Dec 11, 2026",
        "dateLabelKr": "12월 11일 (금)",
        "time": "18:30 KST",
        "titleDe": "Cheonggyecheon Friday Night Lantern Walk & Hot Bungeoppang Chat",
        "titleEn": "Cheonggyecheon Friday Night Lantern Walk & Hot Bungeoppang Chat",
        "rsvpUrl": "https://www.stolantern.macco.kr/",
        "statusNoteDe": "Cheonggye Plaza",
        "statusNoteEn": "Cheonggye Plaza",
        "postUrl": "https://www.instagram.com/seoul_lantern_festival/"
      },
      {
        "date": "2026-12-18",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 18. Dez 2026",
        "dateLabelEn": "Fri, Dec 18, 2026",
        "dateLabelKr": "12월 18일 (금)",
        "time": "18:30 KST",
        "titleDe": "Holiday Lights & Hanji Sculpture Evening Walk",
        "titleEn": "Holiday Lights & Hanji Sculpture Evening Walk",
        "rsvpUrl": "https://www.stolantern.macco.kr/",
        "statusNoteDe": "Cheonggye Plaza to Samilgyo",
        "statusNoteEn": "Cheonggye Plaza to Samilgyo",
        "postUrl": "https://www.instagram.com/seoul_lantern_festival/"
      }
    ]
  },
  {
    "id": "event-social-bbb-gangnam-boardgames",
    "name": "{BBB} Board, Bluff, & Banter! – Gangnam Social Games & Icebreaker Lounge",
    "nameDe": "{BBB} Board, Bluff & Banter – Gangnam Social Games & Icebreaker-Spiele (Alkoholfrei)",
    "nameKr": "{BBB} 보드 블러프 앤 밴터 – 강남 소셜 보드게임 & 마피아 라운지 (마피아카페)",
    "category": "event_festival",
    "region": "Seoul",
    "district": "Gangnam-gu (Gangnam Station Exit 11 / Gangnam-daero 96-gil 19)",
    "lat": 37.4998,
    "lng": 127.0278,
    "rating": 4.9,
    "reviewCount": 1840,
    "isMustSee": true,
    "isEvent": true,
    "isIndoor": true,
    "eventType": "party_mixer",
    "organizer": "Board, Bluff, & Banter! Community (@boardbluffbanter)",
    "websiteUrl": "https://www.meetup.com/board-bluff-and-banter/",
    "instagramUrl": "https://www.instagram.com/boardbluffbanter/",
    "instagramTag": "마피아카페강남",
    "tiktokQuery": "Board Bluff Banter Gangnam board game meetup Seoul",
    "eventUrl": "https://www.meetup.com/board-bluff-and-banter/",
    "eventTime": "Mittwoch 19:30 – 22:30 Uhr & Samstag 14:30 – 18:00 Uhr (+ Abendessen)",
    "targetAudienceDe": "Expats, Studierende und aufgeschlossene Koreaner (20–30 Jahre), die durch Partyspiele ohne Alkoholzwang echte Freunde finden wollen",
    "targetAudienceEn": "Expats, university students & open-minded locals (20–30 yrs) looking for authentic connections through social games with zero alcohol pressure",
    "targetAudienceKr": "외국인 유학생, 직장인, 20대 한국인이 마피아·코드네임 등 소셜 게임을 즐기며 친구를 사귀는 건전한 모임",
    "ageRecommendationDe": "🎯 Perfekt für 20–29 Jahre (Ø 23 Jahre, ideal gegen soziale Schüchternheit)",
    "ageRecommendationEn": "🎯 Best for 20–29 yrs (avg. 23 yrs, ideal for introverts wanting fun interaction)",
    "ageRecommendationKr": "🎯 20대 청년/대학생 집중 모임 (평균 23세, 부담 없는 게임 소셜)",
    "socialTipsDe": "Der absolute Geheimtipp für Introvertierte: Das Spiel übernimmt die Gesprächsführung! Niemand muss mühsam über das Wetter reden – durch Spiele wie Codenames, Avalon, Telestrations oder Mafia lacht und neckt man sich sofort ab Minute eins. Findet im Gangnam Mafia Cafe (4. OG) statt. Nach der Spielrunde gehen meistens 4–6 Leute zusammen unkompliziert essen – der ideale Moment, um Nummern oder KakaoTalk zu tauschen!",
    "socialTipsEn": "The best icebreaker for introverts: the game drives the conversation! No awkward smalltalk needed. Games like Codenames, Avalon, and Telestrations spark instant laughter. Held at Gangnam Mafia Cafe (4F). Groups usually grab casual dinner together afterward.",
    "socialTipsKr": "게임 룰 안에서 자연스럽게 대화가 오가므로 어색함이 전혀 없습니다. 모임 후 가볍게 저녁 식사를 함께하며 친해집니다.",
    "description": "Seoul’s premier international social gaming meetup meeting twice weekly in Gangnam (Mafia Cafe 4F). Focused on light-hearted party and social deduction games (Codenames, Avalon, Secret Hitler, Telestrations, Dixit) that spark genuine interaction, laughter, and lasting friendships without alcohol.",
    "descriptionDe": "Seouls beliebtestes internationales Social-Gaming-Meetup in Gangnam (Gangnam Mafia Cafe, 4. Stock). Fokus auf unterhaltsame Partyspiele und Deduktionsspiele (Codenames, Avalon, Telestrations, Dixit), die für herzhaftes Lachen und echten Austausch sorgen – ganz ohne Alkohol.",
    "photoTips": "Cozy game cafe room with energetic players pointing and laughing around colorful card decks.",
    "photoTipsDe": "Lebhafte Spielrunden mit Spielkarten, Markern und lachenden Gesichtern im gemütlichen Café-Raum.",
    "bestTime": "Wed Evenings (19:30 - 22:30) & Sat Afternoons (14:30 - 18:00)",
    "bestTimeDe": "Mittwochabend (19:30 - 22:30) & Samstagnachmittag (14:30 - 18:00 Uhr)",
    "imageUrl": "/spots/event-social-gangnam-mafia-cafe.jpg",
    "subwayInfo": "Gangnam Station (Line 2 / Sinbundang) Exit 11 (Walk 3 min to Gangnam-daero 96-gil 19, 4F)",
    "feeInfo": "10,000 ~ 12,000 KRW (Includes venue fee + 1 cafe beverage: iced tea, americano, fruit juice)",
    "feeInfoDe": "10.000 ~ 12.000 KRW (inkl. Café-Eintritt + 1 Getränk nach Wahl: Eistee, Kaffee, Saft)",
    "tags": [
      "Board Games",
      "Gangnam",
      "Party Games",
      "Social Games",
      "Alkoholfrei",
      "Solo Friendly",
      "20s",
      "Must See"
    ],
    "eventDatesDe": "Jeden Mittwoch & Samstag im November & Dezember 2026",
    "eventDatesEn": "Every Wednesday & Saturday in November & December 2026",
    "eventDatesKr": "2026년 11월 & 12월 매주 수요일 & 토요일",
    "upcomingSessions": [
      {
        "date": "2026-11-04",
        "dayNameDe": "Mittwoch",
        "dayNameEn": "Wednesday",
        "dayNameKr": "수요일",
        "dateLabelDe": "Mi, 04. Nov 2026",
        "dateLabelEn": "Wed, Nov 4, 2026",
        "dateLabelKr": "11월 4일 (수)",
        "time": "19:30 KST",
        "titleDe": "{BBB} Midweek Social Games & Mafia Night Gangnam",
        "titleEn": "{BBB} Midweek Social Games & Mafia Night Gangnam",
        "rsvpUrl": "https://www.meetup.com/board-bluff-and-banter/",
        "statusNoteDe": "Gangnam Mafia Cafe (4F)",
        "statusNoteEn": "Gangnam Mafia Cafe (4F)"
      },
      {
        "date": "2026-11-07",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 07. Nov 2026",
        "dateLabelEn": "Sat, Nov 7, 2026",
        "dateLabelKr": "11월 7일 (토)",
        "time": "14:30 KST",
        "titleDe": "{BBB} Saturday Social Games, Codenames & Dinner Hangout",
        "titleEn": "{BBB} Saturday Social Games, Codenames & Dinner Hangout",
        "rsvpUrl": "https://www.meetup.com/board-bluff-and-banter/",
        "statusNoteDe": "Gangnam Mafia Cafe (4F)",
        "statusNoteEn": "Gangnam Mafia Cafe (4F)"
      },
      {
        "date": "2026-11-14",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 14. Nov 2026",
        "dateLabelEn": "Sat, Nov 14, 2026",
        "dateLabelKr": "11월 14일 (토)",
        "time": "14:30 KST",
        "titleDe": "{BBB} Saturday Social Games, Codenames & Dinner Hangout",
        "titleEn": "{BBB} Saturday Social Games, Codenames & Dinner Hangout",
        "rsvpUrl": "https://www.meetup.com/board-bluff-and-banter/",
        "statusNoteDe": "Gangnam Mafia Cafe (4F)",
        "statusNoteEn": "Gangnam Mafia Cafe (4F)"
      },
      {
        "date": "2026-11-21",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 21. Nov 2026",
        "dateLabelEn": "Sat, Nov 21, 2026",
        "dateLabelKr": "11월 21일 (토)",
        "time": "14:30 KST",
        "titleDe": "{BBB} Saturday Social Games, Codenames & Dinner Hangout",
        "titleEn": "{BBB} Saturday Social Games, Codenames & Dinner Hangout",
        "rsvpUrl": "https://www.meetup.com/board-bluff-and-banter/",
        "statusNoteDe": "Gangnam Mafia Cafe (4F)",
        "statusNoteEn": "Gangnam Mafia Cafe (4F)"
      },
      {
        "date": "2026-12-05",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 05. Dez 2026",
        "dateLabelEn": "Sat, Dec 5, 2026",
        "dateLabelKr": "12월 5일 (토)",
        "time": "14:30 KST",
        "titleDe": "{BBB} Winter Social Games & Avalon Party in Gangnam",
        "titleEn": "{BBB} Winter Social Games & Avalon Party in Gangnam",
        "rsvpUrl": "https://www.meetup.com/board-bluff-and-banter/",
        "statusNoteDe": "Gangnam Mafia Cafe (4F)",
        "statusNoteEn": "Gangnam Mafia Cafe (4F)"
      }
    ]
  },
  {
    "id": "event-social-ome-cooking-social",
    "name": "OME Cooking Lab – K-Food Traditional Market Tour & Hanok Cooking Social",
    "nameDe": "OME Cooking Lab – K-Food Markttour, Hanok-Kochen & Family-Style Dinner (Dongdaemun)",
    "nameKr": "오미요리연구소 – 제기동 한옥 쿠킹클래스 & 경동시장 투어 & 소셜 다이닝",
    "category": "event_festival",
    "region": "Seoul",
    "district": "Dongdaemun-gu (Yangnyeongsi-ro 97-1 / Jegidong Station)",
    "lat": 37.5802,
    "lng": 127.0392,
    "rating": 4.95,
    "reviewCount": 2450,
    "isMustSee": true,
    "isEvent": true,
    "isIndoor": true,
    "eventType": "cultural_festival",
    "organizer": "OME Cooking Lab (@omecookinglab)",
    "websiteUrl": "https://www.5-tastes.com/",
    "instagramUrl": "https://www.instagram.com/omecookinglab/",
    "instagramTag": "오미요리연구소",
    "tiktokQuery": "OME cooking lab Seoul market tour Hanok cooking",
    "eventUrl": "https://www.5-tastes.com/",
    "eventTime": "Mo bis Sa: 10:00 – 13:00 Uhr (Morning Market Session) & 14:00 – 17:00 Uhr",
    "targetAudienceDe": "Solo-Reisende, Expats & junge Kulturinteressierte (20–35 Jahre), die in kleiner Runde (4–8 Personen) gemeinsam Kochen und Freunde finden möchten",
    "targetAudienceEn": "Solo travelers, expats & young culture enthusiasts (20–35 yrs) seeking authentic connections through hands-on cooking in small groups",
    "targetAudienceKr": "전통시장에서 식재료를 함께 장보고 한옥에서 요리하며 자연스럽게 교류하는 소셜 쿠킹 프로그램",
    "ageRecommendationDe": "🎯 Ideal für 20–35 Jahre (Ø 24 Jahre, 100% Alkoholfrei)",
    "ageRecommendationEn": "🎯 Ideal for 20–35 yrs (avg. 24 yrs, 100% Alcohol-Free)",
    "ageRecommendationKr": "🎯 20~30대 글로벌 청년/여행객 (평균 24세, 따뜻한 한옥 식사)",
    "socialTipsDe": "Kochen verbindet wie nichts anderes: Da deine Hände beim Zerkleinern, Anbraten und Würzen beschäftigt sind, entsteht nie die typische peinliche Stille. Man hilft sich gegenseitig mit Pfannen und Gewürzen und schlendert vorher gemeinsam über den quirligen Gyeongdong-Markt. Zum Abschluss sitzt man gemeinsam an einer großen Tafel in einem warmen Hanok und genießt das frisch zubereitete Essen bei heißem Tee. Extrem herzliche Atmosphäre!",
    "socialTipsEn": "Cooking together eliminates awkward silences because your hands are always busy. Stroll through vibrant Gyeongdong Market together, cook side-by-side in a cozy Hanok, and enjoy a family-style meal with warm tea.",
    "socialTipsKr": "시장에서 함께 재료를 고르고 요리하며 식사까지 이어져 대화가 끊이지 않는 따뜻하고 자연스러운 소셜 모임입니다.",
    "description": "An intimate, hands-on cultural cooking experience in Dongdaemun. Begins with a guided exploration of historic Gyeongdong and Seoul Yangnyeongsi herbal markets to pick fresh local ingredients, followed by step-by-step Korean cooking inside a traditional Hanok house. Ends with a shared family-style meal, warm tea, and meaningful conversation in small groups (4-8 people). 100% alcohol-free.",
    "descriptionDe": "Ein persönliches, herzliches Koch- und Kennenlern-Event in Dongdaemun. Beginnt mit einem geführten Spaziergang über den traditionellen Gyeongdong-Kräuter- und Lebensmittelmarkt, gefolgt von gemeinsamen Kochen koreanischer Klassiker in einer gemütlichen Hanok-Küche. Anschließend wird gemeinsam an einem großen Holztisch gegessen – 100% alkoholfrei.",
    "photoTips": "Warm Hanok wooden kitchen, colorful traditional market ingredients, and freshly plated Korean dishes.",
    "photoTipsDe": "Gemütliches Hanok-Ambiente mit Holzstreben, dampfenden Töpfen und herrlich angerichteten koreanischen Tellern.",
    "bestTime": "Morning Sessions (10:00 - 13:00) & Afternoon (14:00 - 17:00)",
    "bestTimeDe": "Vormittags (10:00 - 13:00) & Nachmittags (14:00 - 17:00 Uhr)",
    "imageUrl": "/spots/event-social-ome-cooking-lab.jpg",
    "subwayInfo": "Jegidong Station (Line 1) Exit 2 (Meeting spot right in front of Exit 2, 97-1 Yangnyeongsi-ro)",
    "feeInfo": "55,000 ~ 65,000 KRW (Includes guided market tour, all ingredients, cooking class, full 3-course warm meal & dessert tea)",
    "feeInfoDe": "55.000 ~ 65.000 KRW (inkl. Markttour, alle Zutaten, Kochkurs, komplettes warmes 3-Gänge-Essen & Dessert-Tee)",
    "tags": [
      "Cooking Class",
      "Dongdaemun",
      "Hanok",
      "Market Tour",
      "K-Food",
      "Alkoholfrei",
      "Solo Friendly",
      "Must See"
    ],
    "eventDatesDe": "Montag bis Samstag im November & Dezember 2026",
    "eventDatesEn": "Every Monday to Saturday in November & December 2026",
    "eventDatesKr": "2026년 11월 & 12월 월~토요일 상시 운영",
    "upcomingSessions": [
      {
        "date": "2026-11-06",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 06. Nov 2026",
        "dateLabelEn": "Fri, Nov 6, 2026",
        "dateLabelKr": "11월 6일 (금)",
        "time": "10:00 KST",
        "titleDe": "Gyeongdong Market Tour & Hanok Home-Cook Social Lunch",
        "titleEn": "Gyeongdong Market Tour & Hanok Home-Cook Social Lunch",
        "rsvpUrl": "https://www.5-tastes.com/",
        "statusNoteDe": "Jegidong Station Exit 2",
        "statusNoteEn": "Jegidong Station Exit 2",
        "postUrl": "https://www.instagram.com/omecookinglab/"
      },
      {
        "date": "2026-11-13",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 13. Nov 2026",
        "dateLabelEn": "Fri, Nov 13, 2026",
        "dateLabelKr": "11월 13일 (금)",
        "time": "10:00 KST",
        "titleDe": "Gyeongdong Market Tour & Hanok Home-Cook Social Lunch",
        "titleEn": "Gyeongdong Market Tour & Hanok Home-Cook Social Lunch",
        "rsvpUrl": "https://www.5-tastes.com/",
        "statusNoteDe": "Jegidong Station Exit 2",
        "statusNoteEn": "Jegidong Station Exit 2",
        "postUrl": "https://www.instagram.com/omecookinglab/"
      },
      {
        "date": "2026-11-20",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 20. Nov 2026",
        "dateLabelEn": "Fri, Nov 20, 2026",
        "dateLabelKr": "11월 20일 (금)",
        "time": "10:00 KST",
        "titleDe": "Gyeongdong Market Tour & Hanok Home-Cook Social Lunch",
        "titleEn": "Gyeongdong Market Tour & Hanok Home-Cook Social Lunch",
        "rsvpUrl": "https://www.5-tastes.com/",
        "statusNoteDe": "Jegidong Station Exit 2",
        "statusNoteEn": "Jegidong Station Exit 2",
        "postUrl": "https://www.instagram.com/omecookinglab/"
      },
      {
        "date": "2026-12-04",
        "dayNameDe": "Freitag",
        "dayNameEn": "Friday",
        "dayNameKr": "금요일",
        "dateLabelDe": "Fr, 04. Dez 2026",
        "dateLabelEn": "Fri, Dec 4, 2026",
        "dateLabelKr": "12월 4일 (금)",
        "time": "10:00 KST",
        "titleDe": "Winter Warm Comfort Food Cooking & Market Walk",
        "titleEn": "Winter Warm Comfort Food Cooking & Market Walk",
        "rsvpUrl": "https://www.5-tastes.com/",
        "statusNoteDe": "Jegidong Station Exit 2",
        "statusNoteEn": "Jegidong Station Exit 2",
        "postUrl": "https://www.instagram.com/omecookinglab/"
      }
    ]
  },
  {
    "id": "event-social-seoul-boulder-club-the-climb",
    "name": "Seoul Boulder Club – The Climb Hongdae/Yeonnam Weekend Social Session",
    "nameDe": "Seoul Boulder Club – The Climb Bouldern & Social Hangout (Hongdae / Yeonnam)",
    "nameKr": "서울 볼더 클럽 – 더클라임 연남/홍대점 주말 소셜 볼더링 & 외국인 친목 모임",
    "category": "event_festival",
    "region": "Seoul",
    "district": "Mapo-gu (Hongdae / Yeonnam-dong)",
    "lat": 37.5585,
    "lng": 126.9255,
    "rating": 4.9,
    "reviewCount": 1620,
    "isMustSee": true,
    "isEvent": true,
    "isIndoor": true,
    "eventType": "outdoor_social",
    "organizer": "Seoul Boulder Club (@seoulboulderclub)",
    "websiteUrl": "https://www.meetup.com/seoul-boulder-club/",
    "instagramUrl": "https://www.instagram.com/seoulboulderclub/",
    "instagramTag": "더클라임연남",
    "tiktokQuery": "Seoul boulder club The Climb Hongdae bouldering",
    "eventUrl": "https://www.meetup.com/seoul-boulder-club/",
    "eventTime": "Jeden Samstag 14:00 – 17:00 Uhr (+ unkompliziertes Essen danach)",
    "targetAudienceDe": "Internationale Expats, Studierende & junge Koreaner (20–30 Jahre) aller Kletterlevel – vom absoluten Anfänger bis zum Fortgeschrittenen",
    "targetAudienceEn": "International expats, exchange students & young locals (20–30 yrs) of all climbing skill levels from beginner to advanced",
    "targetAudienceKr": "초보자부터 숙련자까지 함께 벽을 오르고 팁을 나누며 친해지는 글로벌 볼더링 커뮤니티",
    "ageRecommendationDe": "🎯 Perfekt für 20–29 Jahre (Ø 23 Jahre, 100% aktiv & nüchtern)",
    "ageRecommendationEn": "🎯 Best for 20–29 yrs (avg. 23 yrs, 100% active & sober)",
    "ageRecommendationKr": "🎯 20대 청년/대학생/직장인 (평균 23세, 활기찬 주말 친목)",
    "socialTipsDe": "Bouldern ist die kontaktfreudigste Sportart überhaupt: Man klettert 60 Sekunden, sitzt dann auf der dicken Weichbodenmatte und bespricht mit den anderen, wie man den nächsten Griff am besten erwischt („Beta teilen“). Wenn du neu bist, sag einfach: ‚Hey, what grade are you working on? Any tips for this one?' – schon bist du im Gespräch. Nach der Session geht die Gruppe meist noch gemeinsam Snacks oder Smoothies holen.",
    "socialTipsEn": "Bouldering is the most social sport in Seoul: climb for 1 min, sit on the mats for 4 min discussing routes (\"sharing beta\"). Everyone is welcoming to beginners. Just ask for route advice and you have an instant conversation.",
    "socialTipsKr": "매트 위에 앉아 함께 루트를 고민하며 '파이팅!'을 외치다 보면 자연스럽게 친구가 됩니다. 모임 후 가벼운 간식을 함께합니다.",
    "description": "Seoul’s premier English-speaking bouldering and climbing community hosting weekly Saturday afternoon social sessions at The Climb (Yeonnam / Hongdae branch). Complete beginners are warmly welcomed with route tips and technique guidance. 100% sober, athletic, and friendly.",
    "descriptionDe": "Seouls beliebteste englischsprachige Boulder-Community mit wöchentlichen Treffen am Samstagnachmittag bei The Climb (Filiale Yeonnam / Hongdae). Anfänger werden mit offenen Armen empfangen und bekommen Tipps für die ersten Griffe. Komplett nüchtern, sportlich und extrem herzlich.",
    "photoTips": "Bright high-ceiling modern climbing hall with colorful holds, chalk bags, and group high-fives.",
    "photoTipsDe": "Moderne, weitläufige Kletterhalle mit bunten Griffen, Kreidestaub und begeisterten Kletterern an der Überhangwand.",
    "bestTime": "Saturday Afternoons (14:00 - 17:00)",
    "bestTimeDe": "Samstagnachmittag (14:00 - 17:00 Uhr)",
    "imageUrl": "/spots/activity-seoul-the-climb-hongdae.jpg",
    "subwayInfo": "Hongik Univ. Station (Line 2 / AREX / Gyeongui-Jungang) Exit 3 (Walk 4 min to The Climb Yeonnam)",
    "feeInfo": "20,000 ~ 22,000 KRW Day Pass (Shoe rental ~3,000 KRW)",
    "feeInfoDe": "20.000 ~ 22.000 KRW Tageskarte (Kletterschuhe-Leihgebühr ca. 3.000 KRW)",
    "tags": [
      "Bouldering",
      "Hongdae",
      "Yeonnam",
      "The Climb",
      "Active Social",
      "Alkoholfrei",
      "20s",
      "Solo Friendly",
      "Must See"
    ],
    "eventDatesDe": "Jeden Samstag im November & Dezember 2026",
    "eventDatesEn": "Every Saturday in November & December 2026",
    "eventDatesKr": "2026년 11월 & 12월 매주 토요일",
    "upcomingSessions": [
      {
        "date": "2026-11-07",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 07. Nov 2026",
        "dateLabelEn": "Sat, Nov 7, 2026",
        "dateLabelKr": "11월 7일 (토)",
        "time": "14:00 KST",
        "titleDe": "🧗 Seoul Boulder Club – Saturday Social Climb & Route Sharing",
        "titleEn": "🧗 Seoul Boulder Club – Saturday Social Climb & Route Sharing",
        "rsvpUrl": "https://www.meetup.com/seoul-boulder-club/",
        "statusNoteDe": "The Climb Yeonnam / Hongdae",
        "statusNoteEn": "The Climb Yeonnam / Hongdae",
        "postUrl": "https://www.instagram.com/seoulboulderclub/"
      },
      {
        "date": "2026-11-14",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 14. Nov 2026",
        "dateLabelEn": "Sat, Nov 14, 2026",
        "dateLabelKr": "11월 14일 (토)",
        "time": "14:00 KST",
        "titleDe": "🧗 Seoul Boulder Club – Saturday Social Climb & Route Sharing",
        "titleEn": "🧗 Seoul Boulder Club – Saturday Social Climb & Route Sharing",
        "rsvpUrl": "https://www.meetup.com/seoul-boulder-club/",
        "statusNoteDe": "The Climb Yeonnam / Hongdae",
        "statusNoteEn": "The Climb Yeonnam / Hongdae",
        "postUrl": "https://www.instagram.com/seoulboulderclub/"
      },
      {
        "date": "2026-11-21",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 21. Nov 2026",
        "dateLabelEn": "Sat, Nov 21, 2026",
        "dateLabelKr": "11월 21일 (토)",
        "time": "14:00 KST",
        "titleDe": "🧗 Seoul Boulder Club – Saturday Social Climb & Route Sharing",
        "titleEn": "🧗 Seoul Boulder Club – Saturday Social Climb & Route Sharing",
        "rsvpUrl": "https://www.meetup.com/seoul-boulder-club/",
        "statusNoteDe": "The Climb Yeonnam / Hongdae",
        "statusNoteEn": "The Climb Yeonnam / Hongdae",
        "postUrl": "https://www.instagram.com/seoulboulderclub/"
      },
      {
        "date": "2026-12-05",
        "dayNameDe": "Samstag",
        "dayNameEn": "Saturday",
        "dayNameKr": "토요일",
        "dateLabelDe": "Sa, 05. Dez 2026",
        "dateLabelEn": "Sat, Dec 5, 2026",
        "dateLabelKr": "12월 5일 (토)",
        "time": "14:00 KST",
        "titleDe": "🧗 Seoul Boulder Club – Winter Kickoff Social Session",
        "titleEn": "🧗 Seoul Boulder Club – Winter Kickoff Social Session",
        "rsvpUrl": "https://www.meetup.com/seoul-boulder-club/",
        "statusNoteDe": "The Climb Yeonnam / Hongdae",
        "statusNoteEn": "The Climb Yeonnam / Hongdae",
        "postUrl": "https://www.instagram.com/seoulboulderclub/"
      }
    ]
  }
];
